(function(){
// ── NT CHIP EDITOR v6 build 20260523-C ──────────────────
window._ntBuildId='20260601-A';
console.log('[NukkadTales] Chip editor loaded, build',window._ntBuildId);
// ── ICON COLOR FILTER ──────────────────────────────────
function ntIconFilter(hex){
  if(!hex||hex.length<7)hex='#3d2b1a';
  var fid='ntIcF'+hex.replace('#','');
  if(!document.getElementById(fid)){
    var ns='http://www.w3.org/2000/svg';
    var defsEl=document.getElementById('ntIconFDefs');
    if(!defsEl){
      var svgEl=document.createElementNS(ns,'svg');
      svgEl.id='ntIconFDefs';
      svgEl.style.cssText='width:0;height:0;position:absolute;overflow:hidden;pointer-events:none;';
      var dEl=document.createElementNS(ns,'defs');
      svgEl.appendChild(dEl);
      document.body.appendChild(svgEl);
      defsEl=dEl;
    }
    var fEl=document.createElementNS(ns,'filter');
    fEl.id=fid;
    fEl.setAttribute('color-interpolation-filters','sRGB');
    fEl.setAttribute('x','-20%');fEl.setAttribute('y','-20%');
    fEl.setAttribute('width','140%');fEl.setAttribute('height','140%');
    var flood=document.createElementNS(ns,'feFlood');
    flood.setAttribute('flood-color',hex);
    flood.setAttribute('flood-opacity','1');
    flood.setAttribute('result','colour');
    var comp=document.createElementNS(ns,'feComposite');
    comp.setAttribute('in','colour');
    comp.setAttribute('in2','SourceGraphic');
    comp.setAttribute('operator','in');
    fEl.appendChild(flood);
    fEl.appendChild(comp);
    defsEl.appendChild(fEl);
  }
  // Add drop-shadow as outline using the same colour at reduced opacity
  var r=parseInt(hex.slice(1,3),16);
  var g=parseInt(hex.slice(3,5),16);
  var b=parseInt(hex.slice(5,7),16);
  var shadowClr='rgba('+r+','+g+','+b+',0.9)';
  return 'url(#'+fid+')';
}

// Convert a catalog product title to lines array for ntMakeAiCard
function titleToLines(title){
  if(!title) return [''];
  // Split on ' & ', ' / ', or spaces — connectors stay as own line
  const words = title.trim().split(/\s+/);
  if(words.length <= 4) return words;
  // For longer titles, group into max 4 lines of max 3 words each
  const lines = [];
  for(let i=0; i<words.length && lines.length<4; i+=2){
    lines.push(words.slice(i, Math.min(i+2, words.length)).join(' '));
  }
  return lines;
}

async function callCatalogSearch(query){
  const res = await fetch(CATALOG_PROXY_URL, {
    method: 'POST',
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({ query })
  });
  if(!res.ok) throw new Error(`Catalog proxy HTTP ${res.status}`);
  const data = await res.json();
  if(data.error){
    console.error('[NukkadCatalog] Proxy error:', data.error, data);
    throw new Error(data.error);
  }
  const raw = data.content?.filter(b=>b.type==='text').map(b=>b.text).join('') || '[]';
  const match = raw.match(/\[[\s\S]*\]/);
  if(!match) throw new Error('No JSON from catalog search');
  const products = JSON.parse(match[0]);
  // Convert catalog products to ntMakeAiCard format — return all, display layer paginates
  return products.map(p => ({
    lines: titleToLines(p.title),
    type: 'quote',
    price: 999,
    inch: 8,
    src: '',
    handle: p.handle,
    tagline: p.tagline || p.catalog_tagline || ''
  }));
}

// ── SEARCH SYSTEM PROMPT ──────────────────────────────
async function callStockSearchAI(query){
  // First try Gemini proxy (semantic, cached)
  try {
    const res=await fetch(CATALOG_PROXY_URL,{
      method:'POST', headers:{'Content-Type':'application/json'},
      body:JSON.stringify({query})
    });
    if(!res.ok) throw new Error(`Gemini HTTP ${res.status}`);
    const data=await res.json();
    console.log('[NukkadStock] Gemini response keys:', Object.keys(data), '| error:', data.error||'none');
    if(data.error) throw new Error('Gemini: '+data.error);
    // Proxy returns {content:[{type:'text',text:'[{handle,...}]'}]}
    const raw = data.content?.find(b=>b.type==='text')?.text || data.text || '';
    console.log('[NukkadStock] Gemini data keys:', Object.keys(data));
    console.log('[NukkadStock] Gemini content:', JSON.stringify(data.content||'MISSING').slice(0,200));
    console.log('[NukkadStock] Gemini raw preview:', (raw||'EMPTY').slice(0,200));
    if(!raw) throw new Error('Gemini empty result');
    // Strip markdown fences first, then parse
    const cleaned = raw.replace(/```json|```/g,'').replace(/[\u0000-\u001F\u007F]/g,' ').replace(/,(\s*[}\]])/g,'$1').trim();
    if(cleaned==='[]'||cleaned==='') throw new Error('Gemini empty result');
    let products;
    try {
      products = JSON.parse(cleaned);
      if(!Array.isArray(products)) throw new Error('not array');
    } catch(_){
      const match = cleaned.match(/\[[\s\S]*\]/);
      if(!match) throw new Error('Gemini no JSON array');
      products = JSON.parse(match[0]);
    }
    const handles=products.map(p=>p.handle).filter(Boolean).slice(0,12); // fetch 12, some will 404
    if(!handles.length) throw new Error('Gemini 0 handles');
    console.log('[NukkadStock] Gemini handles (top 12):', handles);
    const shopifyProducts=await fetchShopifyProducts(handles);
    if(!shopifyProducts.length) throw new Error('All Shopify fetches 404 — handles mismatch');
    return shopifyProducts;
  } catch(geminiErr){
    console.warn('[NukkadStock] Gemini failed:', geminiErr.message);
  }

  // Fallback: Haiku reads catalog JSON and picks best handles
  const catalogRes=await fetch('https://cdn.shopify.com/s/files/1/0777/5636/7123/files/nukkad-catalog.json');
  if(!catalogRes.ok) throw new Error('Catalog fetch failed');
  const catalog=await catalogRes.json();

  // Sort by bestseller score, take top 80, compress — catalog uses p.h/p.t not p.handle/p.title
  const sorted=catalog.sort((a,b)=>((b.bs||b.bestseller_score||0)-(a.bs||a.bestseller_score||0)));
  const compressed=sorted.slice(0,80).map(p=>`${p.h||p.handle||''}|${p.t||p.title||''}|${p.v||p.vibe||''}|${(p.who_p||p.for_personal||'').slice(0,30)}|${(p.occ||p.occasions||[]).slice(0,3).join(',')}`).filter(l=>l.startsWith('|')===false).join('\n');

  const haikuRes=await fetch(SEARCH_PROXY_URL,{
    method:'POST', headers:{'Content-Type':'application/json'},
    body:JSON.stringify({
      model:'claude-haiku-4-5-20251001', max_tokens:150,
      system:`You match a search query to the most relevant product handles from a catalog. Return ONLY a JSON array of 6 handle strings. No explanation. Match based on: sentiment, occasion, recipient, and hobby/interest mentioned. If query mentions a hobby (cricket, music, cooking, etc) — prioritise products with matching vibes. If query mentions a relationship (papa, boss, friend) — prioritise products for that recipient.`,
      messages:[{role:'user',content:`Query: "${query}"\n\nProducts (handle|title|vibe|recipient|occasions):\n${compressed}`}]
    })
  });
  if(!haikuRes.ok) throw new Error(`Haiku catalog ${haikuRes.status}`);
  const haikuData=await haikuRes.json();
  if(haikuData.error) throw new Error(haikuData.error.message||'Haiku error');
  const raw=haikuData.content.filter(b=>b.type==='text').map(b=>b.text).join('');
  console.log('[NukkadStock] Haiku raw:', raw);
  const match=raw.match(/\[[\s\S]*?\]/);
  if(!match) throw new Error('No handles from Haiku');
  const handles=JSON.parse(match[0]).filter(h=>typeof h==='string').slice(0,6);
  console.log('[NukkadStock] Handles:', handles);
  return await fetchShopifyProducts(handles);
}

const SEARCH_SYS = `You suggest quote designs for NukkadTales — Indian handmade engraved wooden tabletop decor. ₹999 per piece.

WHAT THIS IS: A small wooden piece that sits on a desk or shelf. A private, personal object someone looks at every day and feels something.

CRITICAL — TWO COMPLETELY DIFFERENT JOBS:

1. PERSON QUERIES ("gift for maa", "for my boss", "for my friend"):
   - The quote is about WHO THEY ARE or the RELATIONSHIP
   - Should feel like a tribute, a heartfelt moment, a private message
   - "Heart Of Gold" works here — it describes a person's character
   - "She Carried Worlds" works here
   - DO NOT use room/space/vibe quotes for person queries

2. SPACE/DECOR QUERIES ("for my bedroom", "home decor", "office wall", "boho style"):
   - The quote is about the FEELING OF THE SPACE, not a person
   - Should feel like the room itself has a personality
   - "Heart Of Gold" does NOT work for a boho bedroom — it's a person quote
   - "Stay Wild Moon Child" WORKS — it's a space/vibe quote
   - "Wander Often Wonder Always" WORKS for boho
   - "Good Vibes Only", "Into The Wild", "Let It Be" — space quotes
   - NEVER suggest person tributes for room decor queries

DETECT THE QUERY TYPE FIRST:
- Contains person/relationship words (maa, dad, friend, boss, wife, etc.) → PERSON query
- Contains space/room words (bedroom, office, living room, boho, minimal, cosy, etc.) → SPACE query
- Mixed → lead with space quotes, add 1-2 person-flavoured ones

GENERATE 6 QUOTES matching the right type.
LANGUAGE: English only. Famous iconic phrases allowed.
Max 4 lines, max 2 words per line, max 8 words total. No motivational poster language.

Return ONLY a JSON array of 6, no markdown:
[{"lines":["word","word"],"vibe":"boho","src":"","inch":7,"score":9}]

inch = letter count of longest line (no spaces). Single line +3, multi-line +2.`;
const LAYOUT_SYS = `You are the typography layout AI for NukkadTales — Indian handmade wooden tabletop decor.
Decide how a quote is laid out as a hand-carved wooden piece.

FONT: Use only "main" (Poppins 900) for all lines. No font mixing. No script/Pacifico.

RULES:
- Max 3 lines
- Each line = one word only
- marginTop between lines: always +4
- letterSpacing: Title Case → "-0.03em" | ALL CAPS → "-0.05em"
- Case: power nouns ALL CAPS (PAIN, GAIN, HOME, HUSTLE) | names and flowing words Title Case

Return ONLY valid JSON:
{"lines":[{"text":"No","font":"main","fontSize":"82px","letterSpacing":"-0.03em","marginTop":0},{"text":"Pain","font":"main","fontSize":"82px","letterSpacing":"-0.03em","marginTop":4},{"text":"GAIN","font":"main","fontSize":"82px","letterSpacing":"-0.05em","marginTop":4}],"notes":"one sentence"}`;

// ══════════════════════════════════════════════════════
// STATE
// ══════════════════════════════════════════════════════
const C_DEFAULT=[
  {n:'Dark Espresso',fc:'#3d2b1a',lt:0},{n:'Ivory White',fc:'#f2ece3',lt:1},
];
// All colours come from Theme Customiser → Nukkad Customiser → Custom colour blocks
window._NT_HARDCODED_COLORS=[];
// Merge with custom colors from section settings
function ntGetColors(){
  const custom=window.NT_CUSTOM_COLORS||[];
  return custom.length?custom:[...C_DEFAULT];
}
// C is now a function call — always fresh with custom colors
// All references to C_get(i) and C_map() work via ntGetColors()
function C_get(i){return ntGetColors()[i]||C_DEFAULT[1];}
function C_len(){return ntGetColors().length;}
function C_map(fn){return ntGetColors().map(fn);}
const CONN=['no','an','my','aur','is','a','the','&','and','or','of','but','so'];

let selFont4='',namePos='below';

function goBackFromRender(){
  showSt('stageSugg');
  {var _bb=document.getElementById('backBar');if(_bb)_bb.classList.remove('show');}
  // reset state so old design doesn't leak into next pick
  window.lineOpts=[];
  window.s4NameLine='';
  window.s4LineOpts=[];
  selFont='sans';
  ['sans','serif','script','hindi'].forEach(x=>{const el=document.getElementById('fo-'+x);if(el)el.classList.toggle('on',x==='sans');});
  if(cachedSugg.length>0){
    document.getElementById('suggGrid').innerHTML='';
    renderBatch(cachedSugg.slice(0,shownCount||6));
    document.getElementById('moreRow').style.display='flex';
    document.getElementById('unlimitedTxt').style.display='block';
  }
  const _eb2=document.getElementById('ntEditorBody');if(_eb2)_eb2.scrollTop=0;
}

function setNamePos(pos){
  namePos=pos;
  ['above','below','woven'].forEach(p=>{
    const el=document.getElementById('npos-'+p);
    if(el)el.classList.toggle('on',p===pos);
  });
  renderS4();
}

function setFont4(f){
  selFont4=f;window.selFont4=f;
  window._font4ManuallySet=true;
  ['serif','pacifico','lobster','amaranth','montserrat','teko','comic','andalusia','recoleta'].forEach(x=>{const el=document.getElementById('fo4-'+x);if(el)el.classList.toggle('on',x===f);});
  // Hide global Hindi button if present
  const hindiBtn=document.getElementById('fo4-hindi');if(hindiBtn)hindiBtn.style.display='none';
  // Clear per-line font overrides so global change takes effect on all chips
  if(window.s4LineOpts)window.s4LineOpts.forEach(o=>{if(o){delete o.fontOverride;delete o.hindiText;}});
  renderS4();renderS4LineChips();try{renderS4SizeBar();}catch(e){}
}
let selC3=0,selC4=0,selFont='sans',selIcon4='';
// Find first dark (non-light) color index for visible default
function _ntDefaultColorIdx(){
  var cols=ntGetColors();
  for(var i=0;i<cols.length;i++){if(!cols[i].lt)return i;}
  return 0;
}
let uniformFs4=48,uniformFs999=48; // updated by renderS4/renderSimple each time

// ── Mantra/Shayari specific state ────────────────────
const CM=[
  {n:'Mantra Gold', bg:'#1e1408', fc:'#e8c84a'},
  {n:'Deep Navy',   bg:'#1e3a5f', fc:'#f2ece3'},
  {n:'Espresso',    bg:'#3d2b1a', fc:'#f2ece3'},
  {n:'Charcoal',    bg:'#2a2a2a', fc:'#f2ece3'},
  {n:'Forest',      bg:'#1a2e1a', fc:'#d4edda'},
  {n:'Rosewood',    bg:'#3d1515', fc:'#f9e4e4'},
];
let selCM=0, selMantraFont='sans';

function renderMantraCrow(){
  const crow=document.getElementById('mantraCrow');
  if(!crow)return;
  crow.innerHTML=CM.map((c,i)=>`<div class="nt-sw" style="background:${c.bg};border:${i===selCM?'2.5px solid var(--orange)':'2px solid rgba(0,0,0,0.15)'};transform:${i===selCM?'scale(1.2)':'scale(1)'};" title="${c.n}" onclick="pickMantraColor(${i})"></div>`).join('')
    +`<span class="nt-cn" style="color:var(--brown);">${CM[selCM].n}</span>`;
}
function pickMantraColor(i){selCM=i;renderMantraCrow();renderMantraPreview();}

function setMantraFont(f){
  selMantraFont=f;
  ['sans','serif','hindi'].forEach(x=>{const el=document.getElementById('mfo-'+x);if(el)el.classList.toggle('on',x===f);});
  renderMantraPreview();
}

function renderMantraPreview(){
  const bg=document.getElementById('mantraPieceBg');
  if(!bg)return;
  const cm=CM[selCM];
  bg.style.background=cm.bg;
  bg.innerHTML='';
  if(!mantraLines||!mantraLines.length)return;
  const piece=document.createElement('div');
  piece.className='nt-piece';
  const n=mantraLines.length;
  const maxChars=Math.max(...mantraLines.map(l=>(l||'').length),1);
  const baseSize=n<=2?26:n<=4?19:n<=6?15:12;
  const charScale=Math.min(1,16/Math.max(maxChars,8));
  const fs=Math.max(10,Math.round(baseSize*charScale));
  const fontClass=selMantraFont==='serif'?'serif':selMantraFont==='hindi'?'hindi':'sans';
  mantraLines.forEach((l,i)=>{
    if(!l)return;
    const sp=document.createElement('span');
    sp.className='tl '+fontClass;
    sp.style.color=cm.fc;
    sp.style.fontSize=fs+'px';
    sp.style.lineHeight=n<=2?'1.4':'1.55';
    sp.style.letterSpacing=selMantraFont==='hindi'?'0.01em':'-0.01em';
    sp.style.webkitTextStroke='none';
    if(i>0)sp.style.marginTop='2px';
    sp.textContent=l;
    piece.appendChild(sp);
  });
  bg.appendChild(piece);
}

// Auto-scale font size so long lines never overflow the preview
function calcLineFontSize(text, isScript, isHindi, baseMax){
  // Use the actual preview container width if available, fallback to slider width
  const container=document.getElementById('pieceBg')||document.getElementById('s4Bg');
  let containerW=container?container.getBoundingClientRect().width:0;
  // Fallback: use slider width - padding if container not yet laid out
  if(!containerW){
    const sl=document.getElementById('ntSl');
    containerW=sl?sl.getBoundingClientRect().width:0;
  }
  if(!containerW) containerW=320; // absolute fallback
  const vw=Math.min(window.innerWidth||375, 780);
  const w=Math.max(200,(containerW||vw))-48; // subtract horizontal padding
  const allChars=Math.max(1,(text||'').replace(/\s+/g,'').length);
  // include spaces in width estimate (spaces ~0.3 of charW)
  const spaces=Math.max(0,(text||'').split(' ').length-1);
  // Poppins Bold ~0.68em per char; Script ~0.58em; Hindi ~0.82em
  const charW=isHindi?0.82:isScript?0.58:0.68;
  const effectiveChars=allChars+spaces*0.3;
  const max=baseMax||72;
  const min=isHindi?20:16;
  const fit=Math.floor(w/(effectiveChars*charW));
  return Math.max(min,Math.min(max,fit));
}
let s4Align='center',align999='center';
let budget=40,curLines=[],curPrice=999,isNamed=false,exactMode=false;
let c4used=0,histLines=[],cachedSugg=[],shownCount=0;
let exactLines=[],exactPrice=999;
let customSizeOverride=null;
let curQty=1;

function adjustQtyS4(delta){
  const el=document.getElementById('qtyCurrentS4');
  if(!el)return;
  const cur=parseInt(el.textContent)||1;
  el.textContent=Math.max(1,cur+delta);
}

function adjustQty(delta){
  curQty=Math.max(1,Math.min(50,curQty+delta));
  const el=document.getElementById('qtyCurrent');if(el)el.textContent=curQty;
  const el2=document.getElementById('qtyCurrentS4');if(el2)el2.textContent=curQty;
} // customer-chosen size override

const MIN_INCH=6, MAX_INCH=24;

function updateSizeDisplay(aiInch,isPersonal){
  // update render stage size selector
  const cur=customSizeOverride||aiInch;
  const el=document.getElementById('sizeCurrent');
  const warn=document.getElementById('sizeWarning');
  if(el)el.textContent=cur;
  const aiDisp2=document.getElementById('sizeAiDisplay');if(aiDisp2)aiDisp2.textContent=aiInch;
  const aiLabel999=document.getElementById('aiLabelText999');
  if(aiLabel999)aiLabel999.innerHTML=`✦ Nukkad AI suggested · ${aiInch}" minimum for better readability · <span style="letter-spacing:.05em;color:#1e6b3a;">GO BIGGER</span> for more impact.`;
  const minusBtn=document.getElementById('sizeMinusBtn');
  if(minusBtn){const atMin=(customSizeOverride===null);minusBtn.disabled=atMin;minusBtn.style.cssText=atMin?"width:38px;height:38px;border-radius:50%;border:1.5px solid #e8e0d8;background:#fdf6f0;color:#ccc4bb;font-size:20px;font-weight:700;cursor:not-allowed;display:flex;align-items:center;justify-content:center;line-height:1;padding:0;margin:0;box-shadow:none;-webkit-appearance:none;appearance:none;":"width:38px;height:38px;border-radius:50%;border:1.5px solid #c8b09a;background:#fdf6f0;color:#3d2b1a;font-size:20px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;line-height:1;padding:0;margin:0;box-shadow:none;-webkit-appearance:none;appearance:none;";}
  const extra2x=Math.max(0,cur-aiInch)*100;
  if(warn){warn.style.display='none';}
  // price increases above anchor: quote anchor = min(9, aiInch), personal anchor = 8
  const base=isPersonal?1299:999;
  const anchor=isPersonal?8:Math.min(9,aiInch);
  const extra=Math.max(0,cur-anchor)*100;
  const price=base+extra;
  const btn=document.getElementById('commBtn');
  if(btn)btn.textContent=`${(window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.txt&&window.NUKKAD_CONFIG.txt.commLabel)||'Add to Cart'} · ₹${price.toLocaleString('en-IN')}`;
  curPrice=price;
}

function adjustSize(delta){
  const {inch}=calcSizePrice(curLines,isNamed,window.lineOpts||[]);
  const cur=customSizeOverride||inch;
  const next=Math.max(inch,Math.min(MAX_INCH,cur+delta)); // min = AI suggested (≥6" for quotes)
  customSizeOverride=next===inch?null:next; // null = back to AI default
  updateSizeDisplay(inch,isNamed);
}

function updateSizeDisplayS4(aiInch){
  aiInch = aiInch||6;
  const cur=customSizeOverride||aiInch;
  const el=document.getElementById('sizeCurrentS4');
  const warn=document.getElementById('sizeWarningS4');
  if(el)el.textContent=cur;

  const aiDispS4=document.getElementById('sizeAiDisplayS4');if(aiDispS4)aiDispS4.textContent=aiInch;
  // Update AI label with actual inch value
  const _aiEl=document.getElementById('aiLabelTextS4');
  if(_aiEl){
    const _txt2=(window.NUKKAD_CONFIG&&NUKKAD_CONFIG.txt)||{};
    const _aiBase='Nukkad AI suggested · '+aiInch+'" minimum for readability';
    const _bigger=_txt2.goBigger||'GO BIGGER for more impact';
    _aiEl.innerHTML='✦ '+_aiBase+' · <span style="letter-spacing:.04em;color:#a8ffc4;">'+_bigger+'</span>';
  }
  // Update place caption below stepper
  const _descMap={6:'Compact · gifting',7:'Desk or shelf',8:'Desk · comfortable read',9:'Desk · slightly bolder',10:'Sideboard or console',11:'Sideboard · makes a statement',12:'Wall piece · bold from a distance',13:'Wall piece · strong anchor',14:'Large wall',15:'Statement wall piece',16:'Feature wall',18:'Gallery wall',20:'Large installation'};
  const _captEl=document.getElementById('sizeInfoTextRenderS4');
  if(_captEl)_captEl.textContent=_descMap[cur]||'Bold statement piece';
  // Set minus button inline styles to beat Sense theme
  const minusBtnS4=document.getElementById('sizeMinusBtnS4');
  if(minusBtnS4){
    const atMinS4=(customSizeOverride===null);
    minusBtnS4.disabled=atMinS4;
    minusBtnS4.style.cssText=atMinS4?'width:40px;height:40px;border-radius:50%;border:1.5px solid #e8e0d8;background:#fdf6f0;color:#ccc4bb;font-size:22px;font-weight:700;cursor:not-allowed;display:flex;align-items:center;justify-content:center;line-height:1;padding:0;margin:0;box-shadow:none;-webkit-appearance:none;appearance:none;flex-shrink:0;':'width:40px;height:40px;border-radius:50%;border:1.5px solid #c8b09a;background:#fdf6f0;color:#3d2b1a;font-size:22px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;line-height:1;padding:0;margin:0;box-shadow:none;-webkit-appearance:none;appearance:none;transition:border-color .15s,color .15s;flex-shrink:0;';
  }
  if(warn)warn.style.display='none';

  // Bug fix: count ALL lines (quote lines + name lines) for 4th line charge
  const adjNameLines=(window.s4NameLines||[]).filter(Boolean);
  const totalLines=curLines.length+adjNameLines.length;
  const lineBase=totalLines>=4?1399:1299;
  // ── MATRIX PRICING FIX 1 (updateSizeDisplayS4) ──
  const actualInch=Math.min(Math.max(cur,8),24);
  const lineCount=Math.min(totalLines,4);
  const price=typeof ntGetPrice==='function'?ntGetPrice(actualInch,lineCount):(lineBase+Math.max(0,cur-aiInch)*100);
  const btn=document.getElementById('s4Btn');
  if(btn)btn.textContent=`${(window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.txt&&window.NUKKAD_CONFIG.txt.commLabel)||'Add to Cart'} · ₹${price.toLocaleString("en-IN")}`;
  const dt=document.getElementById('designerToggle');
  if(dt)dt.setAttribute('onclick',`toggleDesigner('designerToggle','s4Btn',${lineBase})`);
}

function adjustSizeS4(delta){
  const adjNameLines=(window.s4NameLines||[]).filter(Boolean);
  const allLines=[...curLines,...adjNameLines];
  const adjOpts=[...(window.s4LineOpts||[]),...(window.s4NameLineOpts||[]).slice(0,adjNameLines.length)];
  const {inch}=calcSizePrice(allLines,true,adjOpts);
  const cur=customSizeOverride||inch;
  const next=Math.max(inch,Math.min(MAX_INCH,cur+delta));
  customSizeOverride=next===inch?null:next;
  renderS4SizeBar(); // updates full breakdown + button
  ntUpdatePersonalBtn();
}

// ══════════════════════════════════════════════════════
// API
// ══════════════════════════════════════════════════════
async function callAI(model,system,userMsg,maxTok=1000){
  const res=await fetch(PROXY_URL,{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({model,max_tokens:maxTok,system,messages:[{role:'user',content:userMsg}]})
  });
  if(!res.ok){const t=await res.text();throw new Error(`HTTP ${res.status}: ${t.slice(0,200)}`);}
  const data=await res.json();
  if(data.error)throw new Error(data.error.message||JSON.stringify(data.error));
  return data.content.filter(b=>b.type==='text').map(b=>b.text).join('');
}

// Render a real Shopify product card (image + price)
function ntMakeShopifyCard(product){
  const el = document.createElement('div');
  el.className = 'nt-shopify-card';

  const img = product.images?.[0]?.src;
  const minPrice = Math.min(...(product.variants||[]).map(v=>{
    const p=parseFloat(v.price)||0;
    return p>1000 ? p/100 : p; // suggest API returns cents as integer
  }));
  const priceStr = minPrice ? '₹'+minPrice.toLocaleString('en-IN') : '';
  const title = product.title || '';

  if(img){
    const imgEl = document.createElement('img');
    imgEl.className = 'nt-shopify-img';
    imgEl.src = img;
    imgEl.alt = title;
    imgEl.loading = 'lazy';
    el.appendChild(imgEl);
  } else {
    const ph = document.createElement('div');
    ph.className = 'nt-shopify-img-placeholder';
    ph.innerHTML = `<span style="font-weight:900;font-size:13px;color:var(--muted);text-align:center;padding:8px;">${title}</span>`;
    el.appendChild(ph);
  }

  const body = document.createElement('div');
  body.className = 'nt-shopify-body';
  body.innerHTML =
    `<div class="nt-shopify-title">${title}</div>` +
    (priceStr ? `<div class="nt-shopify-price">${priceStr}</div>` : '') +
    `<div class="nt-shopify-meta">Ships 2–3 days · In stock</div>`;
  el.appendChild(body);

  el.onclick = () => window.open(`https://nukkadtales.com/products/${product.handle}`, '_blank');
  return el;
}

async function callSearchAI(query){
  const providers = [
    {name:'GPT-4o Mini',  url:GPT_SUGG_URL,     body:{system:SEARCH_SYS,messages:[{role:'user',content:`Query: "${query}"`}],max_tokens:1000}},
    {name:'Gemini',       url:GEMINI_SUGG_URL,   body:{system:SEARCH_SYS,messages:[{role:'user',content:`Query: "${query}"`}],max_tokens:2000}},
    {name:'Claude Haiku', url:SEARCH_PROXY_URL,  body:{model:'claude-haiku-4-5-20251001',max_tokens:1200,system:SEARCH_SYS,messages:[{role:'user',content:`Query: "${query}"`}]}}
  ];
  for(const p of providers){
    try{
      const res=await fetch(p.url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(p.body)});
      if(!res.ok) throw new Error('HTTP '+res.status);
      const data=await res.json();
      if(data.error) throw new Error(data.error.message||'API error');
      const raw=data.content.filter(b=>b.type==='text').map(b=>b.text).join('');
      const cleaned=raw.replace(/```json|```/g,'').replace(/[\u0000-\u001F\u007F]/g,' ').replace(/,(\s*[}\]])/g,'$1').trim();
      const match=cleaned.match(/\[[\s\S]*\]/);
      if(!match) throw new Error('No JSON array');
      const cards=JSON.parse(match[0]);
      if(!Array.isArray(cards)||!cards.length) throw new Error('Empty array');
      console.log('[NukkadAI]',p.name,'| cards:',cards.length);
      return cards;
    }catch(e){
      console.warn('[NukkadAI]',p.name,'failed:',e.message,'— trying next...');
    }
  }
  return [];
}

async function classifyIntent(query){
  try{
    const raw=await callAI(MODEL_SUGG,CLASSIFY_SYS,query,20);
    const r=raw.trim().toLowerCase();
    if(r.includes('mantra'))return 'mantra';
    if(r.includes('personal'))return 'personal';
    return 'quote';
  }catch(e){
    return quickDetect(query)?'personal':'quote';
  }
}

async function fetchSuggestions(query,count=6,named=false){
  let sys,userMsg;
  if(named==='couple'){
    sys=SUGG_SYS_COUPLE;
    userMsg=`Generate ${count} couple name suggestions for: "${query}". Extract the two names. Return compact single-line JSON only.`;
  } else if(named){
    sys=SUGG_SYS_PERSONAL;
    userMsg=`Generate ${count} personalised suggestions for: "${query}". Use actual names from input. Return compact single-line JSON only.`;
  } else {
    sys=SUGG_SYS_QUOTE;
    userMsg=`Generate ${count} quote suggestions for: "${query}". Return compact single-line JSON only.`;
  }
  const raw=await callAI(MODEL_SUGG,sys,userMsg,3000);
  console.log('[NukkadAI] Raw response:',raw.slice(0,500));
  const clean=raw.replace(/[\u{1F000}-\u{1FFFF}]/gu,'').replace(/[\u{2600}-\u{26FF}]/gu,'').replace(/```json|```/g,'').trim();
  const start=clean.indexOf('{'); const end=clean.lastIndexOf('}');
  if(start===-1||end===-1){console.warn('[NukkadAI] No JSON in:',raw.slice(0,300));throw new Error('No JSON found in AI response');}
  const match=[clean.slice(start,end+1)];
  let jsonStr=match[0].replace(/,\s*([}\]])/g,'$1');
  // try to recover truncated JSON by closing open structures
  try{
    const quotes=JSON.parse(jsonStr).quotes;
    // post-process each suggestion
    return quotes.map(q=>{
      const rawLines=q.lines||[];
      // split any multi-word line elements
      const splitLines=[];
      rawLines.forEach(l=>{
        // also split camelCase — "StillGrowing" → ["Still","Growing"]
        const deСamel=l.replace(/([a-z])([A-Z])/g,'$1 $2');
        const words=(deСamel||'').trim().split(/\s+/).filter(Boolean);
        if(words.length<=1){
          splitLines.push(l);
        } else {
          const lettersOnly=l.replace(/\s/g,'').length;
          if(words.length===2&&lettersOnly<=4){splitLines.push(deСamel);}
          else{words.forEach(w=>splitLines.push(w));}
        }
      });
      const finalLines=splitLines.slice(0,4).filter(Boolean);
      // filter garbage suggestions — loosen for personal/Hindi
      const maxLen=(named===true||named==='couple')?18:12;
      const tooLong=finalLines.some(l=>l.replace(/\s/g,'').length>maxLen);
      if(tooLong)return null;
      // always use isNamed for personal, not just named param
      const {inch,price}=calcSizePrice(finalLines,named,[]);
      return {...q,lines:finalLines,inch,price,upgrade:inch>9};
    }).filter(Boolean);
  }catch(e){
    // attempt recovery: find last complete quote object
    try{
      const quotesMatch=jsonStr.match(/"quotes"\s*:\s*\[([\s\S]*)/);
      if(quotesMatch){
        const items=quotesMatch[1].match(/\{[^{}]*"lines"[^{}]*\}/g)||[];
        if(items.length>0){
          const recovered=items.map(item=>{try{
            const q=JSON.parse(item);
            const {inch,price}=calcSizePrice(q.lines||[],named,[]);
            return {...q,inch,price,upgrade:inch>9};
          }catch{return null;}}).filter(Boolean);
          if(recovered.length>0)return recovered;
        }
      }
    }catch{}
    console.error('[JSON parse error]',e.message,'\nRaw:',raw.slice(0,300));
    throw new Error(`AI returned malformed JSON: ${e.message}`);
  }
}

// ══════════════════════════════════════════════════════
// HELPERS
// ══════════════════════════════════════════════════════
function isSc(w){return CONN.includes(w.toLowerCase().trim())&&w.length<=5;}

// Detect if text contains Devanagari script
function isDevanagari(text){
  return /[ऀ-ॿ]/.test(text||'');
}

function autoDetectHindi(lines, opts){
  // Hindi font removed — users type Devanagari directly, size calc handles it via countAnyScript
  return false;
}
function showError(title,sub){
  const e=document.getElementById('errBox');
  document.getElementById('errTitle').textContent=title;
  document.getElementById('errSub').textContent=sub;
  e.style.display='block';
}
function hideError(){document.getElementById('errBox').style.display='none';}
function setLoading(on,txt){
  document.getElementById('suggLoading').style.display=on?'block':'none';
  if(txt)document.getElementById('ltxt').textContent=txt;
}
function showSt(id){
  if(typeof goToEditorScreen==='function'&&(id==='stageRender'||id==='stagePersonal'||id==='stageMantra'))goToEditorScreen();
  if(typeof goToSearchScreen==='function'&&(id==='stageEmpty'||id==='stageSugg'))goToSearchScreen();
  const bc=document.getElementById('blankCanvas');if(bc)bc.style.display=(id==='stageEmpty')?'block':'none';
  const inDesign=id==='stagePersonal'||id==='stageRender';
  const heroH=document.getElementById('heroHeadline');if(heroH)heroH.style.display=inDesign?'none':'';
  const heroS=document.getElementById('heroSection');if(heroS)heroS.style.display=inDesign?'none':'';
  const designNav=document.getElementById('designNav');if(designNav)designNav.style.display=inDesign?'flex':'none';
  const chipsArea=document.querySelector('.nt-sticky .nt-chips');if(chipsArea)chipsArea.parentElement.style.display=(id==='stageEmpty')?'block':'none';
  ['stageEmpty','stageSugg','stageRender','stagePersonal','stageMantra'].forEach(s=>{
    var _s=document.getElementById(s);if(_s)_s.style.display=s===id?'block':'none';
  });
  // hide back bar when going to suggestions or empty
  if(id==='stageSugg'||id==='stageEmpty'){var _bb=document.getElementById('backBar');if(_bb)_bb.classList.remove('show');}document.body.classList.remove('has-backbar');
}
function quickDetect(q){
  if(!q)return false;
  if(/\w+\s*&\s*\w+/.test(q))return true;
  if(/\b(dr|mr|mrs|ms|prof)\b/i.test(q))return true;
  return false;
}
function isCouple(q){
  const ql=q.toLowerCase();
  if(/\b(couple|husband|wife|anniversary|wedding|shaadi|jodi)\b/.test(ql))return true;
  // two capitalised names: "Rahul Priya", "Rahul and Priya"
  const names=q.match(/[A-Z][a-z]{2,}/g)||[];
  if(names.length>=2)return true;
  return false;
}

const VAGUE_PERSONAL=["customise name","customize name","add name","personalise","personalize","with name","custom name"];
const VAGUE_GENERIC=["custom design","custom","design","something","a piece","wooden","gift","quote","anything"];

function detectVague(q){
  const ql=q.toLowerCase().trim();
  const words=ql.split(/\s+/);
  // very short or generic single words
  if(words.length<=2&&VAGUE_GENERIC.some(v=>ql===v||ql.startsWith(v)))return'generic';
  if(VAGUE_PERSONAL.some(v=>ql.includes(v)))return'name';
  if(["for my boss","for my friend","for my colleague","for my wife","for my husband","for my mom","for my dad","for my sister","for my brother","for someone"].some(v=>ql.includes(v))&&!/[A-Z][a-z]{2,}/.test(q))return'relation';
  if(words.length<=2&&["boss","friend","wife","husband","colleague","teacher","mom","dad","sister","brother"].some(w=>ql===w||ql.includes("for "+w)||ql.includes("my "+w)))return'relation';
  return null;
}
function setChip(v){var _mi=document.getElementById('mainInp');if(_mi)_mi.value=v;doCreate();}
function scrollToInput(){window.scrollTo({top:0,behavior:'smooth'});setTimeout(()=>{var _mi=document.getElementById('mainInp');if(_mi)_mi.focus();},400);}

function toggleExact(){
  exactMode=!exactMode;
  var _ec=document.getElementById('exactChk');if(_ec)_ec.classList.toggle('on',exactMode);
  const wrap=document.getElementById('exactPillWrap');
  const dot=document.getElementById('exactPillDot');
  const txt=document.getElementById('exactPillTxt');
  if(exactMode){
    wrap.classList.add('on');
    dot.style.background='var(--teal)';dot.style.borderColor='var(--teal)';
    dot.innerHTML='<span style="font-size:9px;color:#fff;font-weight:700;">✓</span>';
    txt.textContent='Exact match on ✓';txt.style.color='var(--teal)';
  }else{
    wrap.classList.remove('on');
    dot.style.background='transparent';dot.style.borderColor='rgba(42,172,142,0.6)';
    dot.innerHTML='';
    txt.textContent='Carve exactly what I typed';txt.style.color='rgba(255,255,255,0.8)';
  }
  renderExactCard();
}
function renderExactCard(){
  var _mainEl=document.getElementById('mainInp');const v=_mainEl?_mainEl.value.trim():'';
  const card=document.getElementById('exactCard');
  const divider=document.getElementById('exactDivider');
  if(!exactMode||!v){card.style.display='none';if(divider)divider.style.display='none';const tb3=document.getElementById('tierBadge');if(tb3)tb3.style.display='';return;}
  if(divider)divider.style.display='flex';
  const tb2=document.getElementById('tierBadge');if(tb2)tb2.style.display='none';
  // split by word — each word = one line
  const words=v.split(/\s+/).filter(Boolean);
  const lines=words.length>1?words:[v]; // single word stays as-is
  exactLines=lines;
  // show card immediately with lines but block interaction until AI confirms price
  document.getElementById('exactCardLines').innerHTML=lines.map(l=>`<span class="nec-line">${l}</span>`).join('');
  document.getElementById('exactCardMeta').textContent='checking price…';
  card.style.display='block';
  card.style.pointerEvents='none';
  card.style.opacity='0.65';
  classifyIntent(v).then(intent=>{
    const personal=intent==='personal';
    isNamed=personal;
    const {inch,price:ep}=calcSizePrice(lines,personal,[]);
    exactPrice=ep;
    const anchor=personal?8:Math.min(9,inch);
    const extra=Math.max(0,inch-anchor)*100;
    const base=personal?1299:999;
    const meta=extra>0?`${inch}" · ₹${base} + ₹${extra} for size`:`${inch}" · ₹${base}`;
    document.getElementById('exactCardMeta').textContent=meta;
    card.style.pointerEvents='';
    card.style.opacity='1';
  }).catch(()=>{
    // fallback to quickDetect if AI fails
    const personal=quickDetect(v);
    isNamed=personal;
    const {inch,price:ep}=calcSizePrice(lines,personal,[]);
    exactPrice=ep;
    const anchor=personal?8:Math.min(9,inch);
    const extra=Math.max(0,inch-anchor)*100;
    const base=personal?1299:999;
    document.getElementById('exactCardMeta').textContent=extra>0?`${inch}" · ₹${base} + ₹${extra} for size`:`${inch}" · ₹${base}`;
    card.style.pointerEvents='';
    card.style.opacity='1';
  });
}

// ══════════════════════════════════════════════════════
// MAIN CREATE
// ══════════════════════════════════════════════════════
async function doCreate(){
  var _mainEl2=document.getElementById('mainInp');const q=_mainEl2?_mainEl2.value.trim():'';
  if(!q)return;
  // exactMode: show exact card as pinned first option + AI suggestions below
  // (no skip — let AI run and show exact card prominently)
  cachedSugg=[];shownCount=0;_paletteIdx=0;// clear layout cache so new prompt applies
  document.getElementById('suggGrid').innerHTML='';
  document.getElementById('moreRow').style.display='none';
  document.getElementById('historyWrap').style.display='none';
  hideError();renderExactCard();
  showSt('stageSugg');
  const _nc=document.getElementById('ntEditorBody');if(_nc)_nc.scrollTop=0;
  setLoading(true,'Nukkad AI is reading your input…');
  try{
    // classify intent
    const intent=await classifyIntent(q);
    isNamed=intent==='personal';
    const tb=document.getElementById('tierBadge');if(tb)tb.classList.add('show');
    // handle mantra intent — go direct to stageMantra
    if(intent==='mantra'){
      setLoading(false);
      const isComplete=q.length>=100;
      const mantraPrice=isComplete?3299:2299;
      document.getElementById('tbPrice').textContent=`₹${mantraPrice.toLocaleString('en-IN')}`;
      const _tbr=document.getElementById('tbReason');if(_tbr)_tbr.textContent=isComplete?'Full Mantra · ₹3,299':'Shayari · ₹2,299';
      goMantra(q,mantraPrice);
      return;
    }
    document.getElementById('tbPrice').textContent=isNamed?'₹1,299':'₹999';
    const _tbr=document.getElementById('tbReason');if(_tbr)_tbr.textContent=isNamed?'Personalised piece':'Quote piece';
    setLoading(true,'Finding the best ideas for you…');
    // detect vague query
    const vagueType=detectVague(q);
    const vagueNudge=document.getElementById('vagueNudge');
    vagueNudge.style.display='none';

    // generic vague query — show refine prompt, skip AI
    if(vagueType==='generic'){
      setLoading(false);
      document.getElementById('unlimitedTxt').style.display='none';
      vagueNudge.style.display='block';
      document.getElementById('vagueTitle').textContent='What exactly do you want on it?';
      document.getElementById('vagueSub').innerHTML='Be specific — a quote, a name, a feeling. Like <span style="color:var(--orange);font-weight:500;">"No Pain No Gain"</span> or <span style="color:var(--orange);font-weight:500;">"for my boss Nidhi"</span> or <span style="color:var(--orange);font-weight:500;">"something for a chai lover"</span>.';
      document.getElementById('suggGrid').innerHTML='';
      document.getElementById('moreRow').style.display='none';
      return;
    }
    // for vague name queries use sample name for personal suggestions
    const effectiveQuery=vagueType==='name'?q+' — sample names Rahul & Priya':q;
    let quoteSuggs=[];
    let personalSuggs=[];
    let _suggErr=null;
    const coupleMode=isNamed&&isCouple(q);
    if(coupleMode){
      try{personalSuggs=await fetchSuggestions(effectiveQuery,6,'couple');}
      catch(e){_suggErr=e;console.error('[Couple suggs failed]',e.message);}
    } else if(isNamed||vagueType==='name'){
      try{personalSuggs=await fetchSuggestions(effectiveQuery,6,true);}
      catch(e){_suggErr=e;console.error('[Personal suggs failed]',e.message);}
    } else {
      try{quoteSuggs=await fetchSuggestions(effectiveQuery,6,false);}
      catch(e){_suggErr=e;console.error('[Quote suggs failed]',e.message);}
    }
    if(quoteSuggs.length===0&&personalSuggs.length===0){
      if(exactMode&&exactLines.length>0){
        setLoading(false);
        document.getElementById('unlimitedTxt').style.display='none';
        return;
      }
      // API responded but JSON parse failed — show meaningful error
      setLoading(false);
      showError('AI returned no suggestions','The AI responded but couldn\'t be parsed. Check the browser console (F12) for the raw response. Try rephrasing — e.g. \"gym motivation for Rahul\".');
      return;
    }
    const allSuggs=[...quoteSuggs,...personalSuggs];
    const seen=new Set();
    cachedSugg=allSuggs.filter(s=>{const k=(s.lines||s.ls||[]).join('|');if(seen.has(k))return false;seen.add(k);return true;});
    renderBatch(cachedSugg.slice(0,6));
    shownCount=6;budget-=6;updBudget();
    // show unlimited text
    document.getElementById('unlimitedTxt').style.display='block';
    // show vague nudge if needed
    if(vagueType){
      const nudge=document.getElementById('vagueNudge');
      nudge.style.display='block';
      if(vagueType==='name'){
        document.getElementById('vagueTitle').textContent='These are sample designs with a placeholder name';
        document.getElementById('vagueSub').innerHTML='Type the actual name you want — like <span style="color:var(--orange);font-weight:500;">"Rahul" or "Priya & Arjun"</span> — and AI will personalise it.';
      } else {
        document.getElementById('vagueTitle').textContent='Want something more personal?';
        document.getElementById('vagueSub').innerHTML='Add a specific name or detail — like <span style="color:var(--orange);font-weight:500;">"my boss Nidhi" or "for Rahul who loves chai"</span> — for better results.';
      }
    }
    setLoading(false);
  }catch(err){
    setLoading(false);
    let errTitle='Could not reach Nukkad AI';
    let errMsg=err.message;
    if(err.message==='Failed to fetch'||err.message.includes('NetworkError')||err.message.includes('CORS')){
      errTitle='CORS / Network error';
      errMsg='Opening from file:// blocks the API call. Host this file on Netlify or run a local server (e.g. VS Code Live Server). Raw error: '+err.message;
    } else if(err.message.includes('401')){
      errTitle='API key missing';
      errMsg='ANTHROPIC_API_KEY is not set in Netlify env vars, or the function is not deployed.';
    } else if(err.message.includes('403')){
      errTitle='Access denied (403)';
      errMsg='The function rejected this origin. Check the allowlist in nt-ai.js. Raw: '+err.message;
    } else if(err.message.includes('HTTP')){
      errTitle='Function error';
      errMsg=err.message;
    }
    showError(errTitle,errMsg);
    console.error('[NukkadAI]',err);
  }
}

let _paletteIdx=0; // unused but kept for compat

function renderBatch(suggs){
  const g=document.getElementById('suggGrid');
  g.className='nt-grid';
  suggs.forEach(s=>{
    const lines=[...(s.lines||s.ls||[])];
    const price=s.price||s.pr||999;
    const inch=s.inch||8;

    const card=document.createElement('div');
    card.className='nt-scard';

    card.onclick=()=>{
      if(lines.some(l=>l.includes('NAME'))){
        curLines=[...lines];curPrice=price;isNamed=true;goPersonal();
      } else {
        goRender([...lines],price);
      }
    };

    // text block — each line on its own row, serif italic
    const lh=lines.map(l=>`<span class="nscl ${isSc(l)?'sc':'m'}">${l}</span>`).join('');
    const sizeLabel=s.upgrade?`↑ ${inch}" suggested`:`${inch}"`;

    card.innerHTML=`
      <div class="nscard-body">
        <div class="nscard-kicker">MADE FOR YOU</div>
        <div class="nscard-text">${lh}</div>
      </div>
      <div class="nscard-foot">
        <span class="nscard-price">From ₹${price.toLocaleString('en-IN')}</span>
        <span class="nscard-cta">Get this →</span>
      </div>
    `;

    g.appendChild(card);
  });
  document.getElementById('moreRow').style.display='flex';
}

function moreCards(encoded){
  const lines=decodeURIComponent(encoded).split('|');
  var _mainEl2=document.getElementById('mainInp');const q=_mainEl2?_mainEl2.value.trim():'';
  const inp=document.getElementById('mainInp')||{value:'',focus:()=>{}};
  // for couple mode — keep original query, just ask for more variety
  if(isCouple(q)&&isNamed){
    showMore();
  } else {
    inp.value=lines.join(' ')+' — more like this';
    inp.focus();
    doCreate();
  }
}

function updBudget(){
  const n=document.getElementById('budgetNum');
  if(n){n.textContent=Math.max(0,budget);n.className='nb-num'+(budget<=4?' low':'');}
  const rem=cachedSugg.length-shownCount;
  const mb=document.getElementById('moreBtn');
  const main=document.getElementById('moreBtnMain');
  const sub=document.getElementById('moreBtnSub');
  if(budget<=0){
    mb.disabled=false;
    main.textContent='Generate 10 more ideas';
    sub.textContent='You\'ve seen a lot — here\'s a fresh batch';
    mb.onclick=()=>{budget+=10;updBudget();showMore();};
  } else if(rem>0){
    mb.disabled=false;mb.onclick=showMore;
    main.textContent=`Show ${Math.min(4,rem)} more ideas`;
    sub.textContent=`${budget} left this session`;
  } else {
    mb.disabled=false;mb.onclick=showMore;
    main.textContent='Generate 4 more ideas';
    sub.textContent=`${budget} left this session`;
  }
}

async function showMore(){
  const rem=cachedSugg.slice(shownCount,shownCount+4);
  if(rem.length>0){
    renderBatch(rem);shownCount+=rem.length;budget-=rem.length;updBudget();
  } else if(budget>0){
    var _mainEl2=document.getElementById('mainInp');const q=_mainEl2?_mainEl2.value.trim():'';
    setLoading(true,'Fetching more…');
    try{
      const more=await fetchSuggestions(q,6,isNamed);
      // deduplicate against already shown
      const seen=new Set(cachedSugg.map(s=>(s.lines||s.ls||[]).join('|')));
      const fresh=more.filter(s=>!seen.has((s.lines||s.ls||[]).join('|')));
      cachedSugg=[...cachedSugg,...fresh];
      renderBatch(fresh);shownCount+=fresh.length;budget-=fresh.length;
      setLoading(false);updBudget();
    }catch(e){setLoading(false);showError('Could not fetch more',e.message);}
  }
}

// ══════════════════════════════════════════════════════
// RENDER
// ══════════════════════════════════════════════════════
async function goRender(lines,price){
  if(curLines.length>0)histLines.push({ls:[...curLines],pr:curPrice});
  // ensure each line element is a single word — split any multi-word elements
  const cleanLines=[];
  lines.forEach(l=>{
    const words=(l||'').trim().split(/\s+/).filter(Boolean);
    const isDevanagari=/[\u0900-\u097F]/.test(l);
    if(words.length<=1||l.replace(/\s/g,'').length<=4||isDevanagari){cleanLines.push(l);}
    else{words.forEach(w=>cleanLines.push(w));}
  });
  curLines=(cleanLines.length>0?cleanLines:lines).slice(0,4);
  curPrice=price;
  isNamed=price>=1299;
  window.lineOpts=curLines.map(()=>({font:''}));
  customSizeOverride=null;
  curQty=1;
  window._fontManuallySet=false;
  // Reset icon on letter for new design
  window.ntLetterIcon={active:false,letter:'',line:0,charIdx:0,iconSrc:'',iconLabel:''};
  if(typeof ntRefreshIconLetterRow==='function') ntRefreshIconLetterRow(); // reset on new design
  // Auto-detect if customer typed in Devanagari directly
  // Only auto-switch to Hindi if font is still at default (hasn't been manually changed)
  autoDetectHindi(curLines, window.lineOpts);
  if(histLines.length>0){
    document.getElementById('historyWrap').style.display='block';
    document.getElementById('historyScroll').innerHTML=histLines.map(h=>`<div class="nt-hcard" onclick="goRender(${JSON.stringify(h.ls)},${h.pr})"><div class="nhcl">${h.ls.join(' ')}</div><div class="nhcm">₹${h.pr}</div></div>`).join('');
  }
  if(isNamed){
    // ₹1,299 — go to personal stage
    selC4=selC3;window.selC4=selC4;
    selFont4=selFont4||'';window.selFont4=selFont4;window.selFont=selFont;
    window.s4NameLine='';
    window.s4NameLines=[''];
    window.s4NameLineOpts=[{}];
    window.s4LineOpts=curLines.map(()=>({}));
    window.s4NameFontOpts={};
    selIcon4='';s4Align='center';
    customSizeOverride=null;
    originalCurLines=[...curLines];
    initS4();
  } else {
    // ₹999 — go to render stage
    showSt('stageRender');
    {var _bb=document.getElementById('backBar');if(_bb)_bb.classList.add('show');}
    {var _bbs=document.getElementById('backBarStage');if(_bbs)_bbs.textContent='₹999 design';}
    selFont='sans';
    ['sans','serif','script'].forEach(x=>{const el=document.getElementById('fo-'+x);if(el)el.classList.toggle('on',x==='sans');});
    try{renderSimple();}catch(e){console.error('[renderSimple crash]',e.message,e.stack);}
    try{renderC3();}catch(e){console.error('[renderC3 crash]',e.message);}
    try{renderPuThumb();}catch(e){console.error('[renderPuThumb crash]',e.message);}
    const puEl=document.getElementById('puRow');
    if(puEl){puEl.style.display='flex';puEl.style.visibility='visible';puEl.style.height='96px';puEl.style.margin='';puEl.style.overflow='hidden';puEl.style.border='1px solid var(--border)';}
    document.getElementById('commBtn').textContent=`${(window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.txt&&window.NUKKAD_CONFIG.txt.commLabel)||'Add to Cart'} · ₹${price}`;
    // open reorder panel
    const wrap=document.getElementById('lineReorderWrap');
    if(wrap)wrap.style.display='block';
    try{renderLineChips();}catch(e){console.error('renderLineChips',e);}
    try{renderSizeBar();}catch(e){console.error('renderSizeBar',e);}
  }
  // if no cached suggestions yet (came via exact card), fetch some
  if(cachedSugg.length===0){
    var _mainEl2=document.getElementById('mainInp');const q=_mainEl2?_mainEl2.value.trim():'';
    if(q)fetchSuggestions(q,3,false).then(s=>{cachedSugg=[...s];renderTry();}).catch(()=>{});
  } else {
    renderTry();
  }
  // Scroll editor body to top (not page — we're in a slider)
  const _eb=document.getElementById('ntEditorBody');if(_eb)_eb.scrollTop=0;
}

function useExact(){
  const q=(exactLines||[]).join(' ');
  isNamed=quickDetect(q);
  const p=calcSizePrice(exactLines,isNamed,[]).price;
  goRender(exactLines,p);
}

function renderSimple(){
  try { _renderSimpleInner(); } catch(e){ console.error('[renderSimple CRASH]', e.message, e.stack); }
}
function _renderSimpleInner(){
  const _allC3=ntGetColors();const c=_allC3[selC3]||_allC3[1];const p=document.createElement('div');p.className='nt-piece';
  const block999=document.createElement('div');
  block999.style.cssText='display:inline-flex;flex-direction:column;align-items:stretch;';
  const lines=curLines.length>0?curLines:[''];
  const effectiveFont=selFont;
  const opts=window.lineOpts||[];
  const isBottomLine=(i)=>i===lines.filter(l=>l).length-1;

  // Pre-compute uniform font size = minimum across all non-wide lines
  // Also build per-line font size map for icon-on-letter sizing
  uniformFs999=72;
  const perLineFontSize999=[];
  lines.forEach((l,i)=>{
    if(!l){perLineFontSize999.push(72);return;}
    const opt2=window.lineOpts?window.lineOpts[i]||{}:{};
    const lf2=opt2.fontOverride||selFont;
    const isHindi2=lf2==='hindi';
    const isCaps2=!!opt2.allCaps&&!isHindi2;
    const dt2=isHindi2?(opt2.hindiText||l):(isCaps2?l.toUpperCase():l);
    const isWide2=!!(opt2.wide&&ntWideEligible(i,lines));
    const fs2=calcLineFontSize(dt2,lf2==='script',isHindi2,isWide2?96:72);
    perLineFontSize999.push(fs2);
    if(!isWide2&&fs2<uniformFs999)uniformFs999=fs2;
  });

  lines.forEach((l,i)=>{
    if(!l)return;

  // ── ICON LINE: render at very top of block ──────────
  try {
  if(i===0 && window.ntIconLine && window.ntIconLine.active && window.ntIconLine.iconKey){
    const il = window.ntIconLine;
    const ilRow = document.createElement('div');
    const ilJc = il.side==='left'?'flex-start':il.side==='right'?'flex-end':'center';
    ilRow.style.cssText='display:flex;align-items:center;justify-content:'+ilJc+';padding-bottom:4px;';
    const ilImg = document.createElement('img');
    ilImg.src = il.iconKey; ilImg.alt='';
    ilImg.style.cssText='width:'+uniformFs999+'px;height:'+uniformFs999+'px;object-fit:contain;display:block;transform:rotate('+il.rotation+'deg);';
    ilRow.appendChild(ilImg);
    block999.appendChild(ilRow);
  }
  } catch(e){ console.warn('[IconLine canvas]',e); }
    const opt=opts[i]||{};
    const lf=opt.fontOverride||selFont; // per-line override OR global font
    const isHindi=lf==='hindi';
    const isCaps=!!opt.allCaps&&!isHindi;
    const displayText=isHindi?(opt.hindiText||l):(isCaps?l.toUpperCase():l);
    const ls=isCaps?'-0.05em':isHindi?'0.01em':'-0.03em';

    // global 999 icon row — left side (kept, not per-chip)
    const lineAlign999=(opt.align||'center');
    const jc=lineAlign999==='left'?'flex-start':lineAlign999==='right'?'flex-end':'center';
    const row=document.createElement('div');
    row.style.cssText='display:flex;align-items:baseline;justify-content:'+jc+';gap:8px;';
    // per-line icon left side (uploaded)
    if(opt.iconKey&&opt.iconSide!=='right'){
      const ic=document.createElement('img');
      ic.src=opt.iconKey;ic.alt='';
      const _cis=Math.min(opt.iconSize||uniformFs999, uniformFs999);
      const _cap=Math.round(_cis*0.82);
      const _rot=opt.iconRotation||0;
      ic.style.cssText='width:auto;height:'+_cap+'px;max-width:'+Math.round(_cap*1.8)+'px;object-fit:contain;flex-shrink:0;display:block;transform:rotate('+_rot+'deg);filter:'+ntIconFilter(c.fc||'#3d2b1a')+';';
      row.appendChild(ic);
    }

    const sp=document.createElement('span');
    sp.className='tl '+(isHindi?'hindi':getFont4Cls(false,lf)||'sans');
    sp.style.color=c.fc;
    sp.style.letterSpacing=ls;
    sp.style.webkitTextStroke='';sp.style.textShadow='0 0 0.5px rgba(0,0,0,0.8)';
    sp.style.lineHeight='0.75';
    // Wide line: use its per-line pre-calculated font size
    const isWide = !!(opt.wide && ntWideEligible(i, lines));
    const fs999 = isWide ? (perLineFontSize999[i]||uniformFs999) : uniformFs999;
    sp.style.fontSize=fs999+'px';
    // icon-only: if line is empty but has an icon, don't render text span
    if(!displayText && opt.iconKey){ row.appendChild(sp); block999.appendChild(row); return; }
    if(!displayText && !opt.iconKey) return; // skip empty line with no icon

    // descender/matra check — bottom line only
    const isBottom=isBottomLine(i);
    if(isBottom&&isHindi){
      const matraResult=checkHindiMatras(displayText);
      if(matraResult==='shorten'){
        sp.style.transform='scale(0.88) translateY(-4px)';
        sp.style.transformOrigin='center bottom';
        sp.style.display='inline-block';
      }
      sp.textContent=displayText;
    } else {
      sp.textContent=displayText;
    }

    row.appendChild(sp);

    // per-line icon right side (uploaded)
    if(opt.iconKey&&opt.iconSide==='right'){
      const ic=document.createElement('img');
      ic.src=opt.iconKey;ic.alt='';
      const _cis2=Math.min(opt.iconSize||uniformFs999, uniformFs999);
      const _cap2=Math.round(_cis2*0.82);
      const _rot2=opt.iconRotation||0;const _flip2=opt.iconFlip?'scaleX(-1)':'';
      ic.style.cssText='width:auto;height:'+_cap2+'px;max-width:'+Math.round(_cap2*1.8)+'px;object-fit:contain;flex-shrink:0;display:block;transform:rotate('+_rot2+'deg) '+_flip2+';filter:'+ntIconFilter(c.fc||'#3d2b1a')+';';
    }

    block999.appendChild(row);
  });
  p.appendChild(block999);
  const bg=document.getElementById('pieceBg');if(bg){bg.innerHTML='';bg.appendChild(p);}
}

function setFont(f){
  selFont=f;window.selFont=f;
  window._fontManuallySet=true;
  ['sans','serif','script'].forEach(x=>{const el=document.getElementById('fo-'+x);if(el)el.classList.toggle('on',x===f);});
  // Hide Hindi button and hint
  var hindiBtn999=document.getElementById('fo-hindi');if(hindiBtn999)hindiBtn999.style.display='none';
  var hint=document.getElementById('hindiHint');if(hint)hint.style.display='none';
  var hintS4=document.getElementById('hindiHintS4');if(hintS4)hintS4.style.display='none';
  // global font change clears all per-line font overrides
  if(window.lineOpts)window.lineOpts.forEach(o=>{if(o){delete o.fontOverride;delete o.hindiText;}});
  if(window.s4LineOpts)window.s4LineOpts.forEach(o=>{if(o){delete o.fontOverride;delete o.hindiText;}});
  renderSimple();
  if(document.getElementById('lineReorderWrap')&&document.getElementById('lineReorderWrap').style.display!=='none'){
    renderLineChips();
  }
}

function renderPuThumb(){
  const t=document.getElementById('puThumb');if(!t)return;
  t.style.background='#fff';
  const allLines=[...curLines];
  if(!isNamed) allLines.push('Rahul'); // preview name
  const maxC=Math.max(...allLines.map(l=>(l||'').replace(/\s/g,'').length),1);
  const fs=Math.max(10,Math.min(18,Math.floor(72/maxC)));
  t.innerHTML=allLines.map(l=>{
    const sc=isSc(l);
    return `<span style="font-family:${sc?"'Pacifico',cursive":"'Poppins',sans-serif"};font-weight:${sc?400:900};font-size:${sc?fs-1:fs}px;color:#2a1a0e;line-height:1.15;text-align:center;display:block;width:100%;">${l}</span>`;
  }).join('');
}

function renderC3(){
  var _crow3=document.getElementById('crow3');if(!_crow3)return;
  var _c3=ntGetColors();if(selC3>=_c3.length)selC3=1;
  var _swBase3='display:block!important;width:26px!important;height:26px!important;min-width:26px;min-height:26px;border-radius:50%;cursor:pointer;flex-shrink:0;transition:transform .15s,border-color .15s;padding:0;margin:0;';
  _crow3.innerHTML=_c3.map((c,i)=>{
    var sel=i===selC3;
    var border=sel?'border:2.5px solid #3d2b1a!important;transform:scale(1.2);':'border:2px solid transparent;';
    var shadow=c.lt?'box-shadow:0 0 0 1px #c0b8ac;':'';
    return '<div style="'+_swBase3+border+shadow+'background:'+c.fc+';" onclick="pc3('+i+')" title="'+c.n+'"></div>';
  }).join('');
  var _lbl3=document.getElementById('ntColLabel3');if(_lbl3)_lbl3.textContent=_c3[selC3].n;
}
function pc3(i){selC3=i;window.selC3=i;renderSimple();renderC3();renderPuThumb();}

function renderTry(){
  const pool=cachedSugg.filter(s=>JSON.stringify(s.lines||s.ls)!==JSON.stringify(curLines)).slice(0,10);
  const scrollEls=[
    {el:document.getElementById('tryScroll'),compact:false},
    {el:document.getElementById('tryScrollNav'),compact:true}
  ];
  scrollEls.forEach(({el:scroll,compact})=>{
    if(!scroll)return;
    scroll.innerHTML='';
    pool.forEach(s=>{
      const lines=[...(s.lines||s.ls||[])];
      const displayPrice=s.price>=1299?1299:(s.price||s.pr||999);
      const d=document.createElement('div');
      if(compact){
        d.style.cssText='flex-shrink:0;background:#fff;border:1px solid var(--border);border-radius:8px;padding:6px 10px;cursor:pointer;min-width:80px;max-width:110px;';
        d.innerHTML=`<div style="font-size:11px;font-weight:700;color:var(--brown);line-height:1.3;">${lines.join(' ')}</div><div style="font-size:9px;color:var(--muted);margin-top:2px;">₹${displayPrice}</div>`;
      } else {
        d.className='nt-tcard';
        d.innerHTML=`<div class="ntcl">${lines.join(' ')}</div><div class="ntcm">₹${displayPrice}</div>`;
      }
      d.addEventListener('click',()=>goRender([...lines],displayPrice));
      scroll.appendChild(d);
    });
  });
}

function renderTry4(){
  const pool=cachedSugg.filter(s=>JSON.stringify(s.lines||s.ls)!==JSON.stringify(curLines)).slice(0,8);
  const scroll=document.getElementById('tryScroll4');
  if(!scroll)return;
  scroll.innerHTML='';
  pool.forEach(s=>{
    const lines=[...(s.lines||s.ls||[])]; // clone
    const d=document.createElement('div');d.className='nt-tcard';
    d.innerHTML=`<div class="ntcl">${lines.join(' ')}</div><div class="ntcm">₹1,299</div>`;
    d.addEventListener('click',()=>{curLines=[...lines];renderS4();});
    scroll.appendChild(d);
  });
}

function toggleLineReorder(){
  const wrap=document.getElementById('lineReorderWrap');
  const isVisible=wrap.style.display!=='none';
  if(isVisible){wrap.style.display='none';return;}
  wrap.style.display='block';
  window.lineOpts=curLines.map(()=>({font:''}));
  renderLineChips();
  renderSizeBar();
  wrap.scrollIntoView({behavior:'smooth',block:'center'});
}

// Per-line overrides: {fontOverride, iconKey, iconSide}
if(!window.lineOpts)window.lineOpts=[];

// ══════════════════════════════════════════════════════
// HINDI TRANSLITERATION + MATRA DETECTION
// ══════════════════════════════════════════════════════
const HINDI_LOWER_MATRAS=['\u0941','\u0942','\u0943','\u094D']; // ु ू ृ ्

async function transliterateToHindi(text){
  const sys=`You are a Hinglish transliteration expert for Indian wooden decor pieces.
Convert English text to Devanagari script — phonetic transliteration only, NOT translation.

CRITICAL: Transliterate how the word SOUNDS, do not change the meaning.
- "Another" → "अनदर" (NOT अदर, NOT एक और)
- "Level" → "लेवल"
- "Another Level" → "अनदर लेवल"
- "No Pain No Gain" → "नो पेन नो गेन"
- "Boss" → "बॉस" · "Mode" → "मोड" · "Life" → "लाइफ"
- "Lab" → "लैब" · "Code" → "कोड" · "Vibe" → "वाइब"
- Pure Hindi words keep natural spelling: chai→चाय · ghar→घर · dost→दोस्त · pyaar→प्यार
- Titles: Dr→डॉ · Mr→मिस्टर · CA→सीए · CS→सीएस · Prof→प्रोफ

Return ONLY the Devanagari text. No explanation, no quotes.`;
  try{
    const raw=await callAI(MODEL_SUGG,sys,`Transliterate: "${text}"`,60);
    return raw.trim().replace(/["""''*]/g,'');
  }catch(e){return text;}
}

function checkHindiMatras(text){
  // only call on bottom line — check if lower matras are balanced or clustered
  const chars=[...text];
  const positions=chars.map((c,i)=>HINDI_LOWER_MATRAS.includes(c)?i:-1).filter(i=>i>-1);
  if(positions.length===0)return'none';
  if(positions.length===1)return'shorten';
  const spread=(positions[positions.length-1]-positions[0])/chars.length;
  return spread>0.4?'balanced':'shorten';
}

function countHindiChars(text){
  let count=0;
  for(const ch of text){
    const code=ch.codePointAt(0);
    if((code>=0x0915&&code<=0x0939)||(code>=0x0905&&code<=0x0914))count++;
  }
  return count||[...(text||'').replace(/\s/g,'')].length;
}
// Strip emoji and non-engravable symbols
function stripEmoji(text){
  return (text||'')
    // Remove all emoji using Unicode property escape (covers all emoji)
    .replace(/\p{Emoji_Presentation}/gu,'')
    .replace(/\p{Extended_Pictographic}/gu,'')
    // Misc symbols, dingbats, variation selectors, zero-width joiners
    .replace(/[\u2600-\u27BF\uFE00-\uFEFF\u200D]/gu,'')
    // Emoji modifiers and regional indicators
    .replace(/[\uD83C][\uDF00-\uDFFF]/gu,'')
    .replace(/[\uD83D][\uDC00-\uDE4F]/gu,'')
    .replace(/[\uD83D][\uDE80-\uDEFF]/gu,'')
    .replace(/[\uD83E][\uDD00-\uDDFF]/gu,'')
    // Clean up double spaces left after removal
    .replace(/\s+/g,' ').trim();
}
function countAnyScript(text){
  // Grapheme-aware counter — works for Punjabi, Urdu, Bengali, any script
  if(typeof Intl!=='undefined'&&Intl.Segmenter){
    try{const seg=new Intl.Segmenter();return [...seg.segment((text||'').replace(/\s/g,''))].length;}catch(e){}
  }
  return [...(text||'').replace(/\s/g,'')].length;
}
function countChars(line){
  return countAnyScript(line);
}

function calcSizePrice(lines,isPersonal,opts){
  opts=opts||[];
  const nonEmptyLines=lines.filter(l=>(l||'').trim());
  let maxChars=0;
  nonEmptyLines.forEach((l,i)=>{
    let c=countChars(l);
    let iconBonus=0;
    // Chip icon — default = 1 char, doubled = 2 chars
    if((opts[i]||{}).iconKey){
      const defSz=uniformFs4||48;
      const sz=(opts[i]||{}).iconSize||defSz;
      iconBonus=Math.max(iconBonus, sz>=defSz*1.8?2:1);
    }
    // Overlay icon on letter — counts as 1
    const _il=window.ntLetterIcon;
    if(_il&&_il.active&&_il.line===i) iconBonus=Math.max(iconBonus,1);
    // Cap: at most one icon's worth per line (don't double-count chip + letter icon)
    c+=iconBonus;
    if(c>maxChars)maxChars=c;
  });
  const lineCount=nonEmptyLines.length;
  const buffer=lineCount===1?3:2;
  const effective=maxChars+buffer;
  const clampedLines=Math.min(lineCount,4);
  let inch=Math.max(isPersonal?8:6, effective);
  if(inch>24)inch=24;
  const base=isPersonal?1299:999;
  const anchor=inch;
  const extra=Math.max(0,inch-anchor)*100;
  const price=base+extra;
  return {inch,price,maxChars,lineCount:clampedLines,buffer,anchor};
}

// ══════════════════════════════════════════════════════
// WIDE LINE FEATURE
// ══════════════════════════════════════════════════════

// Check if a line is eligible for Wide toggle
// Rule: single word (no spaces), letter diff vs longest line is 2-6
function ntWideEligible(lineIdx, lines){
  const line = (lines[lineIdx]||'').trim();
  const words = line.split(/\s+/).filter(Boolean);
  if(words.length !== 1) return false; // must be single word
  const thisLetters = line.replace(/\s/g,'').length;
  if(thisLetters < 2) return false; // minimum 2 chars
  const longestLetters = Math.max(...lines.map(l=>(l||'').replace(/\s/g,'').length));
  if(thisLetters === longestLetters) return false; // can't be the longest line itself
  const diff = longestLetters - thisLetters;
  return diff >= 1; // no upper cap — font size max (96px) handles visual constraint
}

// Get Wide charge for a line: diff 2-3 = ₹100, diff 4-6 = ₹200
function ntWideCharge(lineIdx, lines){
  const thisLetters = (lines[lineIdx]||'').replace(/\s/g,'').length;
  const longestLetters = Math.max(...lines.map(l=>(l||'').replace(/\s/g,'').length));
  const diff = longestLetters - thisLetters;
  return diff >= 4 ? 200 : 100;
}

// Calculate total wide extra from lineOpts
function ntIconColourExtra(lineOpts, nameLineOpts, textColour){
  // Count lines with custom icon colour different from text colour — ₹500 each, max ₹2000
  var count=0;
  var allOpts=(lineOpts||[]).concat(nameLineOpts||[]);
  allOpts.forEach(function(o){
    if(o&&o.iconKey&&o.iconColour&&o.iconColour!==textColour)count++;
  });
  // Top icon custom colour
  var ti=window.s4TopIcon||{};
  if(ti.iconKey&&ti.iconColour&&ti.iconColour!==textColour)count++;
  return Math.min(count,4)*500;
}
function ntWideExtra(lines, opts){
  let total = 0;
  (opts||[]).forEach((opt,i)=>{
    if(opt && opt.wide && ntWideEligible(i, lines)){
      total += ntWideCharge(i, lines);
    }
  });
  return total;
}

// Suggest cheapest possible split (up to 4 lines total)
function suggestSplit(allLines, curPriceOverride, opts){}

function renderSizeBar(){
  const adjNameLines=(window.s4NameLines||[]).filter(Boolean);
  const allLines=isNamed?[...curLines,...adjNameLines]:curLines;
  const allOpts=isNamed?[...(window.lineOpts||[]),...(window.s4NameLineOpts||[]).slice(0,adjNameLines.length)]:(window.lineOpts||[]);
  const {inch,price,maxChars,lineCount}=calcSizePrice(allLines,isNamed,allOpts);
  const nonEmpty=curLines.filter(l=>(l||'').trim());
  const prevPrice=curPrice;
  curPrice=price;

  const totalLines=curLines.length+adjNameLines.length;
  const lineBase=isNamed?(totalLines>=4?1399:1299):999;
  const displayInch=customSizeOverride||inch;
  const sizeExtra=Math.max(0,displayInch-inch)*100;
  const wideExtra=ntWideExtra(curLines, window.lineOpts||[]);
  const fullPrice=lineBase+sizeExtra+wideExtra;
  const btn=document.getElementById('commBtn');
  if(btn)btn.textContent=`${(window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.txt&&window.NUKKAD_CONFIG.txt.commLabel)||'Add to Cart'} · ₹${fullPrice.toLocaleString("en-IN")}`;

  if(isNamed){
    updateSizeDisplayS4(inch);
  }

  const aiDisp=document.getElementById('sizeAiDisplay');
  if(aiDisp)aiDisp.textContent=inch;
  const szCur=document.getElementById('sizeCurrent');
  if(szCur)szCur.textContent=displayInch;
  const sizeExtraBar=document.getElementById('sizeExtraBar');
  const sizeExtraAmt=document.getElementById('sizeExtraAmt');
  if(sizeExtraBar)sizeExtraBar.style.display=sizeExtra>0?'flex':'none';
  if(sizeExtraAmt)sizeExtraAmt.textContent='+₹'+sizeExtra;
  const sizeInfoRender=document.getElementById('sizeInfoTextRender');
  if(sizeInfoRender){
    const desc={6:'compact and precise',7:'desk or shelf',8:'desk or shelf · comfortable reading size',9:'desk or shelf · slightly bolder',10:'sideboard or console',11:'sideboard or console · makes a statement',12:'wall piece · bold from a distance',13:'wall piece · strong anchor',14:'large wall',15:'large wall · statement piece',16:'feature wall',18:'gallery wall',20:'large installation'};
    const placeTxt=desc[displayInch]||(displayInch>20?'extra large custom piece':'bold statement piece');
    const letterTxt=maxChars>0?`${maxChars} letters · needs ${displayInch}" to be readable`:'';
    sizeInfoRender.innerHTML=placeTxt+(letterTxt?`<br><span style="font-weight:600;color:var(--muted);">${letterTxt}</span>`:'');
  }
  updateSizeDisplay(inch,isNamed);

  const rbar=document.getElementById('sizeInfoBarRender');if(rbar)rbar.style.display='none';
  const bar=document.getElementById('sizeInfoBar');
  const txt=document.getElementById('sizeInfoText');
  if(!bar||!txt)return;
  const priceChanged=prevPrice&&prevPrice!==price;
  const isUpgrade=sizeExtra>0;
  const diffNote=sizeExtra>0?` <span style="color:var(--orange);font-weight:700;">+ ₹${sizeExtra} for size</span>`:'';

  let savingsTip='';
  if(sizeExtra>0||inch>9){
    const split=(typeof window.suggestSplit==='function'?window.suggestSplit:suggestSplit)(allLines);
    if(split&&split.save>=100){
      var _longest=allLines.reduce(function(a,b){return b.replace(/\s/g,'').length>a.replace(/\s/g,'').length?b:a;},'');
      savingsTip='<div style="background:#fff;border:1px solid #d0e8d4;border-radius:8px;padding:8px 11px;margin-top:8px;display:flex;align-items:flex-start;gap:7px;"><span style="font-size:13px;flex-shrink:0;">💡</span><div><div style="font-size:15px;font-weight:900;color:#2d7d46;margin-bottom:2px;">Save ₹'+split.save.toLocaleString('en-IN')+'</div><div style="font-size:10px;color:#3d2b1a;line-height:1.5;">Split <b>'+_longest+'</b> into 2 lines · tap chip above and use break</div></div></div>';
    }
  }

  const subLine999=maxChars>0?(maxChars+' letters on longest line · needs '+displayInch+'" to be readable'):(displayInch+'" · go bigger for more impact');
  const extraBadge=sizeExtra>0?(' <span style="font-size:11px;color:#c47a45;">+₹'+sizeExtra+'</span>'):'';
  txt.innerHTML='<div style="font-family:Poppins,sans-serif;font-weight:900;font-size:13px;color:#3d2b1a;margin-bottom:3px;">'+displayInch+'" piece · ₹'+lineBase.toLocaleString('en-IN')+extraBadge+'</div><div style="font-size:10px;color:#8a6848;line-height:1.5;">'+subLine999+'</div>'+savingsTip;
  bar.style.cssText='display:block;margin-bottom:10px;background:#f5ede0;border:1px solid #e0c9b2;border-radius:10px;padding:10px 14px;';
}

function applySavingsSplit(newParts){
  const adjNameLines=(window.s4NameLines||[]).filter(Boolean);
  const allLines=isNamed?[...curLines,...adjNameLines]:curLines;
  const longest=allLines.reduce((a,b)=>b.replace(/\s/g,'').length>a.replace(/\s/g,'').length?b:a,'');
  const idx=curLines.indexOf(longest);
  if(idx>=0){
    curLines.splice(idx,1,...newParts);
    if(window.lineOpts)window.lineOpts.splice(idx,0,...newParts.slice(1).map(()=>({})));
  }
  customSizeOverride=null;
  renderSimple();renderPuThumb();renderLineChips();renderSizeBar();
}

// ══════════════════════════════════════════════════════
// DESCENDER DETECTION
// ══════════════════════════════════════════════════════
const DESCENDERS='pgyqj';

function checkDescenders(word){
  const w=(word||'').replace(/\s/g,'');
  const positions=[...w].map((c,i)=>DESCENDERS.includes(c)?i:-1).filter(i=>i>-1);
  if(positions.length===0)return'none';
  if(positions.length===1)return'shorten';
  const spread=(positions[positions.length-1]-positions[0])/w.length;
  return spread>0.4?'balanced':'shorten';
}

function applyDescenderFix(container,text){
  for(const ch of text){
    if(DESCENDERS.includes(ch)){
      const sp=document.createElement('span');
      sp.textContent=ch;
      sp.style.cssText='display:inline-block;transform:translateY(-5px);transform-origin:center bottom;';
      sp.title='Descender adjusted for table placement';
      container.appendChild(sp);
    } else {
      container.appendChild(document.createTextNode(ch));
    }
  }
}

// ══════════════════════════════════════════════════════
// BREAK / MERGE
// ══════════════════════════════════════════════════════
function breakLine(i){
  // Don't break if already at 4 lines
  var _tiCap=!!(window.s4TopIcon&&window.s4TopIcon.iconKey)?1:0;
  if(curLines.length+_tiCap>=4){
    if(typeof window.ntShowLineCap==='function')window.ntShowLineCap(_tiCap?'Max 3 lines with top icon — remove top icon to add more':'Max 4 lines reached');
    return;
  }
  const line=curLines[i];
  const opt=window.lineOpts[i]||{};
  const words=line.trim().split(/\s+/);
  const hindiWords=opt.hindiText?(opt.hindiText.trim().split(/\s+/)):null;

  if(words.length<2){
    const mid=Math.ceil(line.length/2);
    const a=line.slice(0,mid).trim();const b=line.slice(mid).trim();
    if(!a||!b)return;
    const nl=[...curLines];nl.splice(i,1,a,b);
    const optA={...opt,hindiText:undefined};
    const no=[...window.lineOpts];no.splice(i,1,optA,{fontOverride:opt.fontOverride});
    curLines=nl;window.lineOpts=no;
  } else {
    const mid=Math.ceil(words.length/2);
    const a=words.slice(0,mid).join(' ');const b=words.slice(mid).join(' ');
    const nl=[...curLines];nl.splice(i,1,a,b);
    const hA=hindiWords?hindiWords.slice(0,mid).join(' '):undefined;
    const hB=hindiWords?hindiWords.slice(mid).join(' '):undefined;
    const optA={...opt,hindiText:hA||undefined};
    const optB={fontOverride:opt.fontOverride,hindiText:hB||undefined};
    const no=[...window.lineOpts];no.splice(i,1,optA,optB);
    curLines=nl;window.lineOpts=no;
  }renderSimple();renderPuThumb();renderLineChips();renderSizeBar();
}

function mergeLine(i){
  if(i>=curLines.length-1)return;
  const merged=(curLines[i]+' '+curLines[i+1]).trim();
  const nl=[...curLines];nl.splice(i,2,merged);
  const optA=window.lineOpts[i]||{};
  const optB=window.lineOpts[i+1]||{};
  const mergedHindi=(optA.hindiText&&optB.hindiText)?(optA.hindiText+' '+optB.hindiText).trim():undefined;
  const no=[...window.lineOpts];no.splice(i,2,{...optA,hindiText:mergedHindi});
  curLines=nl;window.lineOpts=no;renderSimple();renderPuThumb();renderLineChips();renderSizeBar();
}

// ── UPLOADED ICON PICKER ──────────────────────────────
function ntMakeIconPicker(getKey, setKey, getSizeOpts, setSizeOpts, onClose, lineWordCount){
  const icons = window.NT_CUSTOM_ICONS || [];
  const picker = document.createElement('div');
  picker.style.cssText = 'display:none;position:absolute;right:0;top:110%;z-index:300;background:#fff;border:1.5px solid var(--border);border-radius:10px;padding:12px;box-shadow:0 6px 24px rgba(0,0,0,.15);min-width:240px;';
  picker.addEventListener('click', e=>{ e.stopPropagation(); });

  // ── Header with X close button ──────────────────────
  const pickerHdr=document.createElement('div');
  pickerHdr.style.cssText='display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;';
  const pickerHdrLbl=document.createElement('span');
  pickerHdrLbl.style.cssText='font-size:11px;font-weight:700;color:var(--brown);';
  pickerHdrLbl.textContent='Pick icon';
  const closeBtn=document.createElement('button');
  closeBtn.style.cssText='background:none;border:none;font-size:15px;color:var(--muted);cursor:pointer;line-height:1;padding:2px 4px;flex-shrink:0;';
  closeBtn.textContent='✕';
  closeBtn.addEventListener('click',e=>{
    e.stopPropagation();
    picker.style.display='none';
    picker.classList.remove('lc-open-picker');
    if(onClose)onClose();
  });
  pickerHdr.appendChild(pickerHdrLbl);
  pickerHdr.appendChild(closeBtn);
  picker.appendChild(pickerHdr);

  if(!icons.length){
    const emptyDiv=document.createElement('div');
    emptyDiv.innerHTML=`<div style="font-size:12px;font-weight:700;color:var(--brown);margin-bottom:6px;">Add icons first</div>
      <div style="font-size:11px;color:var(--muted);line-height:1.7;margin-bottom:10px;">
        Go to:<br>
        <b>Shopify Admin → Online Store<br>→ Themes → Customize</b><br>
        Find <b>Nukkad Customiser</b> section<br>
        → Add block → <b>Custom icon</b><br>
        Upload your PNG/SVG there.
      </div>
      <div style="font-size:10px;color:var(--light);">Icons appear here after saving.</div>`;
    picker.appendChild(emptyDiv);
    return picker;
  }

  // None button
  const noneBtn = document.createElement('button');
  noneBtn.className = 'line-chip-btn' + (!getKey() ? ' on' : '');
  noneBtn.style.cssText = 'font-size:10px;padding:3px 10px;margin-bottom:8px;';
  noneBtn.textContent = '✕ No icon';
  noneBtn.addEventListener('click', e => {
    e.stopPropagation();
    setKey('');
    noneBtn.className='line-chip-btn on';
    picker.querySelectorAll('.ic-sel-btn').forEach(b=>b.classList.remove('on'));
    picker.querySelectorAll('.ic-tick').forEach(t=>t.remove());
    updateControls();
  });
  picker.appendChild(noneBtn);

  // Icon grid
  const grid = document.createElement('div');
  grid.style.cssText = 'display:grid;grid-template-columns:repeat(auto-fill,minmax(58px,1fr));gap:5px;margin-bottom:10px;overflow-y:auto;max-height:200px;';
  icons.forEach(ic => {
    const btn = document.createElement('button');
    btn.className = 'line-chip-btn ic-sel-btn' + (getKey() === ic.src ? ' on' : '');
    btn.style.cssText = 'padding:4px;display:flex;flex-direction:column;align-items:center;gap:3px;min-width:44px;position:relative;';
    btn.innerHTML = `<img src="${ic.src}" style="width:34px;height:34px;object-fit:contain;" alt="${ic.label}"><span style="font-size:8px;color:var(--muted);width:100%;text-align:center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${ic.label}</span>`;
    if(getKey()===ic.src){
      const initTick=document.createElement('div');initTick.className='ic-tick';
      initTick.style.cssText='position:absolute;top:2px;right:2px;background:var(--orange);color:#fff;border-radius:50%;width:14px;height:14px;font-size:9px;display:flex;align-items:center;justify-content:center;font-weight:700;pointer-events:none;';
      initTick.textContent='✓';btn.appendChild(initTick);
    }
    btn.addEventListener('click', e => {
      e.stopPropagation();
      setKey(ic.src);
      picker.querySelectorAll('.ic-sel-btn').forEach(b=>{b.classList.remove('on');b.querySelectorAll('.ic-tick').forEach(t=>t.remove());});
      btn.classList.add('on');
      noneBtn.className='line-chip-btn';
      const tick=document.createElement('div');
      tick.className='ic-tick';
      tick.style.cssText='position:absolute;top:2px;right:2px;background:var(--orange);color:#fff;border-radius:50%;width:14px;height:14px;font-size:9px;display:flex;align-items:center;justify-content:center;font-weight:700;pointer-events:none;';
      tick.textContent='✓';
      btn.appendChild(tick);
      updateControls();
    });
    grid.appendChild(btn);
  });
  picker.appendChild(grid);

  // ── Controls — always visible, dimmed when no icon ──
  const controlsWrap=document.createElement('div');
  controlsWrap.style.cssText='border-top:1px solid var(--border);padding-top:8px;display:flex;flex-direction:column;gap:8px;transition:opacity .15s;';

  // 1. POSITION row (Left / Center / Right)
  // Center only shown when line has 2+ words
  const posRow=document.createElement('div');
  posRow.style.cssText='display:flex;align-items:center;gap:4px;';
  const posLbl=document.createElement('span');
  posLbl.textContent='Position';
  posLbl.style.cssText='font-size:10px;font-weight:700;color:var(--brown);flex-shrink:0;min-width:56px;';
  posRow.appendChild(posLbl);
  const showCenter=(lineWordCount||0)>=2;
  const posConfig=showCenter?[['left','← Left'],['center','· Center'],['right','Right →']]:[['left','← Left'],['right','Right →']];
  posConfig.forEach(([pos,label])=>{
    const pb=document.createElement('button');
    pb.className='line-chip-btn'+((getSizeOpts().iconSide||'left')===pos?' on':'');
    pb.textContent=label;
    pb.style.cssText='font-size:10px;flex:1;';
    pb.dataset.posBtn=pos;
    pb.addEventListener('click',e=>{
      e.stopPropagation();
      setSizeOpts({...getSizeOpts(),iconSide:pos});
      posRow.querySelectorAll('[data-pos-btn]').forEach(b=>b.classList.remove('on'));
      pb.classList.add('on');
    });
    posRow.appendChild(pb);
  });
  controlsWrap.appendChild(posRow);

  // 2. ROTATE row
  const rotRow=document.createElement('div');
  rotRow.style.cssText='display:flex;align-items:center;gap:4px;';
  const rotLbl=document.createElement('span');rotLbl.textContent='Rotate';rotLbl.style.cssText='font-size:10px;font-weight:700;color:var(--brown);flex-shrink:0;min-width:56px;';
  const rotCCBtn=document.createElement('button');rotCCBtn.className='line-chip-btn';rotCCBtn.textContent='↺ Left';rotCCBtn.style.cssText='font-size:10px;flex:1;';
  const rotNum=document.createElement('span');rotNum.style.cssText='font-size:12px;font-weight:700;color:var(--orange);min-width:32px;text-align:center;background:#fff8f3;border-radius:6px;padding:2px 4px;';
  rotNum.textContent=(getSizeOpts().iconRotation||0)+'°';
  const rotBtn=document.createElement('button');rotBtn.className='line-chip-btn';rotBtn.textContent='Right ↻';rotBtn.style.cssText='font-size:10px;flex:1;';
  rotCCBtn.addEventListener('click',e=>{
    e.stopPropagation();
    const next=((getSizeOpts().iconRotation||0)-5+360)%360;
    setSizeOpts({...getSizeOpts(),iconRotation:next});
    rotNum.textContent=next+'°';
  });
  rotBtn.addEventListener('click',e=>{
    e.stopPropagation();
    const next=((getSizeOpts().iconRotation||0)+5)%360;
    setSizeOpts({...getSizeOpts(),iconRotation:next});
    rotNum.textContent=next+'°';
  });
  rotRow.appendChild(rotLbl);rotRow.appendChild(rotCCBtn);rotRow.appendChild(rotNum);rotRow.appendChild(rotBtn);
  controlsWrap.appendChild(rotRow);

  picker.appendChild(controlsWrap);

  function updateControls(){
    const hasIcon=!!getKey();
    controlsWrap.style.opacity=hasIcon?'1':'0.35';
    controlsWrap.style.pointerEvents=hasIcon?'':'none';
    rotNum.textContent=(getSizeOpts().iconRotation||0)+'°';
    posRow.querySelectorAll('[data-pos-btn]').forEach(b=>{
      b.classList.toggle('on',(getSizeOpts().iconSide||'left')===b.dataset.posBtn);
    });
  }
  updateControls();

  return picker;
}

// Returns true if icons are available — used to conditionally show icon button
function ntHasIcons(){ return !!(window.NT_CUSTOM_ICONS && window.NT_CUSTOM_ICONS.length); }

// ══════════════════════════════════════════════════════
// RENDER LINE CHIPS
// ══════════════════════════════════════════════════════
// ── ICON LINE CHIP ──────────────────────────────────
// Standalone icon at top of design — counts as a line
window.ntIconLine = window.ntIconLine || {active:false, iconKey:'', rotation:0, side:'center'};

function ntRenderIconLineChip(container){
  const icons = window.NT_CUSTOM_ICONS||[];
  const il = window.ntIconLine;

  const chip = document.createElement('div');
  chip.className = 'line-chip';
  chip.style.cssText = 'border:1.5px solid '+(il.active?'var(--orange)':'var(--border)')+';background:'+(il.active?'#fff8f3':'#fff')+';';

  // Left: icon preview or placeholder
  const iconPreview = document.createElement('div');
  iconPreview.style.cssText = 'width:28px;height:28px;display:flex;align-items:center;justify-content:center;flex-shrink:0;';
  if(il.active && il.iconKey){
    const img = document.createElement('img');
    img.src = il.iconKey;
    img.style.cssText = 'width:24px;height:24px;object-fit:contain;transform:rotate('+il.rotation+'deg);';
    iconPreview.appendChild(img);
  } else {
    iconPreview.style.cssText += 'font-size:16px;';
    iconPreview.textContent = '★';
  }
  chip.appendChild(iconPreview);

  // Label
  const lbl = document.createElement('span');
  lbl.style.cssText = 'flex:1;font-size:11px;font-weight:700;color:var(--brown);';
  lbl.textContent = il.active ? '' : 'Select icon';
  chip.appendChild(lbl);

  // Controls (only when active)
  if(il.active){
    // Position removed - rotation only

    // Rotate button
    const rotBtn = document.createElement('button');
    rotBtn.className = 'line-chip-btn';
    rotBtn.textContent = 'Turn ↻';
    rotBtn.title = 'Rotate 5°';
    rotBtn.style.cssText = 'padding:2px 7px;font-size:13px;';
    rotBtn.addEventListener('click',function(e){
      e.stopPropagation();
      window.ntIconLine.rotation = (window.ntIconLine.rotation + 5) % 360;
      ntIconLineRender();
      renderLineChips();
    });
    chip.appendChild(rotBtn);

    // Change icon button
    const changeBtn = document.createElement('button');
    changeBtn.className = 'line-chip-btn on';
    changeBtn.textContent = 'Change';
    changeBtn.style.cssText = 'padding:2px 7px;font-size:10px;';
    changeBtn.addEventListener('click',function(e){
      e.stopPropagation();
      ntOpenIconLinePicker();
    });
    chip.appendChild(changeBtn);

    // Remove button
    const removeBtn = document.createElement('button');
    removeBtn.className = 'line-chip-btn';
    removeBtn.textContent = '✕';
    removeBtn.style.cssText = 'font-size:10px;color:var(--muted);border-color:transparent;background:transparent;padding:2px 5px;';
    removeBtn.addEventListener('click',function(e){
      e.stopPropagation();
      window.ntIconLine = {active:false, iconKey:'', rotation:0, side:'center'};
      ntIconLineRender();
      renderLineChips();
      renderSimple();
    });
    chip.appendChild(removeBtn);
  } else {
    // Click to open picker
    chip.style.cursor = 'pointer';
    chip.addEventListener('click', function(){ ntOpenIconLinePicker(); });
  }

  container.appendChild(chip);

  // Merge zone placeholder (non-interactive)
  const mz = document.createElement('div');
  mz.style.cssText = 'height:6px;';
  container.appendChild(mz);
}

function ntOpenIconLinePicker(){
  const icons = window.NT_CUSTOM_ICONS||[];
  if(!icons.length){ alert('Add icons in Theme Customiser → Nukkad Customiser → icon names field'); return; }

  // Reuse existing icon letter sheet UI
  const grid = document.getElementById('ntILIconTiles');
  if(!grid) return;
  grid.innerHTML = '';
  icons.forEach(function(ic){
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.style.cssText = 'display:flex;flex-direction:column;align-items:center;gap:4px;padding:8px 6px;border:1.5px solid #e0c9b2;border-radius:12px;background:#fff;cursor:pointer;min-width:56px;transition:all .15s;';
    if(window.ntIconLine.iconKey === ic.src) btn.style.borderColor = '#c47a45';
    btn.innerHTML = '<img src="'+ic.src+'" style="width:32px;height:32px;object-fit:contain;" alt="'+ic.label+'"><span style="font-size:9px;color:#a07850;">'+ic.label+'</span>';
    btn.addEventListener('click', function(){
      grid.querySelectorAll('button').forEach(function(b){ b.style.borderColor='#e0c9b2'; });
      btn.style.borderColor = '#c47a45';
      window.ntIconLine = {active:true, iconKey:ic.src, rotation:window.ntIconLine.rotation||0, side:window.ntIconLine.side||'center'};
      ntIconLineRender();
      renderLineChips();
      renderSimple();
      // Close after short delay so user sees selection
      setTimeout(function(){
        if(typeof ntCloseIconLetter==='function') ntCloseIconLetter();
      }, 600);
    });
    grid.appendChild(btn);
  });

  // Open the sheet
  const sheet = document.getElementById('ntIconLetterSheet');
  const bd = document.getElementById('ntIconLetterBackdrop');
  if(sheet){ sheet.style.display='flex'; setTimeout(function(){ sheet.style.transform='translate(-50%,-50%)'; sheet.style.opacity='1'; },10); }
  if(bd) bd.style.display='block';
}

function ntIconLineRender(){
  // Re-renders the canvas to include icon line at top
  if(typeof renderSimple==='function') renderSimple();
}

function renderLineChips(){
  const container=document.getElementById('lineReorderChips');
  container.innerHTML='';
  while(window.lineOpts.length<curLines.length)window.lineOpts.push({});
  window.lineOpts=window.lineOpts.slice(0,curLines.length);
  let dragSrc=null;
let dragSrc4=null;
  const fonts=['sans','serif','script','hindi'];
  const fontLabels={'sans':'Bold','serif':'Serif','script':'Script','hindi':'हि Hindi'};

  // ── ICON LINE CHIP (top) ──────────────────────────────
  try { ntRenderIconLineChip(container); } catch(e){ console.warn('[IconLineChip]',e); }

  curLines.forEach((line,i)=>{
    const opt=window.lineOpts[i]||{};
    const isCaps=!!opt.allCaps;

    const chip=document.createElement('div');
    chip.className='line-chip';chip.draggable=true;chip.dataset.index=i;

    const handle=document.createElement('span');
    handle.className='line-chip-handle';handle.textContent='⠿';

    const textSpan=document.createElement('span');
    textSpan.className='line-chip-text';
    textSpan.textContent=isCaps?line.toUpperCase():line;
    textSpan.style.letterSpacing=isCaps?'-0.05em':'-0.02em';

    const textInp=document.createElement('input');
    textInp.className='line-chip-inp';textInp.value=line;textInp.style.display='none';

    const charCount=document.createElement('span');
    charCount.style.cssText='font-size:9px;color:var(--light);flex-shrink:0;display:none;margin-right:2px;transition:color .15s;';
    const updateCharCount=()=>{
      const n=(textInp.value||'').replace(/\s/g,'').length;
      charCount.textContent=n+'L';
      charCount.style.color=n>9?'var(--orange)':n>7?'#b09a88':'var(--light)';
    };
    textInp.addEventListener('input',()=>{updateCharCount();renderSimple();renderSizeBar();});
    ntNoEmoji(textInp);

    const commitEdit=(val)=>{
      val=stripEmoji(val).trim();
      charCount.style.display='none';
      if(!val){
        curLines.splice(i,1);window.lineOpts.splice(i,1);
      } else {
        curLines[i]=val;
        // Auto-detect Devanagari typed directly in chip
        if(isDevanagari(val)){
          if(!window.lineOpts[i])window.lineOpts[i]={};
          window.lineOpts[i].hindiText=val;
          if(selFont!=='hindi'){selFont='hindi';['sans','serif','script','hindi'].forEach(x=>{const el=document.getElementById('fo-'+x);if(el)el.classList.toggle('on',x==='hindi');});}
          var hint=document.getElementById('hindiHint');if(hint)hint.style.display='block';
        }
        if(!isNamed&&quickDetect(curLines.join(' '))){
          isNamed=true;
          const tb=document.getElementById('tierBadge');
          if(tb){
            document.getElementById('tbPrice').textContent='₹1,299';
            const _tbr=document.getElementById('tbReason');if(_tbr)_tbr.textContent='Personalised piece';
            tb.classList.add('show');
          }
        }
      }renderSimple();renderPuThumb();renderLineChips();renderSizeBar();
    };
    textInp.addEventListener('focus',()=>{charCount.style.display='inline';updateCharCount();});
    textInp.addEventListener('keydown',e=>{
      if(e.key==='Enter'){commitEdit(textInp.value);e.preventDefault();}
      if(e.key==='Escape'){charCount.style.display='none';textSpan.style.display='';textInp.style.display='none';chip.draggable=true;}
    });
    textInp.addEventListener('blur',()=>commitEdit(textInp.value));

    const curFont=opt.fontOverride||'';
    const fontLabels999={'serif':'Classic','pacifico':'Flowing','lobster':'Casual','amaranth':'Rounded','montserrat':'Bold','teko':'Impact','comic':'Quirky'};
    const fBtn=document.createElement('button');
    fBtn.className='line-chip-btn'+(curFont?' on':'');
    if(curFont)fBtn.style.cssText='font-size:10px;font-weight:700;white-space:nowrap;flex-shrink:0;position:relative;';
    else fBtn.style.cssText='font-size:10px;white-space:nowrap;flex-shrink:0;position:relative;';
    const fBtnLbl=document.createElement('span');
    fBtnLbl.textContent=curFont?(fontLabels999[curFont]||'Font'):'Choose a font';
    fBtn.appendChild(fBtnLbl);
    const fPop=document.createElement('div');
    fPop.style.cssText='display:none;position:fixed;z-index:2147483500;background:#fff;border:1.5px solid var(--border);border-radius:10px;padding:8px;box-shadow:0 6px 24px rgba(0,0,0,.15);min-width:160px;max-height:60vh;overflow-y:auto;';
    [['montserrat','Aa','Bold'],['serif','Aa','Classic'],['pacifico','Aa','Flowing'],['lobster','Aa','Casual'],['amaranth','Aa','Rounded'],['teko','Aa','Impact'],['comic','Aa','Quirky'],['andalusia','Aa','Script'],['recoleta','Aa','Recoleta']].forEach(([v,abbr,label])=>{
      const row=document.createElement('button');
      const isA=curFont===v;
      row.style.cssText='display:flex;align-items:center;gap:8px;width:100%;border:none;background:'+(isA?'#fff8f3':'transparent')+';border-radius:6px;padding:6px 8px;cursor:pointer;';
      const samp=document.createElement('span');
      samp.textContent='Aa';
      const _fMap={'serif':"'Playfair Display',serif",'pacifico':"'Pacifico',cursive",'great-vibes':"'Great Vibes',cursive",'lobster':"'Lobster',cursive",'andalusia':"'Andalusia',cursive",'recoleta':"'Recoleta',serif",'amaranth':"'Amaranth',sans-serif",'montserrat':"'Montserrat',sans-serif",'teko':"'Teko',sans-serif",'comic':"'Comic Neue',cursive"};
      samp.style.cssText='font-size:14px;font-weight:700;width:28px;text-align:center;color:'+(isA?'var(--orange)':'var(--brown)')+';flex-shrink:0;font-family:'+(_fMap[v]||"'Poppins',sans-serif")+';';
      const name=document.createElement('span');
      name.textContent=label;
      name.style.cssText='font-size:11px;color:'+(isA?'var(--orange)':'var(--brown)')+';font-weight:'+(isA?'700':'400')+';';
      if(isA){const ck=document.createElement('span');ck.textContent='✓';ck.style.cssText='margin-left:auto;color:var(--orange);font-size:11px;';row.appendChild(samp);row.appendChild(name);row.appendChild(ck);}
      else{row.appendChild(samp);row.appendChild(name);}
      row.addEventListener('click',e=>{
        e.stopPropagation();
        const next=curFont===v?'':v;
        if(!window.lineOpts[i])window.lineOpts[i]={};
        if(next){window.lineOpts[i].fontOverride=next;}
        else{delete window.lineOpts[i].fontOverride;}
        window.lineOpts[i].font=next;
        fPop.style.display='none';
        if(next){window.lineOpts[i].fontOverride=next;}
        else{delete window.lineOpts[i].fontOverride;delete window.lineOpts[i].hindiText;}
        renderSimple();renderSizeBar();renderLineChips();
        ntRefreshHindiHint();
      });
      fPop.appendChild(row);
    });
    fBtn.addEventListener('click',e=>{
  e.stopPropagation();
  if(fPop.style.display!=='none'){fPop.style.display='none';return;}
  document.querySelectorAll('.nt-font-pop-open').forEach(function(p){p.style.display='none';p.classList.remove('nt-font-pop-open');});
  var _r=fBtn.getBoundingClientRect();
  fPop.style.top=(_r.bottom+4)+'px';
  fPop.style.left=Math.max(4,_r.left-80)+'px';
  fPop.style.display='block';
  fPop.classList.add('nt-font-pop-open');
  document.body.appendChild(fPop);
  setTimeout(function(){
    function _close(ev){if(!fPop.contains(ev.target)&&ev.target!==fBtn){fPop.style.display='none';fPop.classList.remove('nt-font-pop-open');document.removeEventListener('click',_close);}};
    document.addEventListener('click',_close);
  },0);
});

    const breakBtn=document.createElement('button');
    breakBtn.className='line-chip-btn';breakBtn.textContent='⇥';breakBtn.title='Break into 2 lines';
    const wordCount=(line||'').trim().split(/\s+/).filter(Boolean).length;const _tiC=!!(window.s4TopIcon&&window.s4TopIcon.iconKey)?1:0;if(wordCount<2||curLines.length+_tiC>=4)breakBtn.style.display='none';
    breakBtn.addEventListener('click',e=>{e.stopPropagation();breakLine(i);});

    // Icon button — uses uploaded icons from NT_CUSTOM_ICONS
    const iconBtn=document.createElement('button');
    iconBtn.className='line-chip-btn'+(opt.iconKey?' on':'');
    iconBtn.style.cssText='position:relative;white-space:nowrap;flex-shrink:0;'+(ntHasIcons()?'':'opacity:0.55;');
    iconBtn.title=ntHasIcons()?'Add icon':'No icons yet — see Theme → Customise → Nukkad Customiser → Add block → Custom icon';
    if(opt.iconKey){
      const thumb=document.createElement('img');thumb.src=opt.iconKey;thumb.alt='';
      thumb.style.cssText='width:14px;height:14px;object-fit:contain;vertical-align:middle;margin-right:3px;';
      iconBtn.innerHTML='';iconBtn.appendChild(thumb);iconBtn.appendChild(document.createTextNode('Icon'));
    } else {iconBtn.textContent='Icon';}
    const picker=ntMakeIconPicker(
      ()=>(window.lineOpts[i]||{}).iconKey||'',
      (k)=>{
        if(!window.lineOpts[i])window.lineOpts[i]={};
        window.lineOpts[i].iconKey=k;
        if(!window.lineOpts[i].iconSize)window.lineOpts[i].iconSize=uniformFs999;
        renderSimple();renderSizeBar();
        // update thumb WITHOUT destroying picker (preserve picker child)
        Array.from(iconBtn.childNodes).forEach(n=>{if(n!==picker)n.parentNode.removeChild(n);});
        if(k){
          const thumb=document.createElement('img');thumb.src=k;thumb.alt='';thumb.style.cssText='width:14px;height:14px;object-fit:contain;vertical-align:middle;margin-right:3px;';
          iconBtn.insertBefore(thumb,picker);
          iconBtn.insertBefore(document.createTextNode('Icon'),picker);
          iconBtn.classList.add('on');
        } else {
          iconBtn.insertBefore(document.createTextNode('Icon'),picker);
          iconBtn.classList.remove('on');
        }
      },
      ()=>window.lineOpts[i]||{},
      (opts)=>{ if(!window.lineOpts[i])window.lineOpts[i]={}; Object.assign(window.lineOpts[i],opts); renderSimple();renderSizeBar(); },
      ()=>{},
      (line||'').trim().split(/\s+/).filter(Boolean).length
    );
    iconBtn.appendChild(picker);
    picker.addEventListener('click',e=>e.stopPropagation());
    iconBtn.addEventListener('click',e=>{
      e.stopPropagation();
      document.querySelectorAll('.lc-open-picker').forEach(p=>{if(p!==picker){p.style.display='none';p.classList.remove('lc-open-picker');}});
      const isOpen=picker.classList.contains('lc-open-picker');
      picker.style.display=isOpen?'none':'block';
      picker.classList.toggle('lc-open-picker',!isOpen);
      if(!isOpen){
        setTimeout(function(){
          function _closeP(ev){
            if(!iconBtn.contains(ev.target)){
              picker.style.display='none';
              picker.classList.remove('lc-open-picker');
              document.removeEventListener('click',_closeP);
            }
          }
          document.addEventListener('click',_closeP);
        },0);
      }
    });

    chip.appendChild(handle);chip.appendChild(textSpan);chip.appendChild(textInp);chip.appendChild(charCount);
    chip.appendChild(fBtn);chip.appendChild(breakBtn);
    chip.appendChild(iconBtn);

    // ── WIDE TOGGLE — hidden for now ─────────────────
    if(false && ntWideEligible(i, curLines)){
      const isWide = !!(opt.wide);
      const wideCharge = ntWideCharge(i, curLines);
      const wideBtn = document.createElement('button');
      wideBtn.className = 'line-chip-btn' + (isWide ? ' on' : '');
      wideBtn.textContent = '↔ Wide';
      wideBtn.title = 'Make this line wider · +₹' + wideCharge;
      if(isWide) wideBtn.style.cssText = 'border-color:var(--orange);color:var(--orange);font-size:10px;font-weight:700;white-space:nowrap;flex-shrink:0;';
      else wideBtn.style.cssText = 'font-size:10px;white-space:nowrap;flex-shrink:0;';
      wideBtn.addEventListener('click', e=>{
        e.stopPropagation();
        if(!window.lineOpts[i]) window.lineOpts[i]={};
        window.lineOpts[i].wide = !isWide;
        renderSimple(); renderLineChips(); renderSizeBar();
      });
      chip.appendChild(wideBtn);
      // Sub-label below chip when wide is on
      if(isWide){
        const wideLbl = document.createElement('div');
        wideLbl.style.cssText = 'font-size:9px;color:var(--orange);font-weight:600;padding:3px 10px 6px 32px;';
        wideLbl.textContent = '↳ wider line · +₹' + wideCharge;
        container.appendChild(chip);
        container.appendChild(wideLbl);
        if(i < curLines.length-1){
          const mz=document.createElement('div');mz.className='line-merge-zone';
          const mb=document.createElement('button');mb.className='line-merge-btn';mb.textContent='↕ merge lines';mb.style.display='none';
          mb.addEventListener('click',e=>{e.stopPropagation();mergeLine(i);});
          mz.appendChild(mb);container.appendChild(mz);
        }
        return; // skip normal append below since we already appended
      }
    }

    if(true){
      const alignIcons999={
        left:'<svg width="14" height="11" viewBox="0 0 14 11"><rect x="0" y="0" width="14" height="2" rx="1" fill="currentColor"/><rect x="0" y="4.5" width="9" height="2" rx="1" fill="currentColor"/><rect x="0" y="9" width="11" height="2" rx="1" fill="currentColor"/></svg>',
        center:'<svg width="14" height="11" viewBox="0 0 14 11"><rect x="0" y="0" width="14" height="2" rx="1" fill="currentColor"/><rect x="2.5" y="4.5" width="9" height="2" rx="1" fill="currentColor"/><rect x="1.5" y="9" width="11" height="2" rx="1" fill="currentColor"/></svg>',
        right:'<svg width="14" height="11" viewBox="0 0 14 11"><rect x="0" y="0" width="14" height="2" rx="1" fill="currentColor"/><rect x="5" y="4.5" width="9" height="2" rx="1" fill="currentColor"/><rect x="3" y="9" width="11" height="2" rx="1" fill="currentColor"/></svg>'
      };
      const cycle999={left:'center',center:'right',right:'left'};
      const chipAlign999=(window.lineOpts[i]&&window.lineOpts[i].align)||'center';
      const aBtn999=document.createElement('button');
      aBtn999.className='line-chip-btn'+(chipAlign999!=='center'?' on':'');
      aBtn999.style.cssText='flex-shrink:0;padding:3px 6px;display:flex;align-items:center;justify-content:center;'+(chipAlign999!=='center'?'border-color:var(--orange);color:var(--orange);':'');
      aBtn999.innerHTML=alignIcons999[chipAlign999];
      aBtn999.addEventListener('click',e=>{
        e.stopPropagation();
        if(!window.lineOpts[i])window.lineOpts[i]={};
        window.lineOpts[i].align=cycle999[chipAlign999];
        renderSimple();renderLineChips();
      });
      chip.appendChild(aBtn999);
    }

    chip.addEventListener('dragstart',e=>{if(!chip.draggable)return;dragSrc=i;chip.classList.add('dragging');e.dataTransfer.effectAllowed='move';});
    chip.addEventListener('dragend',()=>{chip.classList.remove('dragging');document.querySelectorAll('.line-chip').forEach(c=>c.classList.remove('drag-over'));});
    chip.addEventListener('dragover',e=>{e.preventDefault();chip.classList.add('drag-over');});
    chip.addEventListener('dragleave',()=>chip.classList.remove('drag-over'));
    chip.addEventListener('drop',e=>{
      e.preventDefault();chip.classList.remove('drag-over');
      const dest=parseInt(chip.dataset.index);
      if(dragSrc===null||dragSrc===dest)return;
      const nl=[...curLines];const[mv]=nl.splice(dragSrc,1);nl.splice(dest,0,mv);
      const no=[...window.lineOpts];const[mo]=no.splice(dragSrc,1);no.splice(dest,0,mo);
      curLines=nl;window.lineOpts=no;
      renderSimple();renderPuThumb();renderLineChips();renderSizeBar();
    });
    let touchY=0;
    chip.addEventListener('touchstart',e=>{touchY=e.touches[0].clientY;dragSrc=i;},{passive:true});
    chip.addEventListener('touchend',e=>{
      const diff=e.changedTouches[0].clientY-touchY;
      if(Math.abs(diff)<30)return;
      const dest=diff>0?Math.min(curLines.length-1,i+1):Math.max(0,i-1);
      if(dest===i)return;
      const nl=[...curLines];const[mv]=nl.splice(i,1);nl.splice(dest,0,mv);
      const no=[...window.lineOpts];const[mo]=no.splice(i,1);no.splice(dest,0,mo);
      curLines=nl;window.lineOpts=no;
      renderSimple();renderPuThumb();renderLineChips();renderSizeBar();
    });

    container.appendChild(chip);

    if(i<curLines.length-1){
      const mz=document.createElement('div');mz.className='line-merge-zone';
      const mb=document.createElement('button');mb.className='line-merge-btn';mb.textContent='↕ merge lines';mb.style.display='none';
      mb.addEventListener('click',e=>{e.stopPropagation();mergeLine(i);});
      mz.appendChild(mb);container.appendChild(mz);
    }
  });

}

function toggleQuickEdit(){
  const bar=document.getElementById('quickEditBar');
  const inp=document.getElementById('quickEditInp');
  if(bar.style.display==='none'||!bar.style.display){
    bar.style.display='block';
    inp.value=curLines.join(' ');
    inp.focus();inp.select();
  } else {bar.style.display='none';}
}

function applyQuickEdit(){
  const v=document.getElementById('quickEditInp').value.trim();
  if(!v)return;
  const words=v.split(' ');const lines=[];let cur='';
  words.forEach(w=>{if((cur+' '+w).trim().length>12&&cur){lines.push(cur.trim());cur=w;}else cur=(cur+' '+w).trim();});
  if(cur)lines.push(cur);
  curLines=[...lines];window.lineOpts=curLines.map(()=>({font:''}));
  if(!isNamed&&quickDetect(v)){
    isNamed=true;
    document.getElementById('tbPrice').textContent='₹1,299';
    const _tbr=document.getElementById('tbReason');if(_tbr)_tbr.textContent='Personalised piece';
    const tb=document.getElementById('tierBadge');if(tb)tb.classList.add('show');
  }
  renderSimple();renderPuThumb();renderSizeBar();
  document.getElementById('quickEditBar').style.display='none';
}

function showLineInfo(){
  const reply=document.getElementById('changeReqReply');
  const ch=curLines.join(' ').length;
  const inch1line=ch>15?10:ch>10?9:8;
  const price1line=inch1line===10?1199:inch1line===9?1099:999;
  reply.style.display='block';
  reply.innerHTML=`<b>1 line version:</b> Your text needs a ${inch1line}" piece at ₹${price1line}. Currently it's split across ${curLines.length} lines at ₹${curPrice} which looks better carved. Want to proceed with 1 line? <a href="#" onclick="event.preventDefault();makeOneLine()" style="color:var(--orange);font-weight:600;">Yes, try it →</a>`;
}

function makeOneLine(){
  curLines=[curLines.join(' ')];renderSimple();renderPuThumb();
  document.getElementById('changeReqReply').style.display='none';
}

async function handleChangeReq(){
  const inp=document.getElementById('changeReqInp');
  const req=inp.value.trim();if(!req)return;
  const reply=document.getElementById('changeReqReply');
  reply.style.display='block';reply.textContent='Thinking…';
  const sys=`You are a helpful assistant for NukkadTales wooden pieces.
Current design: ${JSON.stringify(curLines)} — ${curPrice > 999?'₹1,299 personalised':'₹999 quote piece'}
Customer has a change request. Respond in 2-3 short sentences:
- If they want fewer lines/1 line: tell them the size needed and price (e.g. "1 line needs a 6 inch piece at ₹899, or keep 2 lines at ₹999 — your choice")
- If they want different text: tell them to update the search above
- If they want different layout: tell them to try the Bold/Serif/Script font options
Keep it warm, direct, helpful. No lectures.`;
  try{
    const raw=await callAI(MODEL_SUGG,sys,req,200);
    reply.textContent=raw.trim();
    inp.value='';
  }catch(e){reply.textContent='Could not process — try rephrasing.';}
}

// ══════════════════════════════════════════════════════
// PERSONAL
// ══════════════════════════════════════════════════════
let iconDragPos={x:50,y:20};
let isDragging=false;
let originalCurLines=[];

function goPersonal(){
  isNamed=true;
  selC4=selC3;window.selC4=selC4;window.selFont4=selFont4;window.selFont=selFont;
  // Ensure selected color is dark enough to be visible on cream canvas
  var _cols4=ntGetColors();
  if(!_cols4[selC4]||_cols4[selC4].lt)selC4=_ntDefaultColorIdx();
  window.s4NameLine='';
  window.s4NameLines=[''];
  window.s4NameLineOpts=[{}];
  if(!window.s4LineOpts||window.s4LineOpts.length!==curLines.length)
    window.s4LineOpts=curLines.map(()=>({}));
  originalCurLines=[...curLines];
  try{document.getElementById('skipBar').style.display='flex';}catch(e){}
  try{document.getElementById('prevQWrap').style.display='block';}catch(e){}
  try{document.getElementById('prevQText').textContent=curLines.join(' · ');}catch(e){}
  initS4();
}

function initS4(){
  showSt('stagePersonal');

  // ── FIX CANVAS VISIBILITY FIRST (before any render) ──
  // Remove any sticky collapse state from previous session
  var _s4w=document.getElementById('s4Wrap');
  if(_s4w){_s4w.classList.remove('nt-collapsed');_s4w.style.cssText='position:relative;margin-top:4px;';}
  var _cw=document.getElementById('ntCanvasWrap');
  if(_cw){
    _cw.style.cssText='max-height:none!important;overflow:visible!important;opacity:1!important;display:block!important;transition:none!important;';
  }
  var _ss=document.getElementById('ntStickyStyles');if(_ss)_ss.remove();
  // Hide all Hindi UI elements (Hindi removed — users type directly)
  ['hindiHint','hindiHintS4','fo-hindi','fo4-hindi'].forEach(function(id){
    var el=document.getElementById(id);if(el)el.style.display='none';
  });
  // Increase canvas height by 25% so tall designs (with caps/icons) don't get clipped
  var _bg=document.getElementById('s4Bg');
  if(_bg){
    var _curH=_bg.getBoundingClientRect().height||_bg.offsetHeight;
    var _hMult=1.25+(curLines.length>2?0.15:0)+(window.s4TopIcon&&window.s4TopIcon.iconKey?0.2:0);
  if(_curH>0){_bg.style.minHeight=Math.round(_curH*_hMult)+'px';}
    else{setTimeout(function(){var h=_bg.getBoundingClientRect().height||_bg.offsetHeight;if(h>0)_bg.style.minHeight=Math.round(h*_hMult)+'px';},200);}
  }
  {var _bb=document.getElementById('backBar');if(_bb)_bb.classList.add('show');}document.body.classList.add('has-backbar');
  {var _bbs=document.getElementById('backBarStage');if(_bbs)_bbs.textContent=isNamed?'₹1,299 personalised':'₹999 design';}
  renderTry4();
  if(window.s4NameLine===undefined)window.s4NameLine='';
  if(!window.s4NameLines||!window.s4NameLines.length)window.s4NameLines=[''];
  if(!window.s4LineOpts||window.s4LineOpts.length!==curLines.length)window.s4LineOpts=curLines.map(()=>({}));
  const s4BtnEl=document.getElementById('s4Btn');
  if(s4BtnEl)s4BtnEl.textContent=isNamed?((window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.txt&&window.NUKKAD_CONFIG.txt.commLabel)||'Add to Cart')+' · ₹1,299':((window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.txt&&window.NUKKAD_CONFIG.txt.commLabel)||'Add to Cart')+' · ₹999';
  try{const sb=document.getElementById('skipBar');if(sb)sb.style.display=isNamed?'flex':'none';}catch(e){}
  try{document.getElementById('d4offer').style.display='none';}catch(e){}
  var sp = document.getElementById('stagePersonal');
  if(sp) sp.style.display = 'block';
  // Inject video and reviews into personal stage
  setTimeout(function(){if(typeof ntInitVideoReviews==='function')ntInitVideoReviews();},800);
  renderS4LineChips();
  try{renderS4();}catch(e){console.error('[renderS4 error]',e.message, e.stack);}
  try{renderS4SizeBar();}catch(e){console.error('[renderS4SizeBar]',e);}
  try{renderC4();}catch(e){console.error('[renderC4]',e);}
  setTimeout(function(){try{renderC4();}catch(e){}},100);
  setTimeout(function(){try{renderC4();}catch(e){}},500);
  setTimeout(ntShowAddIconBtn,300);

  [100, 300, 600, 1200, 2000].forEach(function(delay){
    setTimeout(function(){
      var bg=document.getElementById('s4Bg');
      if(bg){
        // Force visible in case something collapsed it
        bg.style.display='flex';
        bg.style.minHeight='160px';
        if(bg.getBoundingClientRect().width>0)bg.style.minWidth='';
        else bg.style.minWidth='280px';
      }
      try{renderS4();}catch(e){}
      try{renderS4SizeBar();}catch(e){}
    }, delay);
  });
  // Sticky canvas disabled - canvas renders in normal flow
  // Apply sticky immediately so canvas is always fixed at top
  var _s4wSticky=document.getElementById('s4Wrap');
  if(_s4wSticky){
    _s4wSticky.classList.remove('nt-collapsed');
    _s4wSticky.style.setProperty('position','sticky','important');
    _s4wSticky.style.setProperty('top','0','important');
    _s4wSticky.style.setProperty('z-index','9999','important');
    _s4wSticky.style.setProperty('background','var(--cream,#f5ede0)','important');
  }
  // Remove ntStickyStyles to kill any leftover collapse CSS
  var _ss=document.getElementById('ntStickyStyles');if(_ss)_ss.remove();
  var _cw=document.getElementById('ntCanvasWrap');
  if(_cw){_cw.style.transition='none';_cw.style.maxHeight='none';_cw.style.opacity='1';_cw.style.overflow='visible';_cw.style.display='block';}

  // Init scroll listener for collapse after 2s (canvas already visible by then)
  setTimeout(function(){
    var cw=document.getElementById('ntCanvasWrap');
    if(cw)cw.style.cssText='max-height:none!important;overflow:visible!important;opacity:1!important;display:block!important;transition:none!important;';
    var s4w=document.getElementById('s4Wrap');
    if(s4w)s4w.classList.remove('nt-collapsed');
    ntInitStickyCanvas();
  },2000);
  window.scrollTo({top:0,behavior:'smooth'});
}

function renderS4LineChips(){
  const container=document.getElementById('s4LineChips');
  if(!container)return;
  container.innerHTML='';
  if(!window.s4LineOpts)window.s4LineOpts=curLines.map(()=>({}));
  while(window.s4LineOpts.length<curLines.length)window.s4LineOpts.push({});
  if(!window.s4NameLines)window.s4NameLines=[''];

  const totalLines=curLines.length+window.s4NameLines.filter(Boolean).length;
  const MAX_LINES=4;

  let dragSrc4Name=null;
  const makeChip=(lineText, isName, idx)=>{
    const chip=document.createElement('div');chip.className='line-chip';chip.style.background='#fff';chip.dataset.index=idx;chip.dataset.isname=isName?'1':'0';

    const isEmpty=isName&&!lineText;
    const txt=document.createElement('span');txt.className='line-chip-text';
    txt.textContent=isEmpty?'Type a name / text here…':lineText;
    if(isEmpty)txt.style.cssText='flex:1;color:var(--muted);font-style:italic;font-size:12px;cursor:text;padding:0;';
    else txt.style.cssText='flex:1;cursor:text;';

    const inp=document.createElement('input');
    // Always read fresh from curLines/s4NameLines to prevent stale values
    inp.value=(isName?(window.s4NameLines[idx]||''):(curLines[idx]||''));
    inp.placeholder=isName?'Type a name / text here…':'';
    inp.className='line-chip-inp';inp.style.display='none';inp.style.flex='1';
    ntNoEmoji(inp);

    const ckBtn=document.createElement('button');
    ckBtn.className='line-chip-btn';ckBtn.textContent='Done ✓';
    ckBtn.style.cssText='display:none;color:#fff;background:var(--orange);border:none;border-radius:16px;padding:4px 12px;font-size:11px;font-weight:700;flex-shrink:0;cursor:pointer;';

    const commitEdit=()=>{
      const trimmed=inp.value.trim();
      inp.style.display='none';ckBtn.style.display='none';txt.style.display='';
      if(isName){
        window.s4NameLines[idx]=trimmed;
        window.s4NameLine=window.s4NameLines.filter(Boolean).join(' & ');
        if(trimmed)isNamed=true;
      } else {
        const hasIcon=!!(window.s4LineOpts[idx]||{}).iconKey;
        if(trimmed){curLines[idx]=trimmed;}
        else if(idx===0){curLines[idx]='';}  // never delete first line
        else if(!hasIcon){curLines.splice(idx,1);window.s4LineOpts.splice(idx,1);}
        else{curLines[idx]='';}
        if(!isNamed&&quickDetect(curLines.join(' '))){isNamed=true;}
      }
      // Keep s4LineOpts in sync with curLines length
      while(window.s4LineOpts.length<curLines.length)window.s4LineOpts.push({});
      window.s4LineOpts=window.s4LineOpts.slice(0,curLines.length);
      renderS4LineChips();renderS4();renderS4SizeBar();
      // Update compact bar text
      var _ct=document.getElementById('ntCompactText');
      if(_ct)_ct.textContent=curLines.filter(Boolean).join(' · ');
    };

    const startEdit=()=>{
      txt.style.display='none';
      inp.style.display='block';
      ckBtn.style.display='block';
      inp.value=lineText||'';
      setTimeout(()=>{inp.focus();inp.select();},0);
    };

    ckBtn.addEventListener('mousedown',e=>{e.preventDefault();});
    ckBtn.addEventListener('click',e=>{e.stopPropagation();commitEdit();});
    inp.addEventListener('blur',e=>{setTimeout(()=>{if(document.activeElement!==ckBtn)commitEdit();},150);});
    inp.addEventListener('input',()=>{
      const n=(inp.value||'').replace(/\s/g,'').length;
      let cc=inp._cc;
      if(!cc){cc=document.createElement('span');cc.style.cssText='font-size:9px;color:var(--light);flex-shrink:0;margin-left:4px;';inp._cc=cc;inp.parentNode&&inp.after(cc);}
      cc.textContent=n+'L';
      cc.style.color=n>9?'var(--orange)':n>7?'#b09a88':'var(--light)';
      // Live preview while typing - temporarily set value, render, then restore
      try{
        const v=inp.value.trim();
        const _savedQ=curLines[idx];
        const _savedN=(window.s4NameLines||[])[idx];
        if(!isName)curLines[idx]=v||_savedQ;
        else{if(!window.s4NameLines)window.s4NameLines=[''];window.s4NameLines[idx]=v||'';}
        renderS4();
        // Restore so commitEdit can set permanently
        if(!isName)curLines[idx]=_savedQ;
        else window.s4NameLines[idx]=_savedN||'';
      }catch(e){}
    });
    inp.addEventListener('keydown',e=>{
      if(e.key==='Enter'){e.preventDefault();commitEdit();}
      if(e.key==='Escape'){inp.style.display='none';ckBtn.style.display='none';txt.style.display='';}
    });

    chip.appendChild(txt);chip.appendChild(inp);chip.appendChild(ckBtn);

    if(isNamed&&(!isName||lineText)){
      const editBtn=document.createElement('button');
      editBtn.className='line-chip-btn';
      editBtn.textContent='Edit ✎';editBtn.title='Edit text';
      editBtn.style.cssText='font-size:10px;white-space:nowrap;flex-shrink:0;';
      editBtn.addEventListener('click',e=>{
        e.stopPropagation();
        editBtn.style.display='none'; // hide when editing
        startEdit();
      });
      // Show edit button again after commit
      const _origCommit=commitEdit;
      // patch: re-show editBtn on commitEdit (called from blur/enter/ckBtn)
      inp.addEventListener('blur',()=>{setTimeout(()=>{editBtn.style.display='';},200);});
      ckBtn.addEventListener('click',()=>{setTimeout(()=>{editBtn.style.display='';},50);});
      chip.appendChild(editBtn);
    }
    if(isName&&!lineText){
      txt.style.cursor='text';
      txt.addEventListener('click',startEdit);
    }

    const opt_=isName?{}:(window.s4LineOpts[idx]||{});
    const curF=isName?((window.s4NameFontOpts&&window.s4NameFontOpts[idx])||''):(opt_.fontOverride||'');
    const fontLabels1299={'serif':'Classic','pacifico':'Flowing','lobster':'Casual','amaranth':'Rounded','montserrat':'Bold','teko':'Impact','comic':'Quirky'};
    const fBtn4=document.createElement('button');
    fBtn4.className='line-chip-btn'+(curF?' on':'');
    if(curF)fBtn4.style.cssText='font-size:10px;font-weight:700;white-space:nowrap;flex-shrink:0;position:relative;';
    else fBtn4.style.cssText='font-size:10px;white-space:nowrap;flex-shrink:0;position:relative;';
    const fBtn4Lbl=document.createElement('span');
    fBtn4Lbl.textContent=curF?(fontLabels1299[curF]||'Font'):'Choose a font';
    fBtn4.appendChild(fBtn4Lbl);
    const fPop4=document.createElement('div');
    fPop4.style.cssText='display:none;position:fixed;z-index:2147483500;background:#fff;border:1.5px solid var(--border);border-radius:10px;padding:8px;box-shadow:0 6px 24px rgba(0,0,0,.15);min-width:160px;max-height:60vh;overflow-y:auto;';
    [['montserrat','Aa','Bold'],['serif','Aa','Classic'],['pacifico','Aa','Flowing'],['lobster','Aa','Casual'],['amaranth','Aa','Rounded'],['teko','Aa','Impact'],['comic','Aa','Quirky'],['andalusia','Aa','Script'],['recoleta','Aa','Recoleta']].forEach(([v,abbr,label])=>{
      const row=document.createElement('button');
      const isA=curF===v;
      row.style.cssText='display:flex;align-items:center;gap:8px;width:100%;border:none;background:'+(isA?'#fff8f3':'transparent')+';border-radius:6px;padding:6px 8px;cursor:pointer;';
      const samp=document.createElement('span');
      samp.textContent='Aa';
      const _fMap={'serif':"'Playfair Display',serif",'pacifico':"'Pacifico',cursive",'great-vibes':"'Great Vibes',cursive",'lobster':"'Lobster',cursive",'andalusia':"'Andalusia',cursive",'recoleta':"'Recoleta',serif",'amaranth':"'Amaranth',sans-serif",'montserrat':"'Montserrat',sans-serif",'teko':"'Teko',sans-serif",'comic':"'Comic Neue',cursive"};
      samp.style.cssText='font-size:14px;font-weight:700;width:28px;text-align:center;color:'+(isA?'var(--orange)':'var(--brown)')+';flex-shrink:0;font-family:'+(_fMap[v]||"'Poppins',sans-serif")+';';
      const nm=document.createElement('span');
      nm.textContent=label;
      nm.style.cssText='font-size:11px;color:'+(isA?'var(--orange)':'var(--brown)')+';font-weight:'+(isA?'700':'400')+';';
      if(isA){const ck=document.createElement('span');ck.textContent='✓';ck.style.cssText='margin-left:auto;color:var(--orange);font-size:11px;';row.appendChild(samp);row.appendChild(nm);row.appendChild(ck);}
      else{row.appendChild(samp);row.appendChild(nm);}
      row.addEventListener('click',e=>{
        e.stopPropagation();
        const next=curF===v?'':v;
        fPop4.style.display='none';
        if(!isName){
          if(!window.s4LineOpts[idx])window.s4LineOpts[idx]={};
          if(next){window.s4LineOpts[idx].fontOverride=next;}
          else{delete window.s4LineOpts[idx].fontOverride;delete window.s4LineOpts[idx].hindiText;}
          renderS4();setTimeout(()=>{renderS4LineChips();},0);
        } else {
          if(!window.s4NameFontOpts)window.s4NameFontOpts={};
          if(next)window.s4NameFontOpts[idx]=next;
          else delete window.s4NameFontOpts[idx];
          renderS4();setTimeout(()=>{renderS4LineChips();ntRefreshHindiHint();},0);
        }
      });
      fPop4.appendChild(row);
    });
    fBtn4.addEventListener('click',e=>{
  e.stopPropagation();
  if(fPop4.style.display!=='none'){fPop4.style.display='none';return;}
  document.querySelectorAll('.nt-font-pop-open').forEach(function(p){p.style.display='none';p.classList.remove('nt-font-pop-open');});
  var _r=fBtn4.getBoundingClientRect();
  fPop4.style.top=(_r.bottom+4)+'px';
  fPop4.style.left=Math.max(4,_r.left-80)+'px';
  fPop4.style.display='block';
  fPop4.classList.add('nt-font-pop-open');
  document.body.appendChild(fPop4);
  setTimeout(function(){
    function _close(ev){if(!fPop4.contains(ev.target)&&ev.target!==fBtn4){fPop4.style.display='none';fPop4.classList.remove('nt-font-pop-open');document.removeEventListener('click',_close);}};
    document.addEventListener('click',_close);
  },0);
});
    chip.appendChild(fBtn4);

    const totalChipLines=curLines.length+window.s4NameLines.filter(Boolean).length;
    if(true){
      const alignIcons={
        left:'<svg width="14" height="11" viewBox="0 0 14 11"><rect x="0" y="0" width="14" height="2" rx="1" fill="#3d2b1a"/><rect x="0" y="4.5" width="9" height="2" rx="1" fill="#3d2b1a"/><rect x="0" y="9" width="11" height="2" rx="1" fill="#3d2b1a"/></svg>',
        center:'<svg width="14" height="11" viewBox="0 0 14 11"><rect x="0" y="0" width="14" height="2" rx="1" fill="#3d2b1a"/><rect x="2.5" y="4.5" width="9" height="2" rx="1" fill="#3d2b1a"/><rect x="1.5" y="9" width="11" height="2" rx="1" fill="#3d2b1a"/></svg>',
        right:'<svg width="14" height="11" viewBox="0 0 14 11"><rect x="0" y="0" width="14" height="2" rx="1" fill="#3d2b1a"/><rect x="5" y="4.5" width="9" height="2" rx="1" fill="#3d2b1a"/><rect x="3" y="9" width="11" height="2" rx="1" fill="#3d2b1a"/></svg>'
      };
      const cycle={left:'center',center:'right',right:'left'};
      const chipAlign=isName?((window.s4NameLineOpts&&window.s4NameLineOpts[idx]&&window.s4NameLineOpts[idx].align)||'center'):((window.s4LineOpts[idx]&&window.s4LineOpts[idx].align)||'center');
      const safeAlign=(alignIcons[chipAlign]?chipAlign:'center');
      const aBtn=document.createElement('button');
      aBtn.className='line-chip-btn'+(safeAlign!=='center'?' on':'');
      aBtn.style.cssText='flex-shrink:0;padding:3px 6px;display:flex;align-items:center;justify-content:center;background:'+(safeAlign!=='center'?'#fff8f3':'')+'!important;border-color:'+(safeAlign!=='center'?'var(--orange)':'')+'!important;';
      aBtn.innerHTML=alignIcons[safeAlign];
      aBtn.title='Alignment: '+safeAlign;
      aBtn.addEventListener('click',e=>{
        e.stopPropagation();
        const next=cycle[safeAlign];
        if(isName){const o=getOpts4();o.align=next;}
        else{if(!window.s4LineOpts[idx])window.s4LineOpts[idx]={};window.s4LineOpts[idx].align=next;}
        renderS4LineChips();renderS4();
      });
      chip.appendChild(aBtn);
    }
    const nameOpts4=()=>{if(!window.s4NameLineOpts)window.s4NameLineOpts=[];while(window.s4NameLineOpts.length<=idx)window.s4NameLineOpts.push({});return window.s4NameLineOpts[idx];};
    const getOpts4=()=>isName?nameOpts4():(window.s4LineOpts[idx]||{});
    const _defIconSz=uniformFs4;
    // Icon button removed — now handled by icon strips below chips

    // ── WIDE TOGGLE (s4) — hidden for now ─────────────
    if(false && !isName && ntWideEligible(idx, curLines)){
      const _isWideS4 = !!(window.s4LineOpts[idx]&&window.s4LineOpts[idx].wide);
      const _wideChargeS4 = ntWideCharge(idx, curLines);
      const wideBtnS4 = document.createElement('button');
      wideBtnS4.className = 'line-chip-btn' + (_isWideS4 ? ' on' : '');
      wideBtnS4.textContent = '↔ Wide';
      wideBtnS4.title = 'Make this line wider · +₹' + _wideChargeS4;
      if(_isWideS4) wideBtnS4.style.cssText = 'border-color:var(--orange);color:var(--orange);font-size:10px;font-weight:700;white-space:nowrap;flex-shrink:0;';
      else wideBtnS4.style.cssText = 'font-size:10px;white-space:nowrap;flex-shrink:0;';
      wideBtnS4.addEventListener('click', e=>{
        e.stopPropagation();
        if(!window.s4LineOpts[idx]) window.s4LineOpts[idx]={};
        window.s4LineOpts[idx].wide = !_isWideS4;
        renderS4LineChips(); renderS4(); renderS4SizeBar();
      });
      chip.appendChild(wideBtnS4);
    }

    const isLastName=isName&&window.s4NameLines.length<=1;
    const isFirstLine=!isName&&idx===0;
    if(!isLastName&&!isFirstLine){
      const delBtn=document.createElement('button');delBtn.className='line-chip-btn';delBtn.textContent='✕';
      delBtn.style.cssText='font-size:10px;color:var(--muted);border-color:transparent;background:transparent;padding:2px 5px;';
      delBtn.addEventListener('click',e=>{
        e.stopPropagation();
        if(isName){window.s4NameLines.splice(idx,1);if(!window.s4NameLines.length)window.s4NameLines=[''];}
        else{curLines.splice(idx,1);window.s4LineOpts.splice(idx,1);}
        window.s4NameLine=window.s4NameLines.filter(Boolean).join(' & ');
        renderS4LineChips();renderS4();renderS4SizeBar();
      });
      chip.appendChild(delBtn);
    }
    let s4TouchY=0;
    chip.addEventListener('touchstart',e=>{s4TouchY=e.touches[0].clientY;if(isName)dragSrc4Name=idx;else dragSrc4=idx;},{passive:true});
    chip.addEventListener('touchend',e=>{
      const diff=e.changedTouches[0].clientY-s4TouchY;
      if(Math.abs(diff)<30)return;
      if(!isName){
        const dest=diff>0?Math.min(curLines.length-1,idx+1):Math.max(0,idx-1);
        if(dest===idx)return;
        const nl=[...curLines];const[mv]=nl.splice(idx,1);nl.splice(dest,0,mv);
        const no=[...window.s4LineOpts];const[mo]=no.splice(idx,1);no.splice(dest,0,mo);
        curLines=nl;window.s4LineOpts=no;
      } else {
        const dest=diff>0?Math.min(window.s4NameLines.length-1,idx+1):Math.max(0,idx-1);
        if(dest===idx)return;
        const nl=[...window.s4NameLines];const[mv]=nl.splice(idx,1);nl.splice(dest,0,mv);
        window.s4NameLines=nl;window.s4NameLine=window.s4NameLines.filter(Boolean).join(' & ');
      }
      renderS4LineChips();renderS4();renderS4SizeBar();
    });
    return chip;
  };

  curLines.forEach((line,i)=>{
    container.appendChild(makeChip(line,false,i));

    const words=(line||'').trim().split(/\s+/).filter(Boolean);
    if(words.length>=2){
      const bz=document.createElement('div');bz.style.cssText='display:flex;align-items:center;justify-content:center;gap:6px;padding:2px 0;';
      const brk=document.createElement('button');brk.className='line-merge-btn';brk.textContent='break line';
      // Disable break if already at 4 quote lines
      var _tiCap2=!!(window.s4TopIcon&&window.s4TopIcon.iconKey)?1:0;if(curLines.length+_tiCap2>=4){brk.style.opacity='0.4';brk.style.pointerEvents='none';brk.title=_tiCap2?'Remove top icon to add more lines':'Max 4 lines';}
      brk.addEventListener('click',()=>{
        const mid=Math.ceil(words.length/2);
        curLines.splice(i,1,words.slice(0,mid).join(' '),words.slice(mid).join(' '));
        window.s4LineOpts.splice(i,1,{...window.s4LineOpts[i]},{});
        renderS4LineChips();renderS4();renderS4SizeBar();
      });
      bz.appendChild(brk);container.appendChild(bz);
    }

    if(i<curLines.length-1){
      const mz=document.createElement('div');mz.className='line-merge-zone';
      const mb=document.createElement('button');mb.className='line-merge-btn';mb.textContent='↕ merge lines';mb.style.display='none';
      mb.addEventListener('click',e=>{
        e.stopPropagation();
        curLines.splice(i,1,curLines[i]+' '+curLines[i+1]);curLines.splice(i+1,1);
        window.s4LineOpts.splice(i,1,{...window.s4LineOpts[i]});window.s4LineOpts.splice(i+1,1);
        renderS4LineChips();renderS4();renderS4SizeBar();
      });
      mz.appendChild(mb);container.appendChild(mz);
    }
  });

  if(curLines.length>0&&window.s4NameLines.length>0){
    const _hasName=window.s4NameLines.filter(Boolean).length>0;
    const mz=document.createElement('div');mz.className='line-merge-zone';
    if(!_hasName)mz.style.height='8px';
    const mb=document.createElement('button');mb.className='line-merge-btn';mb.textContent='↕ merge these lines';mb.style.display='none';
    if(!_hasName)mb.style.display='none';
    mb.addEventListener('click',e=>{
      e.stopPropagation();
      const lastName=curLines[curLines.length-1];
      const firstName=window.s4NameLines[0]||'';
      if(firstName){curLines[curLines.length-1]=lastName+' '+firstName;window.s4NameLines.splice(0,1);}
      if(!window.s4NameLines.length)window.s4NameLines=[''];
      renderS4LineChips();renderS4();renderS4SizeBar();
    });
    mz.appendChild(mb);container.appendChild(mz);
  }

  // Show max lines hint even before isNamed check
  if(curLines.filter(Boolean).length>=MAX_LINES){
    const _tiActive2=!!(window.s4TopIcon&&window.s4TopIcon.iconKey);
    const hint2=document.createElement('div');
    hint2.style.cssText='margin-top:8px;font-size:10px;color:var(--muted);line-height:1.5;padding:6px 10px;background:#fdf5ec;border:1px solid #e8d5c0;border-radius:8px;';
    if(_tiActive2){
      hint2.innerHTML='<span style="color:#c47a45;font-weight:700;">Top icon counts as a line.</span> Remove it to add another line of text. Max 4 lines allowed.';
    } else {
      hint2.innerHTML='Max 4 lines reached.';
    }
    container.appendChild(hint2);
  }
  const _tiActive=!!(window.s4TopIcon&&window.s4TopIcon.iconKey);
  const currentTotal=(_tiActive?1:0)+curLines.filter(Boolean).length+(window.s4NameLines||[]).filter(Boolean).length;
  if(isNamed){
  window.s4NameLines.forEach((name,ni)=>{
    // Skip empty placeholder when at max lines
    if(!name&&currentTotal>=MAX_LINES)return;
    container.appendChild(makeChip(name,true,ni));
    const nw=(name||'').trim().split(/\s+/).filter(Boolean);
    if(nw.length>=2){
      const bz=document.createElement('div');bz.style.cssText='display:flex;align-items:center;justify-content:center;padding:2px 0;';
      const brk=document.createElement('button');brk.className='line-merge-btn';brk.textContent='break line';
      // Disable break if already at 4 quote lines
      var _tiCap2=!!(window.s4TopIcon&&window.s4TopIcon.iconKey)?1:0;if(curLines.length+_tiCap2>=4){brk.style.opacity='0.4';brk.style.pointerEvents='none';brk.title=_tiCap2?'Remove top icon to add more lines':'Max 4 lines';}
      brk.addEventListener('click',()=>{const mid=Math.ceil(nw.length/2);window.s4NameLines.splice(ni,1,nw.slice(0,mid).join(' '),nw.slice(mid).join(' '));window.s4NameLine=window.s4NameLines.filter(Boolean).join(' & ');renderS4LineChips();renderS4();renderS4SizeBar();});
      bz.appendChild(brk);container.appendChild(bz);
    }
    if(ni<window.s4NameLines.length-1&&name&&window.s4NameLines[ni+1]){
      const mz=document.createElement('div');mz.className='line-merge-zone';
      const mb=document.createElement('button');mb.className='line-merge-btn';mb.textContent='↕ merge names';mb.style.display='none';
      mb.addEventListener('click',e=>{
        e.stopPropagation();
        window.s4NameLines.splice(ni,2,window.s4NameLines[ni]+' '+window.s4NameLines[ni+1]);
        window.s4NameLine=window.s4NameLines.filter(Boolean).join(' & ');
        renderS4LineChips();renderS4();renderS4SizeBar();
      });
      mz.appendChild(mb);container.appendChild(mz);
    }
  });

  } // end if(isNamed)
  if(currentTotal<MAX_LINES){
    const addBtn=document.createElement('button');
    addBtn.style.cssText='margin-top:6px;font-size:11px;color:var(--orange);background:transparent;border:none;cursor:pointer;font-weight:600;padding:4px 0;display:block;';
    addBtn.textContent='+ add another name / text';
    // Always show add button in personal stage when there's room
    addBtn.addEventListener('click',()=>{window.s4NameLines.push('');renderS4LineChips();});
    container.appendChild(addBtn);
  } else {
    // At max — show contextual hint
    const hint=document.createElement('div');
    hint.style.cssText='margin-top:8px;font-size:10px;color:var(--muted);line-height:1.5;padding:6px 10px;background:#fdf5ec;border:1px solid #e8d5c0;border-radius:8px;';
    if(_tiActive && curLines.filter(Boolean).length+(window.s4NameLines||[]).filter(Boolean).length<=3){
      hint.innerHTML='<span style="color:#c47a45;font-weight:700;">Top icon counts as a line.</span> Remove it to add another line of text. Max 4 lines allowed.';
    } else {
      hint.innerHTML='Max 4 lines reached.';
    }
    container.appendChild(hint);
  }

  renderS4SizeBar();
  ntRenderIconStrips();
}

function renderS4SizeBar(){
  const nameLines=(window.s4NameLines||[]).filter(Boolean);
  const _tiLine=(window.s4TopIcon&&window.s4TopIcon.iconKey)?['[icon]']:[];
  const allLines=[..._tiLine,...curLines,...nameLines];
  const allOpts=[...(_tiLine.length?[{}]:[]),...(window.s4LineOpts||[]),...(window.s4NameLineOpts||[]).slice(0,nameLines.length)];
  const {inch}=calcSizePrice(allLines,true,allOpts);
  const hasName=nameLines.length>0;
  const aiInch=inch;
  const displayInch=customSizeOverride||aiInch;
  const totalExtra=Math.max(0,displayInch-8)*100; // personal anchor=8"
  const totalPrice=1299+totalExtra;

  // always update the size display (+/- number) AND the green AI label
  updateSizeDisplayS4(aiInch);
  const sizeEl=document.getElementById('sizeCurrentS4');
  if(sizeEl)sizeEl.textContent=displayInch;
  // Update the large AI suggested number display
  const aiDispS4=document.getElementById('sizeAiDisplayS4');if(aiDispS4)aiDispS4.textContent=aiInch;
  const noteEl=document.getElementById('sizeAiNoteS4');
  if(noteEl)noteEl.textContent=customSizeOverride&&customSizeOverride!==aiInch?`AI suggests ${aiInch}"`:'';

  const btn=document.getElementById('s4Btn');
  if(btn){
    if(!hasName&&!isNamed){btn.textContent=((window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.txt&&window.NUKKAD_CONFIG.txt.commLabel)||'Add to Cart')+' as quote · ₹999';btn.style.background='var(--brown)';}
    else{
      // ── MATRIX PRICING FIX 2 (renderS4SizeBar button) ──
      var _tiBtn=!!(window.s4TopIcon&&window.s4TopIcon.iconKey);
      const lc=Math.min(allLines.length+(_tiBtn?1:0),4);
      const ai=Math.min(Math.max(displayInch,8),24);
      const _btnBase=typeof ntGetPrice==='function'?ntGetPrice(ai,lc):totalPrice;
      const _btnIconExtra=ntIconColourExtra(window.s4LineOpts||[],window.s4NameLineOpts||[],(ntGetColors()[window.selC4||0]||{}).fc||'');
      const btnPrice=_btnBase+_btnIconExtra;
      btn.textContent=((window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.txt&&window.NUKKAD_CONFIG.txt.commLabel)||'Add to Cart')+' · ₹'+btnPrice.toLocaleString('en-IN');
      btn.style.background='';
    }
  }

  // Place caption — below stepper
  const s4DescEl=document.getElementById('sizeInfoTextRenderS4');
  if(s4DescEl){
    const descMap={6:'Compact · gifting',7:'Desk or shelf',8:'Desk · comfortable read',9:'Desk · slightly bolder',10:'Sideboard or console',11:'Sideboard · makes a statement',12:'Wall piece · bold from a distance',13:'Wall piece · strong anchor',14:'Large wall',15:'Statement wall piece',16:'Feature wall',18:'Gallery wall',20:'Large installation'};
    s4DescEl.textContent=descMap[displayInch]||(displayInch>20?'Extra large custom piece':'Bold statement piece');
  }

  // Cream breakdown zone
  const bar=document.getElementById('sizeInfoBarS4');
  const splitTip=document.getElementById('ntSplitTipS4');
  const splitTitle=document.getElementById('ntSplitTipTitle');
  if(bar){
    const _hasTi=!!(window.s4TopIcon&&window.s4TopIcon.iconKey);
    const totalLinesAll=(_hasTi?1:0)+curLines.length+nameLines.length;
    const _s4WideExtra=ntWideExtra(curLines,window.s4LineOpts||[]);
    const _textColour=(ntGetColors()[window.selC4||0]||{}).fc||'';
    const _iconColourExtra=ntIconColourExtra(window.s4LineOpts||[],window.s4NameLineOpts||[],_textColour);
    var _tiForPrice=!!(window.s4TopIcon&&window.s4TopIcon.iconKey);
    const displayPrice=(typeof ntGetPrice==='function'?ntGetPrice(Math.min(Math.max(displayInch,8),24),Math.min(allLines.length+(_tiForPrice?1:0),4)):1299)+_iconColourExtra;
    const lineBase=typeof ntGetPrice==='function'?ntGetPrice(8,Math.min(totalLinesAll,4)):1299;
    const extraAmt=Math.max(0,displayPrice-lineBase-_s4WideExtra-_iconColourExtra);
    const allLinesFlat=[...curLines,...nameLines];
    const mx=allLinesFlat.length?Math.max(...allLinesFlat.map(l=>(l||'').replace(/\s/g,'').length)):0;
    const hasIconOnLine=allOpts.some(o=>o&&o.iconKey);
    const lettersLabel=hasIconOnLine?mx+' letters + icon':mx+' letters';

    const _txt=(window.NUKKAD_CONFIG&&NUKKAD_CONFIG.txt)||{};
    var _tiLabel=_tiForPrice?' + top icon':'';
    var _textLinesOnly=allLines.length;
    let baseDesc=(_txt.breakBase||'Base · {lines} lines · starts at 8\u2033')
      .replace('{lines}',_textLinesOnly+_tiLabel);
    let sizeDesc=customSizeOverride?('Size \u00b7 upgraded to '+displayInch+'\u2033'):('Size \u00b7 '+lettersLabel+' needs '+displayInch+'\u2033');
    let wideDesc='Wide line upgrade';
    // Split tip sub
    var _splitSub=_txt.splitTipSub||'Tap the chip above and use break line';
    document.getElementById('ntSplitTipSub')&&(document.getElementById('ntSplitTipSub').textContent=_splitSub);

    let html='<div style="font-family:\'DM Sans\',sans-serif;font-size:11px;font-weight:600;color:#3d2b1a;line-height:2.1;">';
    html+='<div style="display:flex;justify-content:space-between;"><span>'+baseDesc+'</span><span style="color:#3d2b1a;font-weight:800;font-size:12px;">\u20b9'+lineBase.toLocaleString('en-IN')+'</span></div>';
    if(_hasTi) html+='<div style="display:flex;justify-content:space-between;"><span>Top icon · +1 line</span><span style="color:#c47a45;font-weight:800;font-size:12px;">included in base</span></div>';
    if(extraAmt>0) html+='<div style="display:flex;justify-content:space-between;"><span>'+sizeDesc+'</span><span style="color:#c47a45;font-weight:800;font-size:12px;">+\u20b9'+extraAmt.toLocaleString('en-IN')+'</span></div>';
    if(_s4WideExtra>0) html+='<div style="display:flex;justify-content:space-between;"><span>'+wideDesc+'</span><span style="color:#c47a45;font-weight:800;font-size:12px;">+\u20b9'+_s4WideExtra.toLocaleString('en-IN')+'</span></div>';
    if(_iconColourExtra>0) html+='<div style="display:flex;justify-content:space-between;"><span>Custom icon colour \u00d7'+(_iconColourExtra/500)+'</span><span style="color:#c47a45;font-weight:800;font-size:12px;">+\u20b9'+_iconColourExtra.toLocaleString('en-IN')+'</span></div>';
    html+='</div>';
    html+='<div style="height:1px;background:#ddc9b0;margin:6px 0;"></div>';
    html+='<div style="display:flex;justify-content:space-between;align-items:baseline;padding-bottom:12px;">';
    html+='<span style="font-family:\'DM Sans\',sans-serif;font-size:12px;color:#3d2b1a;font-weight:700;">'+(_txt.breakTotal||'Total')+'</span>';
    html+='<span style="font-family:\'Poppins\',sans-serif;font-weight:900;font-size:16px;color:#3d2b1a;">\u20b9'+displayPrice.toLocaleString('en-IN')+'</span>';
    html+='</div>';

    bar.innerHTML=html;
    bar.style.display='block';
    // Update floating price bar
    if(typeof ntFloatBarUpdate==='function'){
      var _curInch=customSizeOverride||aiInch||8;window._ntDisplayInch=_curInch;
      var _icCount=_iconColourExtra>0?(_iconColourExtra/500):0;
      var _exParts=[];
      if(extraAmt>0)_exParts.push('+₹'+extraAmt.toLocaleString('en-IN')+' size');
      if(_s4WideExtra>0)_exParts.push('+₹'+_s4WideExtra.toLocaleString('en-IN')+' wide');
      if(_iconColourExtra>0)_exParts.push('+₹'+_iconColourExtra.toLocaleString('en-IN')+' colour'+(_icCount>1?' ×'+_icCount:''));
      var _spec=totalLinesAll+' line'+(totalLinesAll>1?'s':'')+' · '+_curInch+'″';
      var _row='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;';
      var _l1=_spec+(_exParts.length?' · <span style="color:#6b4f37;">Base ₹'+lineBase.toLocaleString('en-IN')+'</span>':'');
      var _fbHtml='<div style="color:#8a7560;'+_row+'">'+_l1+'</div>';
      if(_exParts.length){
        _fbHtml+='<div style="color:#c47a45;font-weight:700;margin-top:1px;'+_row+'">'+_exParts.join(' · ')+'</div>';
      }
      ntFloatBarUpdate(displayPrice,_fbHtml);
    }

    // Split tip — bold SAVE banner
    if(splitTip){
      var _tipStyle='display:block;background:#e8f5ec;border:1.5px solid #7bc47b;border-radius:10px;padding:11px 14px;margin-top:8px;';
      var _tiActive2=!!(window.s4TopIcon&&window.s4TopIcon.iconKey);
      var _totalLines=allLinesFlat.length+(_tiActive2?1:0);
      // Only suggest if we have room to add a line (total < 4)
      // and at least one line has 2+ words
      var _canSuggest=_totalLines<4&&displayPrice>2000;
      // Find longest line with 2+ words
      var _breakableLine=allLinesFlat.reduce(function(best,l){
        var words=(l||'').trim().split(/\s+/).filter(Boolean);
        if(words.length<2)return best;
        var len=(l||'').replace(/\s/g,'').length;
        return len>(best?best.replace(/\s/g,'').length:0)?l:best;
      },null);
      if(_canSuggest&&_breakableLine){
        // Calculate actual saving
        var sugg=(typeof window.suggestSplit==='function'?window.suggestSplit:suggestSplit)(allLinesFlat, displayPrice, allOpts);
        var _saveAmt=sugg&&sugg.save>0?sugg.save:null;
        splitTip.style.cssText=_tipStyle;
        splitTip.innerHTML=
          '<div style="font-family:\'Poppins\',sans-serif;font-weight:900;font-size:15px;color:#1a5c32;margin-bottom:2px;">\ud83d\udca1 Save money'+(_saveAmt?' · \u20b9'+_saveAmt.toLocaleString('en-IN'):'')+'</div>'
          +'<div style="font-family:\'DM Sans\',sans-serif;font-size:11px;color:#2d5a2d;margin-bottom:8px;line-height:1.5;">Break \u201c'+_breakableLine+'\u201d into 2 lines</div>'
          +'<button onclick="(window.ntBreakLongestLine||function(){})()" style="background:#1a5c32;color:#fff;border:none;border-radius:20px;padding:8px 16px;font-size:12px;font-weight:700;cursor:pointer;font-family:\'DM Sans\',sans-serif;">Show me where \u2192</button>';
      } else if(_totalLines===1&&!(allLinesFlat[0]||'').includes(' ')&&displayPrice>2000){
        // Single word line — can't auto-break, suggest manual
        splitTip.style.cssText=_tipStyle;
        splitTip.innerHTML=
          '<div style="font-family:\'Poppins\',sans-serif;font-weight:900;font-size:15px;color:#1a5c32;margin-bottom:4px;">\ud83d\udca1 Save money</div>'
          +'<div style="font-family:\'DM Sans\',sans-serif;font-size:11px;color:#2d5a2d;line-height:1.5;">If you can break this into 2 lines, the price will be lower. Edit the chip above and split the text manually.</div>';
      } else {
        splitTip.style.cssText='display:none;';
      }
    }
  }
  // Keep float bar price in sync
  try{var _fb=document.getElementById('ntInlineCommBar');if(_fb&&_fb.classList.contains('show'))ntUpdateFloatBar();}catch(e){}
}

function applySplitSugg(newLines){
  const totalQuote=curLines.length;
  const totalName=window.s4NameLines.filter(Boolean).length;
  const total=totalQuote+totalName;
  const nameCount=totalName||0;
  const quoteCount=Math.max(1,newLines.length-nameCount);
  curLines=newLines.slice(0,quoteCount);
  if(nameCount>0)window.s4NameLines=newLines.slice(quoteCount);
  window.s4LineOpts=curLines.map(()=>({}));
  customSizeOverride=null;
  renderS4LineChips();renderS4();renderS4SizeBar();
}

function handleS4Commission(){
  const nameLines=(window.s4NameLines||[]).filter(Boolean);
  if(!nameLines.length){
  } else {
    console.log('Commission:',{lines:curLines,names:nameLines});
  }
}

function s4GoBackToQuote(){
  isNamed=false;
  window.s4NameLine='';
  goRender([...curLines],999);
}

function s4FocusName(){
  const nameInp=document.querySelector('#s4LineChips input');
  if(nameInp){nameInp.focus();nameInp.scrollIntoView({behavior:'smooth',block:'center'});}
}

function mergeS4Lines(i){
  const merged=(curLines[i]+' '+curLines[i+1]).trim();
  const nl=[...curLines];nl.splice(i,2,merged);
  curLines=nl;renderS4LineChips();renderS4();renderS4SizeBar();
}

function focusName(){const ni=document.querySelector('#s4LineChips input');if(ni){ni.focus();ni.scrollIntoView({behavior:'smooth',block:'center'});}}

function replaceName(lines,nameInput){
  if(!nameInput)return lines;
  const parts=nameInput.trim().split(/\s*[&,]\s*|\s+/).filter(Boolean);
  let idx=0;
  return lines.map(l=>{
    if(l.includes('NAME')){
      const rep=parts[idx]||parts[0]||nameInput;
      idx++;return l.replace(/NAME/g,rep);
    }
    return l;
  });
}

function updateQuoteLine(){}

function getFont4Cls(isConn,fontOverride){
  if(isConn)return'conn';
  const _f=fontOverride||selFont4||'sans';
  if(_f==='hindi')return'hindi';
  if(_f==='serif')return'serif';
  if(_f==='script')return'script-main';
  if(_f==='pacifico')return'pacifico';
  if(_f==='great-vibes')return'great-vibes';
  if(_f==='amaranth')return'amaranth';
  if(_f==='comic')return'comic';
  if(_f==='teko')return'teko';
  if(_f==='montserrat')return'montserrat';
  if(_f==='lobster')return'lobster';
  if(_f==='andalusia')return'andalusia';
  if(_f==='recoleta')return'recoleta';
  return'sans';
}

function renderS4(){
  const _allC4=ntGetColors();const c=_allC4[selC4]||_allC4[1];
  const nameLines=(window.s4NameLines||[]).filter(Boolean);
  const opts=window.s4LineOpts||[];
  const lines=curLines.length>0?curLines:[];
  // Allow render with just name lines (e.g. after quote line deleted)
  if(!lines.length&&!nameLines.length)return;
  const p=document.createElement('div');p.className='nt-piece';

  const makeNameSpan=(txt,ni)=>{
    const ns=document.createElement('span');
    const nfo=(window.s4NameFontOpts&&window.s4NameFontOpts[ni])||selFont4||'sans';
    const _fontFamilyMap={'serif':"'Playfair Display',serif",'script':"'Pacifico',cursive",'pacifico':"'Pacifico',cursive",'great-vibes':"'Great Vibes',cursive",'amaranth':"'Amaranth',sans-serif",'comic':"'Comic Neue',cursive",'teko':"'Teko',sans-serif",'montserrat':"'Montserrat',sans-serif",'lobster':"'Lobster',cursive",'andalusia':"'Andalusia',cursive",'recoleta':"'Recoleta',serif"};
    const ff=_fontFamilyMap[nfo]||"'Poppins',sans-serif";
    const fw=(nfo==='script'||nfo==='pacifico'||nfo==='lobster'||nfo==='andalusia')?'400':(nfo==='teko'||nfo==='recoleta')?'600':'900';
    const fsName=uniformFs4;
    ns.style.cssText=`font-family:${ff};font-weight:${fw};font-size:${fsName}px;color:${c.fc};line-height:0.9;display:block;text-align:center;letter-spacing:-0.02em;text-shadow:0 0 0.5px rgba(0,0,0,0.8);`;
    ns.textContent=txt;
    return ns;
  };

  const alignSelf=(a)=>a==='left'?'flex-start':a==='right'?'flex-end':'center';
  const block=document.createElement('div');
  block.style.cssText='display:inline-flex;flex-direction:column;align-items:stretch;';

  uniformFs4=72;
  const perLineFontSizeS4=[];
  lines.forEach((l,i)=>{
    const opt2=opts[i]||{};
    const lf2=opt2.fontOverride||selFont4||'sans';
    const isH2=lf2==='hindi';
    const dt2=isH2?(opt2.hindiText||l):(opt2.allCaps?l.toUpperCase():l);
    const isWideS4=!!(opt2.wide&&ntWideEligible(i,lines));
    const hasChipIconS4=!!opt2.iconKey;
    // If wide line also has a chip icon, reserve space for it — cap lower
    const wideMaxS4=hasChipIconS4?58:96;
    const fs2=calcLineFontSize(dt2,lf2==='script',isH2,isWideS4?wideMaxS4:72);
    perLineFontSizeS4.push(fs2);
    if(!isWideS4&&fs2<uniformFs4)uniformFs4=fs2;
  });
  nameLines.forEach((l)=>{
    const fs2=calcLineFontSize(l,false,false,60);
    if(fs2<uniformFs4)uniformFs4=fs2;
  });

  lines.forEach((l,i)=>{
    const opt=opts[i]||{};
    const lf=opt.fontOverride||selFont4||'sans';
    const isHindi=lf==='hindi';
    const displayText=isHindi?(opt.hindiText||l):(opt.allCaps?l.toUpperCase():l);
    const sp=document.createElement('span');
    sp.className='tl '+(isHindi?'hindi':getFont4Cls(false,lf)||'sans');
    sp.style.color=c.fc;
    sp.style.webkitTextStroke='';sp.style.textShadow='0 0 0.5px rgba(0,0,0,0.8)';
    sp.style.textAlign=opt.align||'center';
    sp.style.lineHeight='0.75';
    var _ls={'serif':'-0.02em','pacifico':'0.01em','montserrat':'-0.04em','teko':'0.02em','comic':'0.01em','lobster':'0.01em','amaranth':'-0.01em','sans':'-0.03em'};
    sp.style.letterSpacing=_ls[lf]||'-0.03em';
    const _isWideRenderS4=!!(opt.wide&&ntWideEligible(i,lines));
    const fs4=_isWideRenderS4?(perLineFontSizeS4[i]||uniformFs4):uniformFs4;
    sp.style.fontSize=fs4+'px';

    if(displayText) sp.textContent=displayText;
    if(opt.iconKey){
      const lineAlign4=opt.align||'center';
      const jc4=lineAlign4==='left'?'flex-start':lineAlign4==='right'?'flex-end':'center';
      const wrap=document.createElement('div');
      wrap.style.cssText='display:flex;align-items:center;justify-content:'+jc4+';gap:2px;';
      const sz=Math.min(opt.iconSize||uniformFs4, uniformFs4);
      const _szCap=Math.round(sz*0.78);
      const _rotS4=opt.iconRotation||0;const _flipS4=opt.iconFlip?'scaleX(-1)':'';
      const icEl=document.createElement('img');
      icEl.src=opt.iconKey;icEl.alt='';
      const _icColS4=opt.iconColour||c.fc;
      icEl.style.cssText='width:auto;height:'+_szCap+'px;max-width:'+Math.round(_szCap*1.8)+'px;object-fit:contain;flex-shrink:0;display:block;transform:rotate('+_rotS4+'deg) '+_flipS4+';filter:'+ntIconFilter(_icColS4)+';';
      if(opt.iconSide==='right'){wrap.appendChild(sp);wrap.appendChild(icEl);}
      else{wrap.appendChild(icEl);wrap.appendChild(sp);}
      block.appendChild(wrap);
    } else {
      block.appendChild(sp);
    }
  });

  nameLines.forEach((n,ni)=>{
    if(!n)return;
    const nOpt=(window.s4NameLineOpts&&window.s4NameLineOpts[ni])||{};
    const lineAlign=nOpt.align||'center';
    const ns=makeNameSpan(n,ni);
    ns.style.textAlign=lineAlign;
    if(nOpt.iconKey){
      const wrap=document.createElement('span');wrap.style.cssText='display:flex;align-items:center;justify-content:'+alignSelf(lineAlign)+';gap:2px;';
      const sz=Math.min(nOpt.iconSize||uniformFs4, uniformFs4);
      const _szCapN=Math.round(sz*0.78);
      const icElN=document.createElement('img');
      icElN.src=nOpt.iconKey;icElN.alt='';
      const _icColN=nOpt.iconColour||c.fc;
      icElN.style.cssText='width:auto;height:'+_szCapN+'px;max-width:'+Math.round(_szCapN*1.8)+'px;object-fit:contain;flex-shrink:0;display:block;filter:'+ntIconFilter(_icColN)+';';
      if(nOpt.iconSide==='right'){wrap.appendChild(ns);wrap.appendChild(icElN);}
      else{wrap.appendChild(icElN);wrap.appendChild(ns);}
      block.appendChild(wrap);
    } else {
      block.appendChild(ns);
    }
  });

  // ── TOP ICON — centred above the design ──
  var _ti=window.s4TopIcon||{};
  if(_ti&&_ti.iconKey){p.style.paddingTop='16px';
    var _tiEl=document.createElement('img');
    var _tiSz=Math.round(uniformFs4*0.9);
    var _tiCol=_ti.iconColour||c.fc;
    var _tiRot=_ti.iconRotation||0;
    var _tiFlip=_ti.iconFlip?'scaleX(-1)':'';
    var _tiSide=_ti.iconSide||'center';
    var _tiJc=_tiSide==='left'?'flex-start':_tiSide==='right'?'flex-end':'center';
    var _tiWrap=document.createElement('div');
    _tiWrap.style.cssText='display:flex;justify-content:'+_tiJc+';';
    _tiEl.src=_ti.iconKey;_tiEl.alt='';
    _tiEl.style.cssText='width:auto;height:'+_tiSz+'px;max-width:'+Math.round(_tiSz*1.8)+'px;object-fit:contain;display:block;transform:rotate('+_tiRot+'deg) '+_tiFlip+';filter:'+ntIconFilter(_tiCol)+';';
    _tiWrap.appendChild(_tiEl);
    p.appendChild(_tiWrap);
    block.style.marginTop='0';
  }

  p.appendChild(block);
  const bg=document.getElementById('s4Bg');if(!bg)return;
  // Background: subtle linen texture via CSS gradients
  var _bgColor=c.lt?'#f5f5f5':'#ffffff';
  var _grainColor=c.lt?'rgba(0,0,0,0.025)':'rgba(196,160,120,0.07)';
  bg.style.backgroundColor=_bgColor;
  bg.style.backgroundImage=
    'repeating-linear-gradient(0deg,'+_grainColor+' 0px,transparent 1px,transparent 3px),'
    +'repeating-linear-gradient(90deg,'+_grainColor+' 0px,transparent 1px,transparent 6px)';
  bg.style.backgroundSize='4px 4px,7px 7px';
  bg.style.display='flex';
  bg.style.minHeight='160px';
  bg.style.visibility='visible';
  bg.style.opacity='1';
  // bg colour set above via backgroundColor + backgroundImage
  // Only force visible if NOT intentionally collapsed by scroll
  var _s4wr=document.getElementById('s4Wrap');
  if(_s4wr&&!_s4wr.classList.contains('nt-collapsed')){
    var _cwr=document.getElementById('ntCanvasWrap');
    if(_cwr&&!_cwr.style.maxHeight){_cwr.style.cssText='max-height:none;overflow:visible;opacity:1;display:block;';}
  }
  bg.innerHTML='';bg.appendChild(p);

  // ── ICON ON LETTER — draggable overlay ───────────
  const _ilD=window.ntLetterIcon;
  if(_ilD&&_ilD.active){
    bg.style.position='relative';
    const _iov=document.createElement('div');
    _iov.id='ntLetterIconOverlay';
    const _isz=Math.round(uniformFs4*0.55);
    const _lx=_ilD.px!=null?_ilD.px:50;
    const _ly=_ilD.py!=null?_ilD.py:15;
    _iov.style.cssText='position:absolute;left:'+_lx+'%;top:'+_ly+'%;transform:translate(-50%,-50%);'
      +'display:flex;flex-direction:column;align-items:center;gap:3px;cursor:move;z-index:20;touch-action:none;user-select:none;';

    const _iimg=document.createElement('img');
    _iimg.src=_ilD.iconSrc;_iimg.alt=_ilD.iconLabel||'';
    const _iRot=_ilD.rotation||0;
    _iimg.style.cssText='width:'+_isz+'px;height:'+_isz+'px;object-fit:contain;pointer-events:none;display:block;'
      +'transform:rotate('+_iRot+'deg);'
      +'filter:'+ntIconFilter(c.fc)+';';

    // hint text — disappears on first drag
    const _hint=document.createElement('div');
    _hint.id='ntILHint';
    const _hintShown=!_ilD._hintDismissed;
    _hint.style.cssText='font-size:9px;font-weight:700;color:#fff;background:rgba(61,43,26,0.72);'
      +'border-radius:20px;padding:2px 8px;white-space:nowrap;pointer-events:none;'
      +'opacity:'+(_hintShown?'1':'0')+';transition:opacity .3s;';
    _hint.textContent='Move to place on letter';

    // wobble animation — keyframes injected once
    if(!document.getElementById('ntILWobbleStyle')){
      const _st=document.createElement('style');
      _st.id='ntILWobbleStyle';
      _st.textContent='@keyframes ntILWobble{'
        +'0%,100%{transform:translate(-50%,-50%) rotate(0deg)}'
        +'20%{transform:translate(-50%,-50%) rotate(-8deg)}'
        +'40%{transform:translate(-50%,-50%) rotate(8deg)}'
        +'60%{transform:translate(-50%,-50%) rotate(-5deg)}'
        +'80%{transform:translate(-50%,-50%) rotate(5deg)}}';
      document.head.appendChild(_st);
    }
    if(_hintShown){
      _iov.style.animation='ntILWobble 1.2s ease-in-out 0.4s 3';
    }

    _iov.appendChild(_iimg);
    _iov.appendChild(_hint);
    bg.appendChild(_iov);

    // drag logic — dismiss hint on first touch
    let _dragging=false;
    const _dismissHint=function(){
      _hint.style.opacity='0';
      _iov.style.animation='none';
      window.ntLetterIcon._hintDismissed=true;
    };
    const _onMove=function(e){
      if(!_dragging)return;
      const _r=bg.getBoundingClientRect();
      const _cx=e.touches?e.touches[0].clientX:e.clientX;
      const _cy=e.touches?e.touches[0].clientY:e.clientY;
      const _nx=Math.max(0,Math.min(100,((_cx-_r.left)/_r.width)*100));
      const _ny=Math.max(0,Math.min(100,((_cy-_r.top)/_r.height)*100));
      _iov.style.left=_nx+'%';_iov.style.top=_ny+'%';
      window.ntLetterIcon.px=_nx;window.ntLetterIcon.py=_ny;
    };
    const _onUp=function(){
      _dragging=false;
      document.removeEventListener('mousemove',_onMove);
      document.removeEventListener('mouseup',_onUp);
      document.removeEventListener('touchmove',_onMove);
      document.removeEventListener('touchend',_onUp);
    };
    _iov.addEventListener('mousedown',function(e){
      e.preventDefault();_dragging=true;
      _dismissHint();
      document.addEventListener('mousemove',_onMove);
      document.addEventListener('mouseup',_onUp);
    });
    _iov.addEventListener('touchstart',function(e){
      e.preventDefault();_dragging=true;
      _dismissHint();
      document.addEventListener('touchmove',_onMove,{passive:false});
      document.addEventListener('touchend',_onUp);
    },{passive:false});

    // Tap canvas background (not the icon) to cycle letter icon between lines
    bg.addEventListener('click',function(e){
      if(e.target===_iov||_iov.contains(e.target))return;
      if(!window.ntLetterIcon||!window.ntLetterIcon.active)return;
      var totalLines=curLines.length+(window.s4NameLines||[]).filter(Boolean).length;
      if(totalLines<2)return;
      var cur=window.ntLetterIcon.line||0;
      window.ntLetterIcon.line=(cur+1)%totalLines;
      // Reset position to top of new line
      window.ntLetterIcon.py=15;
      renderS4();
    });
  }

  if(typeof window.ntAutoSaveHook==='function')window.ntAutoSaveHook();
  try{ntRenderIconColourPill();}catch(e){}
}

function updateS4(){renderS4();}

function renderC4(){
  var _crow4=document.getElementById('crow4');if(!_crow4)return;
  var _colors=ntGetColors();if(selC4>=_colors.length)selC4=0;
  var _lbl4=document.getElementById('ntColLabel4');if(_lbl4)_lbl4.textContent=_colors[selC4]?_colors[selC4].n:'';
  var _swBase='display:block!important;width:26px!important;height:26px!important;min-width:26px;min-height:26px;border-radius:50%;cursor:pointer;flex-shrink:0;transition:transform .15s,border-color .15s;padding:0;margin:0;';
  _crow4.innerHTML=
    _colors.map((c,i)=>{
      var sel=i===selC4;
      var border=sel?'border:2.5px solid #3d2b1a!important;transform:scale(1.2);':'border:2px solid transparent;';
      var shadow=c.lt?'box-shadow:0 0 0 1px #c0b8ac;':'';
      return '<div style="'+_swBase+border+shadow+'background:'+c.fc+';" onclick="pc4('+i+')" title="'+c.n+'"></div>';
    }).join('');
}
function pc4(i){
  const _c=ntGetColors();selC4=Math.min(i,_c.length-1);window.selC4=selC4;
  renderS4();renderC4();
  try{renderS4SizeBar();}catch(e){}
  try{ntRenderIconColourPill();}catch(e){}
  try{if(window._ntIconPopupLine!=null)ntRenderIconPopup();}catch(e){}
  if(typeof ntRenderIconStrips==='function')setTimeout(ntRenderIconStrips,50);
}

// ══════════════════════════════════════════════════════
// EMOJI BLOCK — strip emoji from any input/textarea
// ══════════════════════════════════════════════════════
function ntStripEmoji(s){
  return s.replace(/\p{Extended_Pictographic}(‍\p{Extended_Pictographic})*/gu,'')
          .replace(/[\u{FE00}-\u{FE0F}\u{20E3}]/gu,'')
          .replace(/‍/g,'');
}
function ntNoEmoji(el){
  if(!el||el._noEmoji) return;
  el._noEmoji=true;
  el.addEventListener('paste',function(e){
    e.preventDefault();
    var text=(e.clipboardData||window.clipboardData).getData('text/plain');
    var clean=ntStripEmoji(text);
    document.execCommand('insertText',false,clean);
  });
  el.addEventListener('input',function(){
    var pos=el.selectionStart||0;
    var clean=ntStripEmoji(el.value);
    if(clean!==el.value){el.value=clean;try{el.setSelectionRange(Math.min(pos,clean.length),Math.min(pos,clean.length));}catch(e){}}
  });
}

// ══════════════════════════════════════════════════════
// LISTENERS
// ══════════════════════════════════════════════════════
var _mi=document.getElementById('mainInp');if(_mi)_mi.addEventListener('input',function(){
  const q=this.value.trim();
  document.getElementById('exactPrompt').style.display=q.length>2?'block':'none';
  if(!q.length){exactMode=false;var _tb=document.getElementById('tierBadge');if(_tb)_tb.classList.remove('show');}
  const hint=document.getElementById('inputHint');
  if(hint)hint.style.display=q?'none':'';
});
async function sendS4Chat(){
  const inp=document.getElementById('s4ChatInp');
  const msg=inp.value.trim();if(!msg)return;
  inp.value='';
  const log=document.getElementById('s4ChatLog');
  const um=document.createElement('div');
  um.style.cssText='font-size:11px;background:#f5ede4;color:var(--brown);padding:6px 10px;border-radius:10px;align-self:flex-end;max-width:85%;';
  um.textContent=msg;log.appendChild(um);log.scrollTop=log.scrollHeight;
  const btn=document.getElementById('s4ChatBtn');btn.disabled=true;btn.textContent='…';
  const nameInput=document.getElementById('nameInp').value.trim();
  const currentLines=replaceName(curLines,nameInput);
  const chatSys=`You are the design assistant for NukkadTales wooden pieces.
Current design lines: ${JSON.stringify(currentLines)}
Name typed by customer: "${nameInput}"
Original template lines: ${JSON.stringify(curLines)}

Customer wants a change. Just do it. No explanations, no lectures.
Rules: max 9 chars per line, max 3 lines, connectors (an,my,no,is,a,the,&) on own line.
If they ask for icon placement — that's handled separately, just say "tap the icon position above".
If request is impossible — just give the closest version you can.

Return ONLY valid JSON: {"lines":["line1","line2"],"reply":"one short friendly sentence, max 10 words"}`;
  try{
    const raw=await callAI(MODEL_SUGG,chatSys,msg,400);
    const match=raw.match(/\{[\s\S]*\}/);
    if(match){
      let jsonStr=match[0].replace(/,\s*([}\]])/g,'$1');
      const result=JSON.parse(jsonStr);
      if(result.lines&&Array.isArray(result.lines)){
        curLines=result.lines;
        renderS4();
        const am=document.createElement('div');
        am.style.cssText='font-size:11px;background:#f0f4f0;color:#2a3a2a;padding:6px 10px;border-radius:10px;align-self:flex-start;max-width:85%;';
        am.textContent=result.reply||'Done — check the design above.';
        log.appendChild(am);log.scrollTop=log.scrollHeight;
      }
    }
  }catch(e){
    const em=document.createElement('div');
    em.style.cssText='font-size:11px;color:#c0392b;padding:4px 10px;';
    em.textContent='Could not apply change. Try rephrasing.';
    log.appendChild(em);
  }
  btn.disabled=false;btn.textContent='→';
}
var _mi2=document.getElementById('mainInp');if(_mi2)_mi2.addEventListener('keydown',e=>{if(e.key==='Enter'&&(e.ctrlKey||e.metaKey))doCreate();});
var _mi3=document.getElementById('mainInp');if(_mi3)ntNoEmoji(_mi3);

function highlightInput(tier){
  const box=document.getElementById('mainInputBox');
  const ta=document.getElementById('mainInp');if(!ta)return;
  if(!box||!ta)return;
  box.scrollIntoView({behavior:'smooth',block:'center'});
  box.style.borderColor='var(--orange)';
  box.style.boxShadow='0 0 0 4px rgba(196,122,69,0.15)';
  ta.focus();
  let nudge=document.getElementById('inputNudge');
  if(!nudge){
    nudge=document.createElement('div');
    nudge.id='inputNudge';
    nudge.style.cssText='font-size:11px;font-weight:600;color:var(--orange);text-align:center;margin-top:6px;transition:opacity .4s;';
    box.parentElement.appendChild(nudge);
  }
  nudge.textContent='Type your '+tier+' idea here →';
  nudge.style.opacity='1';
  setTimeout(()=>{box.style.borderColor='#c8b09a';box.style.boxShadow='0 3px 16px rgba(61,43,26,0.10)';nudge.style.opacity='0';},3000);
}

(function(){
  const ta=document.getElementById('mainInp');
  const box=document.getElementById('mainInputBox');
  if(!ta||!box)return;
  const ph=['A motivating quote for my gym buddy…','Rahul & Priya — our 5 years together…','"No Pain No Gain" for Dr. Arjun…','My boss Nidhi retiring after 15 years…','Sharma & Sons — our family business…','Something for my home office wall…'];
  let pi=0,pt;
  function rp(){ta.placeholder=ph[pi%ph.length];pi++;pt=setTimeout(rp,2800);}
  rp();
  const hint=document.getElementById('inputHint');
  ta.addEventListener('input',()=>{if(hint)hint.style.display=ta.value?'none':'';});
  ta.addEventListener('focus',()=>{clearTimeout(pt);ta.placeholder='';box.style.borderColor='var(--orange)';box.style.boxShadow='0 3px 16px rgba(196,122,69,0.22)';});
  ta.addEventListener('blur',()=>{if(!ta.value.trim()){rp();if(hint)hint.style.display='';box.style.borderColor='#c8b09a';box.style.boxShadow='0 3px 16px rgba(61,43,26,0.13)';}});
})();
const s4ci=document.getElementById('s4ChatInp');if(s4ci)s4ci.addEventListener('keydown',e=>{if(e.key==='Enter')sendS4Chat();});

// ══════════════════════════════════════════════════════
// MANTRA STAGE
// ══════════════════════════════════════════════════════
let mantraLines=[];
let mantraAiInch=18;
let mantraCurInch=18;
let mantraBasePrice=3299;
let mantraQtyVal=1;

const MANTRA_MAX_LINES=4;
function breakMantraLines(text){
  const words=text.replace(/ \/ /g,' ').trim().split(/\s+/).filter(Boolean);
  const lines=[];
  let cur='';
  for(const w of words){
    if(lines.length>=MANTRA_MAX_LINES) break;
    const candidate=cur?cur+' '+w:w;
    if(candidate.length<=MANTRA_CHAR_LIMIT){
      cur=candidate;
    } else {
      if(cur)lines.push(cur);
      cur=w.slice(0,MANTRA_CHAR_LIMIT);
      if(w.length>MANTRA_CHAR_LIMIT&&lines.length<MANTRA_MAX_LINES-1){
        lines.push(cur);cur='';
      }
    }
  }
  if(cur&&lines.length<MANTRA_MAX_LINES)lines.push(cur);
  return lines.length>0?lines:[text.slice(0,MANTRA_CHAR_LIMIT)];
}

function mantraCharSizeBump(){
  if(!mantraLines.length) return 0;
  const maxChars=Math.max(...mantraLines.map(l=>(l||'').length));
  const over=Math.max(0,maxChars-MANTRA_CHAR_LIMIT);
  return Math.ceil(over/2)*2;
}
function mantraCalcAiInch(){
  const lineInch=calcMantraInch(mantraLines);
  const bump=mantraCharSizeBump();
  return Math.min(36,lineInch+bump);
}
function mantraCharHint(){
  const maxChars=Math.max(...(mantraLines.length?mantraLines:['']).map(l=>(l||'').length));
  const over=Math.max(0,maxChars-MANTRA_CHAR_LIMIT);
  if(!over) return '';
  const bump=Math.ceil(over/2)*2;
  return `Longest line has ${maxChars} letters — recommended size bumped to ${Math.min(36,calcMantraInch(mantraLines)+bump)}" (+₹${bump*100})`;
}
function calcMantraInch(lines){
  const n=lines.length||1;
  if(n<=2) return 18;
  if(n<=3) return 24;
  return 36;
}

async function goMantra(text, price){
  mantraBasePrice=price;
  mantraLines=breakMantraLines(text);
  mantraAiInch=calcMantraInch(mantraLines);
  mantraCurInch=mantraAiInch;
  mantraQtyVal=1;

  const badge=document.getElementById('mantraTypeBadge');
  if(badge){
    badge.textContent=price>=3299?'MANTRA · ₹3,299':'SHAYARI · ₹2,299';
    badge.style.background=price>=3299?'#1e1408':'#1e3a5f';
    badge.style.color=price>=3299?'#e8c84a':'#f2ece3';
  }

  showSt('stageMantra');
  requestAnimationFrame(()=>{renderMantraChips();updateMantraSizeBar();updateMantraTotalLine();});
  const _nc=document.getElementById('ntEditorBody');if(_nc)_nc.scrollTop=0;
}

const MANTRA_CHAR_LIMIT=12;

function calcMantraCurrentPrice(){
  const base=mantraBasePrice||2299;
  const baseLines=base>=3299?4:2;
  const extra=Math.max(0,mantraLines.length-baseLines);
  return base+extra*500;
}
function updateMantraCommBtn(){
  const btn=document.getElementById('mantraCommBtn');
  const lbl=document.getElementById('mantraAddLinePrice');
  const addBtn=document.getElementById('mantraAddLineBtn');
  const sizeExtra=Math.max(0,(mantraCurInch||18)-(mantraAiInch||18))*100;
  const linePrice=calcMantraCurrentPrice();
  const total=linePrice+sizeExtra;
  if(btn&&!btn._designerOn)btn.textContent=((window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.txt&&window.NUKKAD_CONFIG.txt.commLabel)||'Add to Cart')+' · ₹'+total.toLocaleString('en-IN');
  const atMax=mantraLines.length>=MANTRA_MAX_LINES;
  if(addBtn){addBtn.style.opacity=atMax?'0.35':'1';addBtn.style.pointerEvents=atMax?'none':'auto';}
  if(lbl)lbl.textContent=atMax?'(max 4 lines)':'· +₹500';
}
function mantraAddLine(){
  mantraLines.push('');
  mantraAiInch=calcMantraInch(mantraLines);
  mantraCurInch=mantraAiInch;
  renderMantraChips();
  updateMantraSizeBar();
  updateMantraTotalLine();
  renderMantraPreview();
  updateMantraCommBtn();
  setTimeout(()=>editMantraLine(mantraLines.length-1),50);
}
function renderMantraChips(){
  const wrap=document.getElementById('mantraChipWrap');
  if(!wrap)return;
  wrap.innerHTML='';
  mantraLines.forEach((line,i)=>{
    const chip=document.createElement('div');
    chip.className='mantra-chip';
    chip.id='mchip-'+i;
    const overLimit=line.length>MANTRA_CHAR_LIMIT;
    chip.innerHTML=`
      <span class="mantra-chip-text" id="mct-${i}" style="${overLimit?'color:var(--orange);':''}">${line}</span>
      <span style="font-size:9px;color:${overLimit?'var(--orange)':'var(--light)'};flex-shrink:0;margin-right:4px;">${line.length}/${MANTRA_CHAR_LIMIT}</span>
      <button class="mantra-chip-edit" onclick="editMantraLine(${i})">✎</button>
    `;
    wrap.appendChild(chip);
    if(i<mantraLines.length-1){
      const gap=document.createElement('div');
      gap.style.height='4px';
      wrap.appendChild(gap);
    }
  });
  updateMantraCommBtn();
}

function editMantraLine(i){
  const chip=document.getElementById('mchip-'+i);
  const textEl=document.getElementById('mct-'+i);
  if(!chip||!textEl)return;
  chip.classList.add('editing');
  const inp=document.createElement('input');
  inp.className='mantra-chip-inp';
  inp.value=mantraLines[i];
  inp.maxLength=MANTRA_CHAR_LIMIT;
  inp.placeholder='max 12 letters';
  inp.style.flex='1';
  const counter=chip.querySelector('span[style*="font-size:9px"]');
  if(counter){
    inp.addEventListener('input',()=>{
      const n=inp.value.length;
      counter.textContent=n+'/'+MANTRA_CHAR_LIMIT;
      counter.style.color=n>MANTRA_CHAR_LIMIT?'#e74c3c':'var(--teal)';
    });
  }
  textEl.replaceWith(inp);
  const btn=chip.querySelector('.mantra-chip-edit');
  btn.textContent='✓';
  btn.onclick=()=>saveMantraLine(i,inp,chip,btn);
  inp.addEventListener('keydown',e=>{if(e.key==='Enter')saveMantraLine(i,inp,chip,btn);});
  inp.focus();inp.select();
}

function saveMantraLine(i,inp,chip,btn){
  mantraLines[i]=inp.value.trim()||mantraLines[i];renderMantraPreview();
  updateMantraSizeBar();updateMantraTotalLine();updateMantraCommBtn();
  chip.classList.remove('editing');
  renderMantraChips();
  mantraAiInch=calcMantraInch(mantraLines);
  mantraCurInch=Math.max(mantraAiInch,mantraCurInch);
  updateMantraSizeBar();
}

function mergeMantraLines(a,b){
  mantraLines[a]=mantraLines[a]+' '+mantraLines[b];
  mantraLines.splice(b,1);
  renderMantraChips();
  mantraAiInch=calcMantraInch(mantraLines);
  mantraCurInch=Math.max(mantraAiInch,mantraCurInch);
  updateMantraSizeBar();
}

function updateMantraSizeBar(){
  mantraAiInch=mantraCalcAiInch();
  if(!mantraCurInch||mantraCurInch<mantraAiInch) mantraCurInch=mantraAiInch;
  const aiEl=document.getElementById('mantraAiInch');
  const curEl=document.getElementById('mantraCurInch');
  if(aiEl)aiEl.textContent=mantraAiInch+'"';
  if(curEl)curEl.textContent=mantraCurInch+'"';
  const hint=mantraCharHint();
  let hintEl=document.getElementById('mantraCharHint');
  if(!hintEl){
    hintEl=document.createElement('div');hintEl.id='mantraCharHint';
    hintEl.style.cssText='font-size:10px;color:var(--orange);margin:-8px 0 10px;padding:6px 12px;background:#fff8f2;border-radius:8px;border:1px solid rgba(196,122,69,0.2);';
    const sizeBar=document.getElementById('mantraSizeBar');
    if(sizeBar)sizeBar.after(hintEl);
  }
  hintEl.textContent=hint;
  hintEl.style.display=hint?'block':'none';
}

function mantraResizeDelta(delta){
  const next=Math.max(mantraAiInch,Math.min(36,mantraCurInch+delta));
  mantraCurInch=next;
  updateMantraSizeBar();
}

function mantraQtyDelta(delta){
  mantraQtyVal=Math.max(1,mantraQtyVal+delta);
  document.getElementById('mantraQty').textContent=mantraQtyVal;
  updateMantraTotalLine();
}

function updateMantraTotalLine(){
  const el=document.getElementById('mantraTotalLine');
  if(!el)return;
  const sizeExtra=Math.max(0,mantraCurInch-mantraAiInch)*100;
  const linePrice=calcMantraCurrentPrice();
  const unitPrice=linePrice+sizeExtra;
  const total=unitPrice*mantraQtyVal;
  el.textContent=mantraQtyVal>1
    ?`₹${unitPrice.toLocaleString('en-IN')} × ${mantraQtyVal} = ₹${total.toLocaleString('en-IN')}`
    :`₹${unitPrice.toLocaleString('en-IN')} · ${mantraCurInch}"`;
  const btn=document.getElementById('mantraCommBtn');
  if(btn&&!btn._designerOn)btn.textContent=((window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.txt&&window.NUKKAD_CONFIG.txt.commLabel)||'Add to Cart')+' · ₹'+unitPrice.toLocaleString('en-IN');
}

function mantraCommission(){
  const extra=Math.max(0,mantraCurInch-mantraAiInch)*100;
  const unitPrice=mantraBasePrice+extra;
  const total=unitPrice*mantraQtyVal;
  const text=mantraLines.join(' / ');
  const wa=`https://wa.me/919999999999?text=${encodeURIComponent(`Hi NukkadTales! I'd like to commission a mantra/shayari piece:
"${text}"
Size: ${mantraCurInch}"
Qty: ${mantraQtyVal}
Total: ₹${total.toLocaleString('en-IN')}`)}`;
  window.open(wa,'_blank');
}

// ══════════════════════════════════════════════════════
// DESIGNER CALL ADD-ON · +₹500 flat fee
// ══════════════════════════════════════════════════════
const designerState={};

function toggleDesigner(toggleId, btnId, basePrice){
  const on=!designerState[toggleId];
  designerState[toggleId]=on;
  const chkId=toggleId==='designerToggle'?'designerChk':toggleId==='renderDesignerToggle'?'renderDesignerChk':'mantraDesignerChk';
  const chk=document.getElementById(chkId);
  const wrap=document.getElementById(toggleId);
  const btn=document.getElementById(btnId);
  if(chk){
    chk.style.background=on?'var(--orange)':'#fff';
    chk.style.borderColor=on?'var(--orange)':'var(--border)';
    chk.innerHTML=on?'<svg width="10" height="8" viewBox="0 0 10 8" fill="none"><path d="M1 4L3.5 6.5L9 1" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>':'';
  }
  if(wrap) wrap.style.borderColor=on?'var(--orange)':'var(--border)';
  if(btn){
    const extra=on?500:0;
    if(toggleId==='mantraDesignerToggle'){
      const sizeExtra=Math.max(0,mantraCurInch-mantraAiInch)*100;
      const total=(mantraBasePrice+sizeExtra+extra)*mantraQtyVal;
      btn.textContent=on
        ?((window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.txt&&window.NUKKAD_CONFIG.txt.commLabel)||'Add to Cart')+' · ₹'+(mantraBasePrice+sizeExtra+extra).toLocaleString('en-IN')+' + designer call'
        :`${(window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.txt&&window.NUKKAD_CONFIG.txt.commLabel)||'Add to Cart'}`;
      updateMantraTotalLine();
    } else {
      const curText=btn.textContent;
      const match=curText.match(/₹([\d,]+)/);
      const curBase=match?parseInt(match[1].replace(/,/g,''),10):basePrice;
      const newPrice=on?curBase+500:curBase-500;
      btn.textContent=on
        ?((window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.txt&&window.NUKKAD_CONFIG.txt.commLabel)||'Add to Cart')+' · ₹'+newPrice.toLocaleString('en-IN')+' (+designer)'
        :((window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.txt&&window.NUKKAD_CONFIG.txt.commLabel)||'Add to Cart')+' · ₹'+newPrice.toLocaleString('en-IN');
    }
  }
}

function isDesignerAdded(toggleId){return !!designerState[toggleId];}

// ── CUSTOM COLOURS — add your brand colours here ─────
// Format: {n:'Colour Name', fc:'#hexcode', lt:0}  (lt:1 = light colour, adds border)
// These appear after the 8 default colours in the colour picker
// You can also add colours via Shopify Customizer → Nukkad Customiser → Add block → Custom colour
// custom colors defined at top of file

// ── STICKY CANVAS + FLOATING COMMISSION BAR ────────────────────

function ntInitStickyCanvas(){
  if(!document.getElementById('ntStickyStyles')){
    var st=document.createElement('style');
    st.id='ntStickyStyles';
    // No transition on ntCanvasWrap to prevent hide-on-init
    st.textContent=
      '#ntInlineCommBar{display:none;align-items:center;gap:10px;padding:8px 14px 12px;background:var(--cream,#f5ede0);border-top:1px solid var(--border,#e8d5c0);}'
      +'#ntInlineCommBar.show{display:flex;}'
      +'#ntCanvasWrap{max-height:none;overflow:visible;opacity:1;display:block;}'
      +'#s4Wrap.nt-collapsed #ntCanvasWrap{max-height:20%;overflow:hidden;transition:max-height .3s ease;opacity:1;}'
      +'#s4Wrap.nt-collapsed{box-shadow:0 4px 12px rgba(61,43,26,0.13)!important;}';
    document.head.appendChild(st);
  }

  // Force uncollapsed on init
  var s4w=document.getElementById('s4Wrap');
  if(!s4w)return;
  s4w.classList.remove('nt-collapsed');

  // Force sticky via inline — overrides theme CSS
  s4w.style.setProperty('position','sticky','important');
  s4w.style.setProperty('top','0','important');
  s4w.style.setProperty('z-index','9999','important');
  s4w.style.setProperty('background','var(--cream,#f5ede0)','important');
  // No box-shadow on load — only appears when collapsed

  // Wrap canvas in collapsible div (once)
  var s4bg=document.getElementById('s4Bg');
  if(s4bg&&!document.getElementById('ntCanvasWrap')){
    var cw=document.createElement('div');
    cw.id='ntCanvasWrap';
    s4bg.parentNode.insertBefore(cw,s4bg);
    cw.appendChild(s4bg);
  }

  // Build inline commission bar
  if(!document.getElementById('ntInlineCommBar')){
    var bar=document.createElement('div');
    bar.id='ntInlineCommBar';
    bar.innerHTML=
      '<div id="ntInlineScrollUp" style="flex:1;min-width:0;cursor:pointer;">'
        +'<div id="ntInlineLines" style="font-family:\'Poppins\',sans-serif;font-weight:900;font-size:12px;color:#3d2b1a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:1.2;"></div>'
        +'<div style="font-size:9px;color:#c47a45;margin-top:2px;font-weight:700;">↑ tap to see design</div>'
      +'</div>'
      +'<button id="ntInlineBtn" onclick="ntCommissionPersonal()" style="background:#c47a45!important;color:#fff!important;border:none;border-radius:20px;padding:10px 16px;font-size:12px;font-weight:700;cursor:pointer;font-family:\'DM Sans\',sans-serif;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:180px;flex-shrink:0;"></button>';
    s4w.appendChild(bar);

    document.getElementById('ntInlineScrollUp').addEventListener('click',function(){
      s4w.classList.remove('nt-collapsed');
      document.getElementById('ntInlineCommBar').classList.remove('show');
      // Only scroll the slider's own container — never window
      if(window._ntScroller&&window._ntScroller!==window){
        window._ntScroller.scrollTo({top:0,behavior:'smooth'});
      }
    });
  }

  // Scroll listener on window — most reliable for Shopify sliders
  var s4BtnEl=document.getElementById('s4Btn');
  if(!s4BtnEl)return;

  function checkCollapse(){
    var sw=document.getElementById('s4Wrap');
    var ib=document.getElementById('ntInlineCommBar');
    if(!sw||!ib)return;
    var rect=s4BtnEl.getBoundingClientRect();
    var swRect=sw.getBoundingClientRect();
    if(rect.bottom===0&&rect.top===0)return;
    var isCollapsed=sw.classList.contains('nt-collapsed');
    // Collapse: button top goes below canvas bottom (button visually reaches canvas)
    // Expand: button is 220px below canvas — large gap prevents flicker
    if(!isCollapsed&&rect.top<swRect.bottom){
      sw.classList.add('nt-collapsed');
      sw.style.setProperty('box-shadow','0 4px 12px rgba(61,43,26,0.13)','important');
      // Remove inline override so CSS class takes effect
      var _cw2=document.getElementById('ntCanvasWrap');
      if(_cw2)_cw2.style.cssText='';
      ntUpdateFloatBar();
      ib.classList.add('show');
    } else if(isCollapsed&&rect.top>swRect.bottom+220){
      sw.classList.remove('nt-collapsed');
      sw.style.removeProperty('box-shadow');
      ib.classList.remove('show');
      setTimeout(checkShadow,10);
    }
  }

  // Attach scroll listener to slider's scroll container
  if(window._ntScrollHandler){
    var _old=window._ntScrollHandler;
    if(window._ntScroller)window._ntScroller.removeEventListener('scroll',_old);
    window.removeEventListener('scroll',_old);
  }
  window._ntScrollHandler=checkCollapse;
  var _eb=document.getElementById('ntEditorBody');
  window._ntScroller=_eb||window;
  window._ntScroller.addEventListener('scroll',checkCollapse,{passive:true});
  // Shadow below canvas — appears only when scrolled (not on initial load)
  function checkShadow(){
    var sw=document.getElementById('s4Wrap');
    if(!sw)return;
    var scrolled=(window._ntScroller&&window._ntScroller!==window)
      ?window._ntScroller.scrollTop>8
      :window.scrollY>8;
    if(scrolled&&!sw.classList.contains('nt-collapsed')){
      sw.style.setProperty('box-shadow','0 4px 12px rgba(61,43,26,0.13)','important');
    } else if(!sw.classList.contains('nt-collapsed')){
      sw.style.removeProperty('box-shadow');
    }
  }
  window._ntScroller.addEventListener('scroll',checkShadow,{passive:true});
  checkShadow();
  checkCollapse();
}

function ntUpdateFloatBar(){
  var inlineBtn=document.getElementById('ntInlineBtn');
  var inlineLines=document.getElementById('ntInlineLines');
  var s4BtnEl=document.getElementById('s4Btn');
  // Mirror commission price
  if(inlineBtn&&s4BtnEl)inlineBtn.textContent=s4BtnEl.textContent||((window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.txt&&window.NUKKAD_CONFIG.txt.commLabel)||'Add to Cart');
  // Lines preview
  var lines=[...(curLines||[]).filter(Boolean),...((window.s4NameLines||[]).filter(Boolean))];
  if(inlineLines)inlineLines.textContent=lines.join(' · ');
}

function ntDestroySticky(){
  if(window._ntStickyObs){window._ntStickyObs.disconnect();window._ntStickyObs=null;}
  if(window._ntScrollHandler&&window._ntScroller){
    window._ntScroller.removeEventListener('scroll',window._ntScrollHandler);
    // Also remove from ntEditorBody in case that was used
    var _eb2=document.getElementById('ntEditorBody');
    if(_eb2)_eb2.removeEventListener('scroll',window._ntScrollHandler);
    window._ntScrollHandler=null;window._ntScroller=null;
  }
  var ib=document.getElementById('ntInlineCommBar');if(ib)ib.remove();
  var s4w=document.getElementById('s4Wrap');
  if(s4w){s4w.classList.remove('nt-collapsed');s4w.style.position='';s4w.style.top='';s4w.style.zIndex='';s4w.style.background='';s4w.style.boxShadow='';}
}
window.ntInitStickyCanvas=ntInitStickyCanvas;
window.ntUpdateFloatBar=ntUpdateFloatBar;
window.ntDestroySticky=ntDestroySticky;

// ── HINDI HINT — shows when Hindi active, hides when global font changes away ──
function ntRefreshHindiHint(){
  var any999=selFont==='hindi'||(window.lineOpts||[]).some(function(o){return o&&o.fontOverride==='hindi';});
  var anyS4=selFont4==='hindi'||(window.s4LineOpts||[]).some(function(o){return o&&o.fontOverride==='hindi';});
  var h999=document.getElementById('hindiHint');
  var hS4=document.getElementById('hindiHintS4');
  if(h999)h999.style.display=any999?'block':'none';
  if(hS4)hS4.style.display=anyS4?'block':'none';
}
window.ntRefreshHindiHint=ntRefreshHindiHint;

// ── BREAK LONGEST LINE — scrolls to chip, flashes green for 1s ──
function ntBreakLongestLine(){}

function ntDismissBreakPrompt(){}
window.ntBreakLongestLine=ntBreakLongestLine;
window.ntDismissBreakPrompt=ntDismissBreakPrompt;

// ── VIDEO — override liquid versions to support direct MP4/Shopify CDN links ──
function ntIsDirectVideo(url){
  return !!(url&&(url.match(/\.(mp4|webm|ogg|mov)(\?|$)/i)||url.includes('cdn.shopify.com/videos')));
}

// Open a fullscreen overlay to play the video with an X to close
function ntPlayVideoFull(url){
  if(!url)return;
  var ov=document.createElement('div');
  ov.id='ntVideoFullscreen';
  ov.style.cssText='position:fixed;inset:0;z-index:99999;background:#000;display:flex;align-items:center;justify-content:center;';

  var closeBtn=document.createElement('button');
  closeBtn.textContent='✕';
  closeBtn.style.cssText='position:absolute;top:16px;right:16px;z-index:10;background:rgba(0,0,0,0.6);border:none;color:#fff;border-radius:50%;width:40px;height:40px;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;line-height:1;';
  closeBtn.onclick=function(){ov.remove();};
  ov.appendChild(closeBtn);

  if(ntIsDirectVideo(url)){
    var v=document.createElement('video');
    v.src=url;v.controls=true;v.autoplay=true;v.playsInline=true;v.preload='auto';
    v.style.cssText='max-width:100%;max-height:100%;object-fit:contain;display:block;';
    ov.appendChild(v);
    document.body.appendChild(ov);
    v.play().catch(function(){v.muted=true;v.play().catch(function(){});});
  } else {
    var iframe=document.createElement('iframe');
    iframe.src=url+(url.includes('?')?'&':'?')+'autoplay=1';
    iframe.allow='autoplay; fullscreen; picture-in-picture';
    iframe.allowFullscreen=true;
    iframe.style.cssText='width:100vw;height:100vh;border:none;display:block;';
    ov.appendChild(iframe);
    document.body.appendChild(ov);
  }
  // tap backdrop to close
  ov.addEventListener('click',function(e){if(e.target===ov)ov.remove();});
}

// Override ntPlayVideoV (used in stageRender 9:16 vertical cards)
window.ntPlayVideoV=function(card,frameId,url){
  if(!url)return;
  ntPlayVideoFull(url);
};

// Override ntPlayVideoS4 (used in stagePersonal single landscape card)
window.ntPlayVideoS4=function(){
  var url=window.NUKKAD_CONFIG&&NUKKAD_CONFIG.videoUrl||'';
  if(url)ntPlayVideoFull(url);
};

// Override ntInitVideoReviews to handle MP4 thumbnails + show video wrap
window.ntInitVideoReviews=function(){
  function toEmbed(url){
    if(!url)return'';
    // YouTube Shorts
    if(url.includes('youtube.com/shorts/')){
      var id=url.split('youtube.com/shorts/')[1].split(/[?#]/)[0];
      return'https://www.youtube.com/embed/'+id;
    }
    // YouTube watch
    if(url.includes('watch?v=')){
      var id2=url.split('watch?v=')[1].split('&')[0];
      return'https://www.youtube.com/embed/'+id2;
    }
    // YouTube short link
    if(url.includes('youtu.be/')){
      var id3=url.split('youtu.be/')[1].split(/[?#]/)[0];
      return'https://www.youtube.com/embed/'+id3;
    }
    // Vimeo
    if(url.includes('vimeo.com/')&&!url.includes('player.vimeo')){
      var id4=url.split('vimeo.com/')[1].split(/[?#]/)[0];
      return'https://player.vimeo.com/video/'+id4;
    }
    return url; // direct MP4 or already an embed URL
  }

  function makePosting(card,url,thumb,title){
    // Show first-frame poster for MP4 or thumbnail image for YouTube
    var isDirect=ntIsDirectVideo(url);
    // clear old posters
    card.querySelectorAll('video.nt-poster').forEach(function(el){el.remove();});

    if(isDirect){
      // hide the <img> thumb, use a muted video element to show first frame
      var imgEl=card.querySelector('img');if(imgEl)imgEl.style.display='none';
      var poster=document.createElement('video');
      poster.className='nt-poster';
      poster.src=url;poster.preload='metadata';poster.muted=true;
      poster.style.cssText='position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;opacity:0.75;pointer-events:none;';
      card.insertBefore(poster,card.firstChild);
    } else {
      // YouTube/Vimeo — use thumbnail img
      var imgEl2=card.querySelector('img');
      if(imgEl2&&thumb)imgEl2.src=thumb;
    }
    // set label
    var lbl=card.querySelector('div[style*="font-weight:700"]');
    if(lbl)lbl.textContent=title||'';
  }

  var cfg=window.NUKKAD_CONFIG||{};
  var v1=toEmbed(cfg.videoUrl||'');
  var v2=toEmbed(cfg.video2Url||'');
  cfg.videoUrl=v1; cfg.video2Url=v2;

  // ── Vertical side-by-side video cards (stageRender) ──
  var wrap=document.getElementById('ntVideoWrap');
  if(wrap&&(v1||v2)){
    wrap.style.display='flex';
    var c1=document.getElementById('ntVideoCard1');
    var c2=document.getElementById('ntVideoCard2');
    if(c1){
      c1.style.display=v1?'flex':'none';
      c1.style.flex='1';
      if(v1){
        makePosting(c1,v1,cfg.videoThumbnail,cfg.videoTitle||'Quality & finishing');
        c1.onclick=function(){ntPlayVideoFull(v1);};
      }
    }
    if(c2){
      c2.style.display=v2?'flex':'none';
      c2.style.flex='1';
      if(v2){
        makePosting(c2,v2,cfg.video2Thumbnail,cfg.video2Title||'How it\'s made');
        c2.onclick=function(){ntPlayVideoFull(v2);};
      }
    }
  }

  // ── Two square cards in stagePersonal (new layout) ──
  var wrapS4=document.getElementById('ntVideoWrapS4');
  if(wrapS4&&(v1||v2)){
    wrapS4.style.display='block';
    var c1s4=document.getElementById('ntVideoCard1S4');
    var c2s4=document.getElementById('ntVideoCard2S4');
    if(c1s4){
      c1s4.style.display=v1?'block':'none';
      if(v1){
        makePosting(c1s4,v1,cfg.videoThumbnail,cfg.videoTitle||'Quality & finishing');
        var dur1=document.getElementById('ntVideoDur1S4');
        var t1=document.getElementById('ntVideoTitle1S4');
        if(t1)t1.textContent=cfg.videoTitle||'Quality & finishing';
        c1s4.onclick=function(){ntPlayVideoFull(v1);};
      }
    }
    if(c2s4){
      c2s4.style.display=v2?'block':'none';
      if(v2){
        makePosting(c2s4,v2,cfg.video2Thumbnail,cfg.video2Title||'How it\'s made');
        var t2=document.getElementById('ntVideoTitle2S4');
        if(t2)t2.textContent=cfg.video2Title||'How it\'s made';
        c2s4.onclick=function(){ntPlayVideoFull(v2);};
      }
    }
  }

  // Artisan + reviews
  if(typeof ntInitArtisan==='function')ntInitArtisan();
  if(typeof ntLoadReviews==='function')ntLoadReviews();
};

window.ntIsDirectVideo=ntIsDirectVideo;
window.ntPlayVideoFull=ntPlayVideoFull;

window.goRender = goRender;
window.ntGetColors = ntGetColors;
window.renderC4 = renderC4;
window.renderC3 = renderC3;

// ── ICON STRIPS — below chips in stagePersonal ──────────────────
function ntRenderIconStrips(){
  // Save scroll position before DOM rebuild to prevent browser jump
  var _scroller=null,_scrollY=0;
  var el=document.getElementById('ntIconStripsWrap');
  if(el){var p=el.parentElement;while(p&&p!==document.body){var cs=window.getComputedStyle(p);if(/(auto|scroll)/.test(cs.overflow+cs.overflowY)){_scroller=p;_scrollY=p.scrollTop;break;}p=p.parentElement;}}
  var _restoreScroll=function(){if(_scroller)_scroller.scrollTop=_scrollY;};

  var wrap=document.getElementById('ntIconStripsWrap');
  if(!wrap){
    var chips=document.getElementById('s4LineChips');
    if(!chips)return;
    wrap=document.createElement('div');
    wrap.id='ntIconStripsWrap';
    wrap.style.cssText='margin-bottom:12px;';
    chips.parentNode.insertBefore(wrap,chips.nextSibling);
  }
  // PILLS-ONLY MODEL: the old section is hidden; per-line pills below global colour own the icon UI.
  wrap.style.display='none';
  return;
  var lineIcons=allIcons.filter(function(ic){return !ic.forLetter&&!ic.disabled;});
  var letterIcons=allIcons.filter(function(ic){return ic.forLetter&&!ic.disabled;});
  if(!lineIcons.length&&!letterIcons.length){wrap.style.display='none';return;}
  wrap.style.display='block';

  // If line count changed, collapse so user can choose
  var _allStripCount=curLines.length+(window.s4NameLines||[]).filter(function(l){return l&&l.trim();}).length;
  if(window._ntLastStripCount!=null&&window._ntLastStripCount!==_allStripCount){
    window._ntLineStripLine=0;
  }
  window._ntLastStripCount=_allStripCount;
  if(window._ntLineStripLine>_allStripCount)window._ntLineStripLine=0;

  var lineOpen=!!window._ntLineStripOpen;
  var letterOpen=!!window._ntLetterStripOpen;
  var lineStep=window._ntLineStripStep||0;
  var selLine=window._ntLineStripLine||0;
  var selPos=window._ntLineStripPos||'left';
  var selLineIcon=window._ntStripSelIcon||'';
  // Only restore icon state when strip is NOT open (initial teaser state)
  // When open and user has selected a line, never override their selection
  var anyLineHasIcon=(window.s4LineOpts||[]).some(function(o){return o&&o.iconKey;});
  if(anyLineHasIcon&&!selLineIcon&&!lineOpen){
    var firstIconLine=-1;
    (window.s4LineOpts||[]).forEach(function(o,i){if(o&&o.iconKey&&firstIconLine<0)firstIconLine=i;});
    if(firstIconLine>=0){
      var fo=window.s4LineOpts[firstIconLine];
      window._ntStripSelIcon=fo.iconKey;selLineIcon=fo.iconKey;
    }
  }
  var selLetterIcon=window._ntLetterStripIcon||'';
  var showChangeGrid=!!window._ntLineStripShowGrid;
  var multiLine=curLines.length>1;

  function teaserRow(icons,selectedSrc){
    var selIc=selectedSrc&&icons.find(function(ic){return ic.src===selectedSrc;});
    return '<div style="display:flex;gap:5px;align-items:center;flex-shrink:0;">'
      +(selIc
        ?'<img src="'+selIc.src+'" style="width:22px;height:22px;object-fit:contain;" alt="'+selIc.label+'">'
        :icons.slice(0,3).map(function(ic){
          return '<div style="width:34px;height:34px;border-radius:8px;border:1.5px solid #e8d5c0;background:#fdfaf5;display:flex;align-items:center;justify-content:center;flex-shrink:0;">'
            +'<img src="'+ic.src+'" style="width:22px;height:22px;object-fit:contain;" alt="'+ic.label+'" loading="lazy"></div>';
        }).join('')
      )
      +'<div style="font-size:9px;font-weight:700;color:#c47a45;border:1px solid #e8d5c0;border-radius:20px;padding:3px 7px;align-self:center;white-space:nowrap;flex-shrink:0;">'+(selIc?'tap to change':'+ more')+'</div>'
      +'</div>';
  }

  function gridHTML(icons,prefix){
    var cur=prefix==='line'?selLineIcon:selLetterIcon;
    return icons.map(function(ic){
      var on=cur===ic.src;
      return '<div data-src="'+ic.src+'" data-label="'+(ic.label||'').replace(/"/g,'&quot;')+'" onclick="ntStripPickIcon(this,\''+prefix+'\')" '
        +'style="aspect-ratio:1;border-radius:9px;border:1.5px solid '+(on?'#c47a45':'#e8d5c0')+';background:'+(on?'#fff8f3':'#fdfaf5')+';display:flex;align-items:center;justify-content:center;cursor:pointer;">'
        +'<img src="'+ic.src+'" style="width:26px;height:26px;object-fit:contain;" alt="'+ic.label+'" loading="lazy">'
        +'</div>';
    }).join('');
  }

  function linePillsHTML(){
    return curLines.map(function(l,i){
      var on=selLine===i+1;
      return '<div onclick="ntStripSetLine('+(i+1)+')" style="flex:1;padding:8px 4px;border:1.5px solid '+(on?'#c47a45':'#e8d5c0')+';border-radius:9px;background:'+(on?'#c47a45':'#fff')+';text-align:center;font-size:11px;font-weight:700;color:'+(on?'#fff':'#3d2b1a')+';cursor:pointer;font-family:\'Poppins\',sans-serif;">Line '+(i+1)+'</div>';
    }).join('');
  }

  function posPillsHTML(){
    // Center only when selected line has 2+ words
    var selLineText=curLines[(window._ntLineStripLine||1)-1]||'';
    var wordCount=selLineText.trim().split(/\s+/).filter(Boolean).length;
    var showCenter=wordCount>=2;
    return ['left','center','right'].filter(function(p){
      return p!=='center'||showCenter;
    }).map(function(p){
      var on=selPos===p;
      return '<div onclick="ntStripSetPos(\''+p+'\')" style="flex:1;padding:7px 4px;border:1.5px solid '+(on?'#c47a45':'#e8d5c0')+';border-radius:8px;background:'+(on?'#c47a45':'#fff')+';text-align:center;font-size:10px;font-weight:700;color:'+(on?'#fff':'#3d2b1a')+';cursor:pointer;">'+(p.charAt(0).toUpperCase()+p.slice(1))+'</div>';
    }).join('');
  }

  function doneRemoveBar(closeAction,removeAction){
    return '<div style="display:flex;align-items:center;justify-content:space-between;padding:10px 0 4px;">'
      +'<span onclick="event.stopPropagation();'+removeAction+'" style="font-size:10px;color:#c0392b;cursor:pointer;text-decoration:underline;">\u2715 Remove icon</span>'
      +'<button onclick="event.stopPropagation();'+closeAction+'" style="background:var(--orange);color:#fff;border:none;border-radius:20px;padding:5px 16px;font-size:11px;font-weight:700;cursor:pointer;font-family:\'DM Sans\',sans-serif;">Done ✓</button>'
      +'</div>';
  }

  function rotRowHTML(prefix){
    if(prefix==='letter')return''; // rotation hidden for letter icon
    var rv=prefix==='line'?(window._ntLineStripRot||0):(window._ntLetterStripRot||0);
    return '<div style="display:flex;gap:4px;align-items:center;margin-bottom:10px;">'
      +[['↺15\u00b0',-15],['↺5\u00b0',-5],[null,0],['↻5\u00b0',5],['↻15\u00b0',15]].map(function(item){
        if(item[1]===0)return '<div style="min-width:30px;text-align:center;font-size:11px;font-weight:700;color:#3d2b1a;">'+rv+'\u00b0</div>';
        return '<div onclick="ntStripRot(\''+prefix+'\','+item[1]+')" style="flex:1;padding:7px 2px;border:1.5px solid #e8d5c0;border-radius:7px;background:#fff;text-align:center;font-size:10px;font-weight:700;color:#3d2b1a;cursor:pointer;">'+item[0]+'</div>';
      }).join('')
      +'</div>';
  }

  function doneBarHTML(closeAction,removeAction){ return ''; }

  function buildCard(open,icons,selectedSrc,title,sub,openAction,closeAction,removeAction,innerHTML){
    var brd=open?'#c47a45':'#e8d5c0';
    return '<div style="background:#fff;border:1.5px solid '+brd+';border-radius:12px;margin-bottom:8px;">'
      +'<div onclick="if(!'+open+')'+openAction+'" style="padding:10px 12px;display:flex;align-items:center;gap:10px;cursor:'+(open?'default':'pointer')+';">'
        +'<div style="flex:1;">'
          +'<div style="font-size:10px;font-weight:700;color:#3d2b1a;font-family:\'Poppins\',sans-serif;">'+title+'</div>'
          +'<div style="font-size:9px;color:'+(selectedSrc?'#c47a45':'#8c7b6e')+';margin-top:2px;">'+(selectedSrc?(function(){
          // Find which line has the selected icon
          var _opts=window.s4LineOpts||[];
          var _ao={};
          for(var _li=0;_li<_opts.length;_li++){if(_opts[_li]&&_opts[_li].iconKey===selectedSrc){_ao=_opts[_li];break;}}
          var _ic=_ao.iconColour||'';var _in=_ao.iconColourName||'';
          return (_ic?'<span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:'+_ic+';border:1px solid rgba(0,0,0,0.2);vertical-align:middle;margin-right:3px;">&#160;</span>'+_in+' · ':'')+'Tap to change';
        })():sub)+'</div>'
        +'</div>'
        +teaserRow(icons,selectedSrc)
      +'</div>'
      +(open
        ?'<div style="background:#fff8f3;border-top:1px solid #fceedd;padding:12px 12px 16px;border-radius:0 0 12px 12px;">'
          +innerHTML
          +doneBarHTML(closeAction,removeAction)
          +'</div>'
        :'')
      +'</div>';
  }

  // ── Line strip inner content ──
  // Combine curLines + s4NameLines (show all slots, even empty name lines)
  var _allStripLines=curLines.slice();
  var _nameLineOffset=curLines.length;
  (window.s4NameLines||[]).forEach(function(l,ni){
    // Only include name line if it has content (not just empty placeholder)
    if(l&&l.trim())_allStripLines.push(l.trim());
  });
  var totalStripLines=_allStripLines.length;

  function getLineOpt(i){
    if(i<_nameLineOffset)return window.s4LineOpts&&window.s4LineOpts[i]?window.s4LineOpts[i]:{};
    var ni=i-_nameLineOffset;
    return window.s4NameLineOpts&&window.s4NameLineOpts[ni]?window.s4NameLineOpts[ni]:{};
  }
  function setLineIcon(i,src,side,rot){
    if(i<_nameLineOffset){
      if(!window.s4LineOpts[i])window.s4LineOpts[i]={};
      window.s4LineOpts[i].iconKey=src;window.s4LineOpts[i].iconSide=side;window.s4LineOpts[i].iconRotation=rot;
    } else {
      var ni=i-_nameLineOffset;
      if(!window.s4NameLineOpts)window.s4NameLineOpts=[];
      while(window.s4NameLineOpts.length<=ni)window.s4NameLineOpts.push({});
      window.s4NameLineOpts[ni].iconKey=src;window.s4NameLineOpts[ni].iconSide=side;window.s4NameLineOpts[ni].iconRotation=rot;
    }
  }
  function removeLineIcon(i){
    if(i<_nameLineOffset){
      if(window.s4LineOpts&&window.s4LineOpts[i]){delete window.s4LineOpts[i].iconKey;delete window.s4LineOpts[i].iconSide;delete window.s4LineOpts[i].iconRotation;}
    } else {
      var ni=i-_nameLineOffset;
      if(window.s4NameLineOpts&&window.s4NameLineOpts[ni]){delete window.s4NameLineOpts[ni].iconKey;delete window.s4NameLineOpts[ni].iconSide;delete window.s4NameLineOpts[ni].iconRotation;}
    }
  }

  var activeLine=window._ntLineStripLine!=null?window._ntLineStripLine:0;
  var lineInner='';

  if(totalStripLines>1){
    lineInner+='<div style="font-size:9px;font-weight:700;color:#8c7b6e;letter-spacing:.06em;text-transform:uppercase;margin-bottom:8px;">Lines &amp; icons</div>';
  }

  _allStripLines.forEach(function(lineText,i){
    var lineIdx=i+1;
    var lineOpt=getLineOpt(i);
    var iconSrc=lineOpt.iconKey||'';
    var isActive=(totalStripLines===1)||activeLine===lineIdx;
    var isShowGrid=isActive&&(!iconSrc||showChangeGrid);
    var isShowSelected=isActive&&iconSrc&&!showChangeGrid;
    var brd=isActive?'#c47a45':'#e8d5c0';

    if(totalStripLines>1){
      var rowN=isActive?0:lineIdx;
      if(iconSrc){
        var _icColDisp=lineOpt.iconColour||'';
        var _icColName=lineOpt.iconColourName||'';
        var _hasCustomCol=!!_icColDisp;
        lineInner+='<div data-line-n="'+rowN+'" style="display:flex;align-items:center;gap:8px;border:1.5px solid '+brd+';border-radius:'+(isActive?'10px 10px 0 0':'10px')+';padding:8px 12px;background:'+(isActive?'#fff8f3':'#fff')+';cursor:pointer;margin-bottom:'+(isActive?'0':'7px')+';">'          +'<div style="position:relative;flex-shrink:0;"><img src="'+iconSrc+'" style="width:28px;height:28px;object-fit:contain;display:block;filter:'+ntIconFilter(_icColDisp||'#3d2b1a')+';" alt="">'          +(_hasCustomCol?'<div style="position:absolute;bottom:-2px;right:-2px;width:10px;height:10px;border-radius:50%;background:'+_icColDisp+';border:1.5px solid #fff;">&#160;</div>':'')          +'</div>'          +'<div style="flex:1;min-width:0;"><div style="font-size:10px;font-weight:700;color:#3d2b1a;">Line '+lineIdx+'</div>'          +'<div style="font-size:9px;color:#c47a45;margin-top:1px;">'+(isActive?'tap to collapse':(_hasCustomCol?_icColName+' colour · tap to edit':'Has icon · tap to edit'))+'</div></div>'          +(isActive?'<div style="font-size:12px;color:#c47a45;flex-shrink:0;">▲</div>':'<div style="font-size:9px;font-weight:700;color:#c47a45;white-space:nowrap;flex-shrink:0;">Edit ↓</div>')          +'</div>';
      } else {
        lineInner+='<div data-line-n="'+rowN+'" style="display:flex;align-items:center;gap:8px;border:1.5px dashed '+brd+';border-radius:'+(isActive?'10px 10px 0 0':'10px')+';padding:8px 12px;background:'+(isActive?'#fff8f3':'#fdfaf5')+';cursor:pointer;margin-bottom:'+(isActive?'0':'7px')+';">'
          +'<div style="width:28px;height:28px;border-radius:6px;border:1.5px dashed #e8d5c0;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:16px;color:#c8b09a;">+</div>'
          +'<div style="flex:1;min-width:0;"><div style="font-size:10px;font-weight:700;color:#3d2b1a;">Line '+lineIdx+'</div>'
          +'<div style="font-size:9px;color:#8c7b6e;margin-top:1px;">No icon · tap to add</div></div>'
          +(isActive?'<div style="font-size:12px;color:#c47a45;flex-shrink:0;">▲</div>':'')
          +'</div>';
      }
    }

    if(isActive){
      var panelStyle=totalStripLines>1
        ?'border:1.5px solid #c47a45;border-top:none;border-radius:0 0 10px 10px;padding:10px 10px 16px;background:#fff8f3;margin-bottom:7px;'
        :'padding-top:4px;padding-bottom:8px;';

      if(isShowGrid){
        lineInner+='<div style="'+panelStyle+'">'
          +'<div style="font-size:9px;font-weight:700;color:#8c7b6e;letter-spacing:.06em;text-transform:uppercase;margin-bottom:7px;">Choose an icon</div>'
          +'<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(58px,1fr));gap:5px;">'+gridHTML(lineIcons,'line')+'</div>'
          +doneRemoveBar(totalStripLines>1?'ntStripSelectLine(0)':'ntLineStripClose()','ntLineRemoveFromLine('+(lineIdx-1)+')')
          +'</div>';
      } else if(isShowSelected){
        lineInner+='<div style="'+panelStyle+'">'
          +(totalStripLines===1
            ?'<div onclick="ntStripShowGrid()" style="display:flex;align-items:center;gap:8px;border:1.5px solid #e8d5c0;border-radius:10px;padding:8px 12px;background:#fff;cursor:pointer;margin-bottom:10px;">'
              +'<img src="'+iconSrc+'" style="width:28px;height:28px;object-fit:contain;">'
              +'<div style="flex:1;font-size:11px;font-weight:700;color:#3d2b1a;">Selected icon</div>'
              +'<div style="font-size:10px;font-weight:700;color:#c47a45;">Change \u2192</div>'
              +'</div>'
            :'')  // multi-line: line row above is already the header, skip duplicate
          +(totalStripLines>1?'<div onclick="ntStripShowGrid()" style="font-size:9px;font-weight:700;color:#c47a45;cursor:pointer;margin-bottom:10px;text-align:right;">Change icon \u2192</div>':'')
          +ntIconColourSwatches(lineIdx-1)
          +'<div style="font-size:9px;font-weight:700;color:#8c7b6e;letter-spacing:.06em;text-transform:uppercase;margin-bottom:6px;">Position</div>'
          +'<div style="display:flex;gap:5px;margin-bottom:10px;">'+posPillsHTML()+'</div>'
          +'<div style="font-size:9px;font-weight:700;color:#8c7b6e;letter-spacing:.06em;text-transform:uppercase;margin-bottom:6px;">Rotate</div>'
          +rotRowHTML('line')
          +doneRemoveBar(totalStripLines>1?'ntStripSelectLine(0)':'ntLineStripClose()','ntLineRemoveFromLine('+(lineIdx-1)+')')
          +'</div>';
      }
    }
  });

  // Global done/remove only for single line (multi-line has per-line buttons)
  if(totalStripLines===1){
    var _singleHasIcon=window.s4LineOpts&&window.s4LineOpts[0]&&window.s4LineOpts[0].iconKey;
    if(!_singleHasIcon){
      // no icon yet — no buttons needed
    }
    // done/remove already inside the panel above for single line
  } else {
    // Multi: global Done at very bottom to close the whole strip
    var _anyIcon=_allStripLines.some(function(l,i){return window.s4LineOpts&&window.s4LineOpts[i]&&window.s4LineOpts[i].iconKey;});
    if(_anyIcon&&activeLine===0){
      lineInner+=doneRemoveBar('ntLineStripClose()','ntLineStripRemoveAll()');
    }
  }

  // ── Letter strip inner content ──
  var showLetterChangeGrid=!!window._ntLetterStripShowGrid;
  var letterInner='';
  if(selLetterIcon&&!showLetterChangeGrid){
    letterInner='<div onclick="ntLetterStripShowGrid()" style="display:flex;align-items:center;gap:8px;border:1.5px solid #e8d5c0;border-radius:10px;padding:8px 12px;background:#fff;cursor:pointer;margin-bottom:10px;">'
      +'<img src="'+selLetterIcon+'" style="width:28px;height:28px;object-fit:contain;">'
      +'<div style="flex:1;font-size:11px;font-weight:700;color:#3d2b1a;">Selected icon</div>'
      +'<div style="font-size:10px;font-weight:700;color:#c47a45;">Change \u2192</div>'
      +'</div>'
      +'<div style="font-size:9px;font-weight:700;color:#8c7b6e;letter-spacing:.06em;text-transform:uppercase;margin-bottom:6px;">Rotate</div>'
      +rotRowHTML('letter')
      +doneRemoveBar('ntLetterStripClose()','ntLetterStripRemove()');
  } else {
    letterInner='<div style="font-size:9px;font-weight:700;color:#8c7b6e;letter-spacing:.06em;text-transform:uppercase;margin-bottom:7px;">Choose an icon \u2014 tap line on canvas above to move it</div>'
      +'<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(58px,1fr));gap:5px;margin-bottom:0;">'+gridHTML(letterIcons,'letter')+'</div>'
      +(selLetterIcon
        ?'<div style="border-top:1px solid #fceedd;padding-top:10px;margin-top:10px;">'
          +'<div style="font-size:9px;font-weight:700;color:#8c7b6e;letter-spacing:.06em;text-transform:uppercase;margin-bottom:6px;">Rotate</div>'
          +rotRowHTML('letter')
          +doneRemoveBar('ntLetterStripClose()','ntLetterStripRemove()')
          +'</div>'
        :'');
  }

  wrap.innerHTML=
    (lineIcons.length?buildCard(lineOpen,lineIcons,selLineIcon,'Add an icon to your design','Tap to place beside a line','ntLineStripOpen()','ntLineStripClose()','ntLineStripRemove()',lineInner):'')
    +(letterIcons.length?buildCard(letterOpen,letterIcons,selLetterIcon,'Add crown on a letter','Floats on top of one letter','ntLetterStripOpen()','ntLetterStripClose()','ntLetterStripRemove()',letterInner):'');
  _restoreScroll();

  // Single delegated click handler on the entire strip wrap
  // This is bulletproof — no onclick strings, no per-element listeners
  if(wrap._clickHandler)wrap.removeEventListener('click',wrap._clickHandler,true);
  wrap._clickHandler=function(e){
    var el=e.target;
    // Walk up to find a data-line-n element
    while(el&&el!==wrap){
      var n=el.getAttribute&&el.getAttribute('data-line-n');
      if(n!==null&&n!==undefined){
        e.stopPropagation();
        e.preventDefault();
        window.ntStripSelectLine(parseInt(n));
        return;
      }
      el=el.parentElement;
    }
  };
  wrap.addEventListener('click',wrap._clickHandler,true);

  // Auto-close strip when clicking outside it (acts as Done)
  if(lineOpen||letterOpen){
    if(wrap._outsideHandler)document.removeEventListener('click',wrap._outsideHandler,true);
    wrap._outsideHandler=function(e){
      if(!wrap.contains(e.target)){
        if(lineOpen)window.ntLineStripClose();
        else if(letterOpen)window.ntLetterStripClose();
        document.removeEventListener('click',wrap._outsideHandler,true);
        wrap._outsideHandler=null;
      }
    };
    setTimeout(function(){
      document.addEventListener('click',wrap._outsideHandler,true);
    },200);
  } else {
    if(wrap._outsideHandler){
      document.removeEventListener('click',wrap._outsideHandler,true);
      wrap._outsideHandler=null;
    }
  }
  try{ntRenderIconColourPill();}catch(e){}
}

window.ntStripSelectLine=function(n){
  window._ntLineStripLine=n;
  window._ntLineStripShowGrid=false;
  if(n>0){
    var i=n-1;
    var _nlo=curLines.length;
    var opt;
    if(i<_nlo){opt=window.s4LineOpts&&window.s4LineOpts[i]?window.s4LineOpts[i]:{};}
    else{var ni=i-_nlo;opt=window.s4NameLineOpts&&window.s4NameLineOpts[ni]?window.s4NameLineOpts[ni]:{};}
    window._ntStripSelIcon=opt.iconKey||'';
    window._ntLineStripPos=opt.iconSide||'left';
    window._ntLineStripRot=opt.iconRotation||0;
  }
  ntRenderIconStrips();
};
window.ntLineRemoveFromLine=function(i){
  var _nlo=curLines.length;
  if(i<_nlo){
    if(window.s4LineOpts&&window.s4LineOpts[i]){delete window.s4LineOpts[i].iconKey;delete window.s4LineOpts[i].iconSide;delete window.s4LineOpts[i].iconRotation;}
  } else {
    var ni=i-_nlo;
    if(window.s4NameLineOpts&&window.s4NameLineOpts[ni]){delete window.s4NameLineOpts[ni].iconKey;delete window.s4NameLineOpts[ni].iconSide;delete window.s4NameLineOpts[ni].iconRotation;}
  }
  renderS4();try{renderS4SizeBar();}catch(e){}
  var anyIcon=(window.s4LineOpts||[]).some(function(o){return o&&o.iconKey;})
    ||(window.s4NameLineOpts||[]).some(function(o){return o&&o.iconKey;});
  if(!anyIcon)window._ntStripSelIcon='';
  window._ntLineStripLine=0;
  ntRenderIconStrips();
};
window.ntLineStripRemoveAll=function(){
  (window.s4LineOpts||[]).forEach(function(o){if(o){delete o.iconKey;delete o.iconSide;delete o.iconRotation;}});
  (window.s4NameLineOpts||[]).forEach(function(o){if(o){delete o.iconKey;delete o.iconSide;delete o.iconRotation;}});
  renderS4();try{renderS4SizeBar();}catch(e){}
  window._ntStripSelIcon='';window._ntLineStripOpen=false;window._ntLineStripStep=0;
  window._ntLineStripLine=0;window._ntLineStripShowGrid=false;
  ntRenderIconStrips();
};
window.ntLineStripOpen=function(){
  if(window._ntLineStripOpen)return;
  window._ntLineStripOpen=true;window._ntLetterStripOpen=false;
  var _totalSlots=curLines.length+(window.s4NameLines||[]).length;
  if(_totalSlots===1){
    window._ntLineStripLine=1; // single line — auto-select
  } else {
    window._ntLineStripLine=0; // multiple lines — show all, user chooses
  }
  ntRenderIconStrips();
};
window.ntLineStripClose=function(){
  window._ntLineStripOpen=false;window._ntLineStripShowGrid=false;ntRenderIconStrips();
  setTimeout(function(){
    var s=document.getElementById('ntIconStripsWrap');
    if(s){var sc=window._ntScroller;if(sc&&sc!==window)sc.scrollTop=Math.max(0,s.offsetTop-20);else s.scrollIntoView({behavior:'smooth',block:'nearest'});}
  },150);
};
window.ntLetterStripOpen=function(){
  if(window._ntLetterStripOpen)return;
  window._ntLetterStripOpen=true;window._ntLineStripOpen=false;
  ntRenderIconStrips();
};
window.ntLetterStripClose=function(){
  window._ntLetterStripOpen=false;window._ntLetterStripShowGrid=false;ntRenderIconStrips();
  setTimeout(function(){
    var s=document.getElementById('ntIconStripsWrap');
    if(s){var sc=window._ntScroller;if(sc&&sc!==window)sc.scrollTop=Math.max(0,s.offsetTop-20);else s.scrollIntoView({behavior:'smooth',block:'nearest'});}
  },150);
};
window.ntStripShowGrid=function(){window._ntLineStripShowGrid=true;ntRenderIconStrips();};
window.ntLetterStripShowGrid=function(){window._ntLetterStripShowGrid=true;ntRenderIconStrips();};
window.ntStripSetLine=function(n){window._ntLineStripLine=n;window._ntLineStripStep=1;window._ntStripSelIcon='';window._ntLineStripShowGrid=false;ntRenderIconStrips();};
// Icon colour helpers
window.ntStripPickIconColour=function(lineIdx,hex,colourName){
  // lineIdx is 0-based
  var _nloP=curLines.length;
  var opts, isName=lineIdx>=_nloP;
  if(!isName){
    if(!window.s4LineOpts[lineIdx])window.s4LineOpts[lineIdx]={};
    opts=window.s4LineOpts[lineIdx];
  } else {
    var ni=lineIdx-_nloP;
    if(!window.s4NameLineOpts)window.s4NameLineOpts=[];
    while(window.s4NameLineOpts.length<=ni)window.s4NameLineOpts.push({});
    opts=window.s4NameLineOpts[ni];
  }
  // If picked colour matches text colour, treat as "default" (free)
  var _tc=(window.ntGetColors?ntGetColors()[window.selC4||0]:null);
  var _tcHex=_tc?_tc.fc:'';
  opts.iconColour=(hex&&hex!==_tcHex)?hex:'';
  opts.iconColourName=(hex&&hex!==_tcHex)?colourName:'';
  renderS4();
  try{renderS4SizeBar();}catch(e){}
  ntRenderIconStrips();
  try{ntRenderIconColourPill();}catch(e){}
};
// ── Per-icon colour pills below the global colour row ──
// One pill per placed icon: thumbnail + colour dot/name. Tap → popup (mounted on
// body to avoid slider transform/z-index issues) with colour swatches + tap-to-change-icon.
// All writes go through ntStripPickIconColour / ntStripSwapIcon → section + canvas stay in sync.
function ntCollectIconLines(){
  // returns [{lineIdx, opt, src}] for every line/name-line that has an icon
  var out=[];var _nloP=curLines.length;
  (window.s4LineOpts||[]).forEach(function(o,i){if(o&&o.iconKey)out.push({lineIdx:i,opt:o,src:o.iconKey});});
  (window.s4NameLineOpts||[]).forEach(function(o,j){if(o&&o.iconKey)out.push({lineIdx:_nloP+j,opt:o,src:o.iconKey});});
  return out;
}
function ntRenderIconColourPill(){
  var host=document.getElementById('ntIconColourPill');if(!host)return;
  var lines=curLines||[];
  var nameLines=(window.s4NameLines||[]);
  var textColour=(ntGetColors()[window.selC4||0]||{}).fc||'';
  host.style.display='block';

  var icons=window.NT_CUSTOM_ICONS||[];
  var preview=icons.slice(0,6).map(function(ic){
    return '<img src="'+ic.src+'" title="'+(ic.label||'')+'" style="width:22px;height:22px;object-fit:contain;opacity:0.8;flex-shrink:0;padding:1px;">';
  }).join('');
  if(icons.length>6)preview+='<span style="font-size:9px;color:#a07850;align-self:center;">+'+(icons.length-6)+'</span>';

  // Top icon pill
  var ti=window.s4TopIcon||{};
  var topPill='';
  if(lines.filter(function(l){return l&&l.trim();}).length>0){
    if(ti.iconKey){
      var tic=ti.iconColour||'';var thasC=!!tic&&tic!==textColour;var tdot=thasC?tic:textColour;
      var trot=ti.iconRotation||0;var tflip=ti.iconFlip?'scaleX(-1)':'';
      var textra=thasC?'<div style="display:flex;align-items:center;gap:3px;margin-top:2px;"><span style="font-size:8px;font-weight:800;color:#c47a45;">+₹500</span><span onclick="event.stopPropagation();ntTopIconResetColour()" style="font-size:8px;font-weight:700;color:#888;cursor:pointer;text-decoration:underline;">remove</span></div>':'';
      topPill='<div style="position:relative;display:inline-flex;flex-direction:column;background:#e8f0ff;border:1.5px solid #a0b8e8;border-radius:12px;padding:6px 11px;cursor:pointer;margin:0 6px 6px 0;" onclick="ntTopIconPillOpen()">'
        +'<span onclick="event.stopPropagation();ntTopIconRemove()" style="position:absolute;top:-6px;left:-6px;width:16px;height:16px;border-radius:50%;background:#c0392b;color:#fff;font-size:9px;font-weight:700;display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:1;line-height:1;">✕</span>'
        +'<div style="display:flex;align-items:center;gap:5px;">'
          +'<img src="'+ti.iconKey+'" style="width:18px;height:18px;object-fit:contain;flex-shrink:0;filter:'+ntIconFilter(tdot||'#3d2b1a')+';transform:rotate('+trot+'deg) '+tflip+';">'
          +'<span style="font-size:10px;font-weight:700;color:#2a4a8a;">Top icon</span>'

        +'</div>'+textra+'</div>';
    } else {
      topPill='<div onclick="ntTopIconPillOpen()" style="display:inline-flex;align-items:center;gap:5px;background:#e8f0ff;border:1.5px dashed #a0b8e8;border-radius:12px;padding:6px 11px;cursor:pointer;margin:0 6px 6px 0;">'
        +'<span style="font-size:13px;color:#2a4a8a;font-weight:700;line-height:1;">+</span>'
        +'<span style="font-size:10px;font-weight:700;color:#2a4a8a;">Top icon</span>'
        +'</div>';
    }
  }

  function makeChip(opt, globalIdx, popupIdx, lineText){
    if(!lineText||!lineText.trim())return '';
    var src=opt.iconKey||'';
    if(src){
      var ic=opt.iconColour||'';
      var hasCustom=!!ic&&ic!==textColour;
      var dotCol=hasCustom?ic:textColour;
      var rot=opt.iconRotation||0;
      var flip=opt.iconFlip?'scaleX(-1)':'';
      var extraRow=hasCustom
        ?'<div style="display:flex;align-items:center;gap:3px;margin-top:2px;"><span style="font-size:8px;font-weight:800;color:#c47a45;">+₹500</span><span onclick="event.stopPropagation();ntPillResetColour('+popupIdx+')" style="font-size:8px;font-weight:700;color:#888;cursor:pointer;text-decoration:underline;">remove</span></div>'
        :'';
      return '<div style="position:relative;display:inline-flex;flex-direction:column;background:#fff3e6;border:1.5px solid #e8c09a;border-radius:12px;padding:6px 11px;cursor:pointer;margin:0 6px 6px 0;" onclick="ntIconPillOpen('+popupIdx+')">'
        +'<span onclick="event.stopPropagation();ntPopupRemoveIcon('+popupIdx+')" style="position:absolute;top:-6px;left:-6px;width:16px;height:16px;border-radius:50%;background:#c0392b;color:#fff;font-size:9px;font-weight:700;display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:1;line-height:1;">✕</span>'
        +'<div style="display:flex;align-items:center;gap:5px;">'
          +'<img src="'+src+'" style="width:18px;height:18px;object-fit:contain;flex-shrink:0;filter:'+ntIconFilter(dotCol||'#3d2b1a')+';transform:rotate('+rot+'deg) '+flip+';">'
          +'<span style="font-size:10px;font-weight:700;color:#a85e22;">Line '+(globalIdx+1)+'</span>'
        +'</div>'+extraRow+'</div>';
    } else {
      return '<div onclick="ntIconPillOpen('+popupIdx+')" style="display:inline-flex;align-items:center;gap:5px;background:#fff3e6;border:1.5px dashed #e8c09a;border-radius:12px;padding:6px 11px;cursor:pointer;margin:0 6px 6px 0;">'
        +'<span style="font-size:13px;color:#a85e22;font-weight:700;line-height:1;">+</span>'
        +'<span style="font-size:10px;font-weight:700;color:#a85e22;">Line '+(globalIdx+1)+'</span>'
        +'</div>';
    }
  }

  var chips='';
  lines.forEach(function(lt,i){
    var opt=(window.s4LineOpts&&window.s4LineOpts[i])||{};
    chips+=makeChip(opt,i,i,lt);
  });
  nameLines.forEach(function(lt,i){
    var ni=lines.length+i;
    var opt=(window.s4NameLineOpts&&window.s4NameLineOpts[i])||{};
    chips+=makeChip(opt,ni,ni,lt);
  });

  if(!chips&&!topPill){host.style.display='none';host.innerHTML='';return;}

  // Icon on letter pill — compact, no colour option
  var il=window.ntLetterIcon||{};
  var ilPill='';
  if(lines.filter(function(l){return l&&l.trim();}).length>0){
    if(il.active&&il.iconSrc){
      ilPill='<div style="position:relative;display:inline-flex;align-items:center;gap:5px;background:#e8f5ec;border:1.5px solid #90c8a0;border-radius:12px;padding:5px 10px;cursor:pointer;margin:0 5px 5px 0;" onclick="ntOpenIconLetter()">'
        +'<span onclick="event.stopPropagation();ntRemoveLetterIcon()" style="position:absolute;top:-6px;left:-6px;width:16px;height:16px;border-radius:50%;background:#c0392b;color:#fff;font-size:9px;font-weight:700;display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:1;line-height:1;">✕</span>'
        +'<img src="'+il.iconSrc+'" style="width:16px;height:16px;object-fit:contain;flex-shrink:0;">'
        +'<span style="font-size:10px;font-weight:700;color:#2a6a3a;">On letter</span>'
        +'</div>';
    } else {
      ilPill='<div onclick="ntOpenIconLetter()" style="display:inline-flex;align-items:center;gap:5px;background:#fdf5ec;border:1.5px dashed #d8c3aa;border-radius:12px;padding:5px 10px;cursor:pointer;margin:0 5px 5px 0;">'
        +'<span style="font-size:11px;color:#a07850;font-weight:700;line-height:1;">✦</span>'
        +'<span style="font-size:10px;font-weight:600;color:#a07850;">Icon on letter</span>'
        +'</div>';
    }
  }

  host.innerHTML=
    '<div style="background:#f5ede4;border:1.5px solid #e8d0b8;border-radius:12px;padding:10px 13px;margin-bottom:10px;">'
      +'<div style="display:flex;align-items:center;background:#fef8f3;border-radius:9px;padding:5px 9px;margin-bottom:8px;gap:7px;">'
        +'<span style="font-size:10px;font-weight:800;color:#c47a45;letter-spacing:.05em;text-transform:uppercase;white-space:nowrap;">Choose an icon</span>'
        +'<div style="display:flex;align-items:center;gap:3px;flex:1;justify-content:flex-end;">'+preview+'</div>'
      +'</div>'
      +'<div style="display:flex;flex-wrap:wrap;">'+topPill+chips+ilPill+'</div>'
    +'</div>';
}

// Reusable line-cap toast
window.ntShowLineCap=function(msg){
  var id='ntLineCapToast';
  var old=document.getElementById(id);if(old&&old.parentNode)old.parentNode.removeChild(old);
  var t=document.createElement('div');t.id=id;
  var sl=document.getElementById('ntSl');var slR=sl?sl.getBoundingClientRect():null;
  t.style.cssText='position:fixed;bottom:80px;left:'+(slR?Math.round(slR.left+slR.width/2)+'px':'50%')+';transform:translateX(-50%);background:#3d2b1a;color:#fdf6f0;font-size:11px;font-weight:700;padding:8px 16px;border-radius:20px;z-index:2147483647;font-family:DM Sans,sans-serif;white-space:nowrap;box-shadow:0 4px 16px rgba(0,0,0,0.3);';
  t.textContent=msg||'Max 4 lines allowed';
  document.body.appendChild(t);
  setTimeout(function(){if(t.parentNode)t.parentNode.removeChild(t);},3000);
};
window.ntRenderIconColourPill=ntRenderIconColourPill;

// ── TOP ICON (decorative icon above the design = +1 line in pricing) ──
window.s4TopIcon=window.s4TopIcon||{};

window.ntTopIconPillOpen=function(){
  if(!(window.s4TopIcon&&window.s4TopIcon.iconKey)){
    var _nl=(window.s4NameLines||[]).filter(Boolean).length;
    var _total=curLines.filter(Boolean).length+_nl;
    if(_total>=4){if(typeof window.ntShowLineCap==='function')window.ntShowLineCap('Max 4 lines — remove a line to add top icon');return;}
  }
  window._ntIconPopupShowIcons=!(window.s4TopIcon&&window.s4TopIcon.iconKey);
  ntRenderTopIconPopup();
};
window.ntTopIconResetColour=function(){
  if(!window.s4TopIcon)window.s4TopIcon={};
  window.s4TopIcon.iconColour='';window.s4TopIcon.iconColourName='';
  renderS4();try{renderS4SizeBar();}catch(e){}ntRenderIconColourPill();
};
window.ntTopIconRemove=function(){
  window.s4TopIcon={};
  renderS4();try{renderS4SizeBar();}catch(e){}try{renderS4LineChips();}catch(e){}ntRenderIconColourPill();
  var p=document.getElementById('ntTopIconPopup');if(p&&p.parentNode)p.parentNode.removeChild(p);var d=document.getElementById('ntPopupDim');if(d)d.style.display='none';
};
function ntRenderTopIconPopup(){
  ['ntTopIconPopup','ntTopIconPopupBd','ntTopIconPopupBd2'].forEach(function(id){var e=document.getElementById(id);if(e&&e.parentNode)e.parentNode.removeChild(e);});
  if(!document.getElementById('ntIconGridStyle')){var _gs=document.createElement('style');_gs.id='ntIconGridStyle';_gs.textContent='@media(min-width:600px){.nt-icgrid img{width:46%!important;height:46%!important;}}';document.head.appendChild(_gs);}
  var ti=window.s4TopIcon||{};var src=ti.iconKey||'';var hasIcon=!!src;
  var textColour=(ntGetColors()[window.selC4||0]||{}).fc||'';
  var curIcCol=ti.iconColour||'';var activeColour=curIcCol||textColour;
  var showIcons=window._ntIconPopupShowIcons||!hasIcon;
  var iconsArr=window.NT_CUSTOM_ICONS||[];
  var iconGrid='';
  if(showIcons){iconGrid='<div style="display:grid;grid-template-columns:repeat(8,1fr);gap:4px;margin:4px 0 10px;" class="nt-icgrid">'+iconsArr.map(function(ic){var on=ic.src===src;return '<div onclick="ntTopIconSwap(\''+ic.src+'\',\''+(ic.label||'').replace(/'/g,'')+'\')" style="aspect-ratio:1;border-radius:9px;border:1.5px solid '+(on?'#c47a45':'#e8d5c0')+';background:'+(on?'#fff8f3':'#fdfaf5')+';display:flex;align-items:center;justify-content:center;cursor:pointer;"><img src="'+ic.src+'" style="width:65%;height:65%;object-fit:contain;" loading="lazy"></div>';}).join('')+'</div>';}
  var body='';
  if(hasIcon){
    var colours=ntGetColors()||[];if(!colours||colours.length<3){colours=[{n:'Dark',fc:'#3d2b1a'},{n:'Sky Blue',fc:'#5bb8e8'},{n:'Red',fc:'#e84040'},{n:'Orange',fc:'#e87c28'},{n:'Lime',fc:'#8cc820'},{n:'Yellow',fc:'#f0c820'},{n:'Purple',fc:'#9860d8'},{n:'White',fc:'#f2ece3',lt:1},{n:'Pink',fc:'#e880a8'}];}
    var sw='';colours.forEach(function(col){var fc=(col.fc||'').trim();if(!fc)return;var isOn=fc===activeColour;sw+='<div data-fc="'+fc+'" data-nm="'+(col.n||'')+'" onclick="ntTopIconSwColour(this)" style="width:26px;height:26px;border-radius:50%;border:2px solid '+(isOn?'#3d2b1a':'rgba(0,0,0,0.1)')+';background:'+fc+';cursor:pointer;box-sizing:border-box;transform:'+(isOn?'scale(1.2)':'scale(1)')+';transition:transform .15s;'+(col.lt?'box-shadow:inset 0 0 0 1px rgba(0,0,0,0.15);':'')+'">'+( isOn?'<span style="color:'+(col.lt?'#3d2b1a':'#fff')+';font-size:9px;font-weight:700;line-height:24px;display:block;text-align:center;">\u2713</span>':'\u200b')+'</div>';});
    var isCustom=!!curIcCol&&curIcCol!==textColour;
    var priceMsg=isCustom?'<span style="color:#c47a45;font-weight:800;background:#fff3e6;border:1px solid #e8c09a;border-radius:6px;padding:1px 6px;">+\u20b9500</span> for a different colour':'Same as text colour \xb7 no extra charge';
    body='<div style="font-size:9px;font-weight:700;color:#8c7b6e;letter-spacing:.06em;text-transform:uppercase;margin:2px 0 8px;">Icon colour</div>'
      +'<div style="display:flex;gap:7px;flex-wrap:wrap;">'+sw+'</div>'
      +'<div style="font-size:10px;color:#8c7b6e;margin-top:8px;">'+priceMsg+'</div>'
      +'<div style="font-size:9px;font-weight:700;color:#8c7b6e;letter-spacing:.06em;text-transform:uppercase;margin:14px 0 8px;">Rotate & Reflect</div>'
      +'<div style="display:flex;gap:7px;align-items:center;">'
        +'<div onclick="ntTopIconRotate(-1)" style="flex:1;padding:9px 4px;border:1.5px solid #e8d5c0;border-radius:9px;background:#fff;text-align:center;font-size:16px;cursor:pointer;">\u21ba</div>'
        +'<div style="text-align:center;min-width:36px;font-weight:700;font-size:13px;color:#3d2b1a;">'+((ti.iconRotation||0)+'\xb0')+'</div>'
        +'<div onclick="ntTopIconRotate(1)" style="flex:1;padding:9px 4px;border:1.5px solid #e8d5c0;border-radius:9px;background:#fff;text-align:center;font-size:16px;cursor:pointer;">\u21bb</div>'
        +'<div onclick="ntTopIconReflect()" style="flex:1;padding:9px 4px;border:1.5px solid '+(ti.iconFlip?'#c47a45':'#e8d5c0')+';border-radius:9px;background:'+(ti.iconFlip?'#fff8f3':'#fff')+';text-align:center;font-size:13px;font-weight:700;color:'+(ti.iconFlip?'#c47a45':'#8c7b6e')+';cursor:pointer;">\u21d4 Flip</div>'
      +'</div>'
      +'<div style="display:flex;align-items:center;justify-content:space-between;margin-top:16px;">'
        +'<span onclick="ntTopIconRemove()" style="font-size:11px;color:#c0392b;cursor:pointer;text-decoration:underline;">\u2715 Remove top icon</span>'
        +'<button onclick="var p=document.getElementById(\'ntTopIconPopup\');if(p&&p.parentNode)p.parentNode.removeChild(p);var d=document.getElementById(\'ntPopupDim\');if(d)d.style.display=\'none\';" style="background:#c47a45;color:#fff;border:none;border-radius:22px;padding:11px 26px;font-weight:700;font-size:13px;cursor:pointer;">Done \u2713</button>'
      +'</div>';
  } else {
    body='<div style="font-size:11px;color:#8c7b6e;text-align:center;padding:6px 0 4px;">Pick an icon to show above your design (+1 line)</div>';
  }
  var headThumb=hasIcon?'<img src="'+src+'" style="width:30px;height:30px;object-fit:contain;filter:'+ntIconFilter(activeColour||'#3d2b1a')+';" alt="">':'<span style="font-size:20px;color:#bba98f;">\u2606</span>';
  var headerSub=hasIcon?'<div onclick="window._ntIconPopupShowIcons=!window._ntIconPopupShowIcons;ntRenderTopIconPopup();" style="font-size:11px;font-weight:700;color:#c47a45;background:#fff3e6;border-radius:8px;padding:2px 8px;margin-top:4px;display:inline-block;cursor:pointer;">'+(showIcons?'\u25b2 close icons':'\u21bb tap to change icon')+'</div>':'<div style="font-size:11px;color:#8c7b6e;margin-top:2px;">choosing\u2026</div>';
  var pop=document.createElement('div');pop.id='ntTopIconPopup';
  var _bg=document.getElementById('s4Bg');
  var _slEl=document.getElementById('ntSl');
  var _bgR=_bg?_bg.getBoundingClientRect():{bottom:260};
  var _slR=_slEl?_slEl.getBoundingClientRect():{left:0,right:window.innerWidth,width:window.innerWidth,bottom:window.innerHeight};
  var _popTop=Math.max(40,Math.min(Math.round(_bgR.bottom)+2,window.innerHeight-200));
  var _popMaxH=Math.max(160,Math.round(Math.min(_slR.bottom,window.innerHeight))-_popTop);
  pop.style.cssText='position:fixed;left:'+Math.round(_slR.left)+'px;width:'+Math.round(_slR.width)+'px;top:'+_popTop+'px;max-height:'+_popMaxH+'px;overflow-y:auto;z-index:2147483600;background:#fff;border-top:2px solid #e8d5c0;box-shadow:0 8px 32px rgba(0,0,0,0.2);';
  var _mountEl=document.body;
  pop.onclick=function(e){if(e.target===pop){pop.parentNode&&pop.parentNode.removeChild(pop);var d=document.getElementById('ntPopupDim');if(d)d.style.display='none';}};
  pop.innerHTML='<div style="padding:14px 16px 18px;font-family:\'DM Sans\',sans-serif;">'
    +'<div style="display:flex;align-items:center;gap:11px;margin-bottom:14px;">'
      +'<div style="width:44px;height:44px;border-radius:11px;border:1.5px solid #e8d5c0;background:#fff;display:flex;align-items:center;justify-content:center;flex-shrink:0;">'+headThumb+'</div>'
      +'<div style="flex:1;"><div style="font-family:\'Poppins\',sans-serif;font-weight:700;font-size:14px;color:#3d2b1a;">Top icon</div>'+headerSub+'</div>'
      +'<div onclick="var p=document.getElementById(\'ntTopIconPopup\');if(p&&p.parentNode)p.parentNode.removeChild(p);var d=document.getElementById(\'ntPopupDim\');if(d)d.style.display=\'none\';" style="width:30px;height:30px;border-radius:50%;background:#f3ece3;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:16px;color:#3d2b1a;flex-shrink:0;">\u2715</div>'
    +'</div>'
    +iconGrid+body
  +'</div>';
  // Dim editor body while popup open
  var _dimEl=document.getElementById('ntPopupDim');
  var _bgForDim=document.getElementById('s4Bg');
  var _bgBot=_bgForDim?Math.round(_bgForDim.getBoundingClientRect().bottom)+2:200;
  var _slForDim=document.getElementById('ntSl');
  var _slR2=_slForDim?_slForDim.getBoundingClientRect():{left:0,width:window.innerWidth};
  if(!_dimEl){
    _dimEl=document.createElement('div');
    _dimEl.id='ntPopupDim';
    document.body.appendChild(_dimEl);
  }
  _dimEl.style.cssText='position:fixed;left:'+Math.round(_slR2.left)+'px;width:'+Math.round(_slR2.width)+'px;top:'+_bgBot+'px;bottom:0;background:rgba(0,0,0,0.35);z-index:2147483599;pointer-events:none;';
  _dimEl.style.display='block';
  _mountEl.appendChild(pop);
}
window.ntRenderTopIconPopup=ntRenderTopIconPopup;
window.ntTopIconSwap=function(src,label){if(!window.s4TopIcon)window.s4TopIcon={};window.s4TopIcon.iconKey=src;window.s4TopIcon.iconLabel=label||'';if(!window.s4TopIcon.iconSide)window.s4TopIcon.iconSide='center';window._ntIconPopupShowIcons=false;renderS4();try{renderS4SizeBar();}catch(e){}try{renderS4LineChips();}catch(e){}ntRenderTopIconPopup();ntRenderIconColourPill();};
window.ntTopIconSwColour=function(el){var fc=el.getAttribute('data-fc');var nm=el.getAttribute('data-nm')||'';var tc=(ntGetColors()[window.selC4||0]||{}).fc||'';if(!window.s4TopIcon)window.s4TopIcon={};window.s4TopIcon.iconColour=(fc===tc)?'':fc;window.s4TopIcon.iconColourName=(fc===tc)?'':nm;ntRenderTopIconPopup();ntRenderIconColourPill();setTimeout(function(){renderS4();try{renderS4SizeBar();}catch(e){}},0);};
window.ntTopIconSetSide=function(side){side='center';
  if(!window.s4TopIcon)window.s4TopIcon={};
  window.s4TopIcon.iconSide=side;
  // Update button styles in-place without rebuilding popup
  var pop=document.getElementById('ntTopIconPopup');
  if(pop){
    pop.querySelectorAll('[data-side]').forEach(function(el){
      var on=el.getAttribute('data-side')===side;
      el.style.background=on?'#c47a45':'#fff';
      el.style.color=on?'#fff':'#3d2b1a';
      el.style.borderColor=on?'#c47a45':'#e8d5c0';
    });
  }
  renderS4();try{renderS4SizeBar();}catch(e){}ntRenderIconColourPill();
};
window.ntTopIconRotate=function(dir){if(!window.s4TopIcon)window.s4TopIcon={};var cur=window.s4TopIcon.iconRotation||0;window.s4TopIcon.iconRotation=((cur+(dir*5))+360)%360;ntRenderTopIconPopup();ntRenderIconColourPill();setTimeout(function(){renderS4();try{renderS4SizeBar();}catch(e){}},0);};
window.ntTopIconReflect=function(){if(!window.s4TopIcon)window.s4TopIcon={};window.s4TopIcon.iconFlip=!window.s4TopIcon.iconFlip;ntRenderTopIconPopup();ntRenderIconColourPill();setTimeout(function(){renderS4();try{renderS4SizeBar();}catch(e){}},0);};

// Reset icon colour to global (removes +₹500)
window.ntPillResetColour=function(lineIdx){
  var _nloP=curLines.length;
  var opt;
  if(lineIdx<_nloP){
    if(!window.s4LineOpts[lineIdx])window.s4LineOpts[lineIdx]={};
    opt=window.s4LineOpts[lineIdx];
  } else {
    var _ni=lineIdx-_nloP;
    if(!window.s4NameLineOpts)window.s4NameLineOpts=[];
    while(window.s4NameLineOpts.length<=_ni)window.s4NameLineOpts.push({});
    opt=window.s4NameLineOpts[_ni];
  }
  opt.iconColour='';opt.iconColourName='';
  renderS4();try{renderS4SizeBar();}catch(e){}
  ntRenderIconColourPill();
  if(window._ntIconPopupLine===lineIdx)ntRenderIconPopup();
};
window.ntPopupSwClick=function(el){
  var li=parseInt(el.getAttribute('data-li')||'0');
  var fc=el.getAttribute('data-fc')||'';
  var nm=el.getAttribute('data-nm')||'';
  ntStripPickIconColour(li,fc,nm);
  ntRenderIconPopup();
};
// Swatch click delegation — handles data-attr based swatches in popup
window.ntSwClick=function(container,e){
  var d=e.target.closest('[data-fc]');if(!d)return;
  var li=window._ntSwLi;var tc=window._ntSwTc||'';
  var fc=d.getAttribute('data-fc');
  var nm=d.getAttribute('data-nm')||'';
  var free=d.getAttribute('data-free')==='1';
  var on=d.getAttribute('data-on')==='1';
  if(on&&!free){ntStripPickIconColour(li,tc,'');}
  else{ntStripPickIconColour(li,fc,nm);}
  ntRenderIconPopup();
};

// Popup state
window._ntIconPopupLine=null;window._ntIconPopupShowIcons=false;
window.ntIconPillOpen=function(lineIdx){
  window._ntIconPopupLine=lineIdx;
  var _nloP=curLines.length;
  var opt;
  if(lineIdx<_nloP){
    opt=(window.s4LineOpts&&window.s4LineOpts[lineIdx])||{};
  } else {
    var ni=lineIdx-_nloP;
    opt=(window.s4NameLineOpts&&window.s4NameLineOpts[ni])||{};
  }
  window._ntIconPopupShowIcons=!opt.iconKey;
  ntRenderIconPopup();
};
window.ntIconPopupClose=function(){window._ntIconPopupLine=null;var p=document.getElementById('ntIconPopup');if(p){if(p._bd&&p._bd.parentNode)p._bd.parentNode.removeChild(p._bd);p.parentNode&&p.parentNode.removeChild(p);}var _bd2=document.getElementById('ntIconPopupBd');if(_bd2&&_bd2.parentNode)_bd2.parentNode.removeChild(_bd2);var d=document.getElementById('ntPopupDim');if(d)d.style.display='none';};
window.ntIconPopupToggleIcons=function(){window._ntIconPopupShowIcons=!window._ntIconPopupShowIcons;ntRenderIconPopup();};
window.ntStripSwapIcon=function(lineIdx,src,label){
  var _nloP=curLines.length;
  if(lineIdx<_nloP){
    if(!window.s4LineOpts[lineIdx])window.s4LineOpts[lineIdx]={};
    var wasEmpty=!window.s4LineOpts[lineIdx].iconKey;
    window.s4LineOpts[lineIdx].iconKey=src;window.s4LineOpts[lineIdx].iconLabel=label||'';
    if(wasEmpty&&!window.s4LineOpts[lineIdx].iconSide)window.s4LineOpts[lineIdx].iconSide='left';
  } else {
    var _ni=lineIdx-_nloP;
    if(!window.s4NameLineOpts)window.s4NameLineOpts=[];
    while(window.s4NameLineOpts.length<=_ni)window.s4NameLineOpts.push({});
    var wasEmpty2=!window.s4NameLineOpts[_ni].iconKey;
    window.s4NameLineOpts[_ni].iconKey=src;window.s4NameLineOpts[_ni].iconLabel=label||'';
    if(wasEmpty2&&!window.s4NameLineOpts[_ni].iconSide)window.s4NameLineOpts[_ni].iconSide='left';
  }
  window._ntStripSelIcon=src;window._ntIconPopupShowIcons=false;
  renderS4();try{renderS4SizeBar();}catch(e){}
  try{ntRenderIconStrips();}catch(e){}
  ntRenderIconPopup();ntRenderIconColourPill();
};
window.ntPopupSetSide=function(lineIdx,side){
  var _nloP2=curLines.length;
  var _o;
  if(lineIdx<_nloP2){
    if(!window.s4LineOpts[lineIdx])window.s4LineOpts[lineIdx]={};
    _o=window.s4LineOpts[lineIdx];
  } else {
    var _ni2=lineIdx-_nloP2;
    if(!window.s4NameLineOpts)window.s4NameLineOpts=[];
    while(window.s4NameLineOpts.length<=_ni2)window.s4NameLineOpts.push({});
    _o=window.s4NameLineOpts[_ni2];
  }
  _o.iconSide=side;
  renderS4();try{renderS4SizeBar();}catch(e){}
  try{ntRenderIconStrips();}catch(e){}
  ntRenderIconPopup();ntRenderIconColourPill();
};
window.ntPopupRotate=function(lineIdx,dir){
  var _nloP2=curLines.length;
  var _o;
  if(lineIdx<_nloP2){
    if(!window.s4LineOpts[lineIdx])window.s4LineOpts[lineIdx]={};
    _o=window.s4LineOpts[lineIdx];
  } else {
    var _ni2=lineIdx-_nloP2;
    if(!window.s4NameLineOpts)window.s4NameLineOpts=[];
    while(window.s4NameLineOpts.length<=_ni2)window.s4NameLineOpts.push({});
    _o=window.s4NameLineOpts[_ni2];
  }
  var cur=_o.iconRotation||0;
  _o.iconRotation=((cur+(dir*5))+360)%360;
  renderS4();try{ntRenderIconStrips();}catch(e){}
  ntRenderIconPopup();ntRenderIconColourPill();
};
window.ntPopupReflect=function(lineIdx){
  var _nloP2=curLines.length;
  var _o;
  if(lineIdx<_nloP2){
    if(!window.s4LineOpts[lineIdx])window.s4LineOpts[lineIdx]={};
    _o=window.s4LineOpts[lineIdx];
  } else {
    var _ni2=lineIdx-_nloP2;
    if(!window.s4NameLineOpts)window.s4NameLineOpts=[];
    while(window.s4NameLineOpts.length<=_ni2)window.s4NameLineOpts.push({});
    _o=window.s4NameLineOpts[_ni2];
  }
  _o.iconFlip=!_o.iconFlip;
  renderS4();try{ntRenderIconStrips();}catch(e){}
  ntRenderIconPopup();ntRenderIconColourPill();
};
window.ntPopupRemoveIcon=function(lineIdx){
  var _nloP3=curLines.length;
  var _ro=lineIdx<_nloP3?(window.s4LineOpts&&window.s4LineOpts[lineIdx]):((window.s4NameLineOpts)&&window.s4NameLineOpts[lineIdx-_nloP3]);
  if(_ro){delete _ro.iconKey;delete _ro.iconSide;delete _ro.iconRotation;delete _ro.iconFlip;delete _ro.iconColour;delete _ro.iconColourName;}
  if(window._ntStripSelIcon)window._ntStripSelIcon='';
  renderS4();try{renderS4SizeBar();}catch(e){}
  try{ntRenderIconStrips();}catch(e){}
  window.ntIconPopupClose();ntRenderIconColourPill();
};
function ntRenderIconPopup(){
  ['ntIconPopup','ntIconPopupBd'].forEach(function(id){var e=document.getElementById(id);if(e&&e.parentNode)e.parentNode.removeChild(e);});
  if(!document.getElementById('ntIconGridStyle')){var _gs=document.createElement('style');_gs.id='ntIconGridStyle';_gs.textContent='@media(min-width:600px){.nt-icgrid img{width:46%!important;height:46%!important;}}';document.head.appendChild(_gs);}
  var lineIdx=window._ntIconPopupLine;if(lineIdx==null)return;
  var _nloP=curLines.length;
  var opt;
  if(lineIdx<_nloP){
    opt=(window.s4LineOpts&&window.s4LineOpts[lineIdx])||{};
  } else {
    var _ni=lineIdx-_nloP;
    if(!window.s4NameLineOpts)window.s4NameLineOpts=[];
    opt=window.s4NameLineOpts[_ni]||{};
  }
  var src=opt.iconKey||'';
  var hasIcon=!!src;
  var lineText=(curLines&&curLines[lineIdx])||'';
  var textColour=(ntGetColors()[window.selC4||0]||{}).fc||'';
  var curIcCol=opt.iconColour||'';
  var activeColour=curIcCol||textColour;

  // ICON GRID (shown when choosing/changing, or when line has no icon)
  var iconsArr=window.NT_CUSTOM_ICONS||[];
  var showIcons=window._ntIconPopupShowIcons||!hasIcon;
  var iconGrid='';
  if(showIcons){
    iconGrid='<div style="display:grid;grid-template-columns:repeat(8,1fr);gap:4px;margin:4px 0 10px;" class="nt-icgrid">'
      +iconsArr.map(function(ic){
        var on=ic.src===src;
        return '<div onclick="ntStripSwapIcon('+lineIdx+",'"+ic.src+"','"+(ic.label||'').replace(/'/g,"")+"')\" style=\"aspect-ratio:1;border-radius:9px;border:1.5px solid "+(on?'#c47a45':'#e8d5c0')+";background:"+(on?'#fff8f3':'#fdfaf5')+";display:flex;align-items:center;justify-content:center;cursor:pointer;\"><img src=\""+ic.src+"\" style=\"width:24px;height:24px;object-fit:contain;\" alt=\"\" loading=\"lazy\"></div>";
      }).join('')
      +'</div>';
  }

  var body='';
  if(hasIcon){
    // COLOUR row — always show swatches. Merge theme colours with fallback.
    var _themeColours=ntGetColors()||[];
    var _fallback=[
      {n:'Dark Espresso',fc:'#3d2b1a'},{n:'Sky Blue',fc:'#5bb8e8'},
      {n:'Red',fc:'#e84040'},{n:'Orange',fc:'#e87c28'},
      {n:'Lime',fc:'#8cc820'},{n:'Yellow',fc:'#f0c820'},
      {n:'Purple',fc:'#9860d8'},{n:'White',fc:'#f2ece3',lt:1},
      {n:'Pink',fc:'#e880a8'}
    ];
    // Use theme colours if they have distinct values, else use fallback
    var _seen={};var _distinct=_themeColours.filter(function(c){if(!c||!c.fc||_seen[c.fc])return false;_seen[c.fc]=true;return true;});
    var colours=_distinct.length>=3?_distinct:_fallback;
        // build swatches — proven data-attr pattern (same as original ntIconColourSwatches)
    var sw='';
    colours.forEach(function(col){
      var isOn=col.fc===activeColour;var isFree=col.fc===textColour;
      sw+='<div data-li="'+lineIdx+'" data-fc="'+col.fc+'" data-nm="'+(col.n||'')+'" onclick="ntPopupSwClick(this)" title="'+(col.n||'')+(isFree?' (free)':' +₹500')+'" style="width:26px;height:26px;border-radius:50%;border:2px solid '+(isOn?'#3d2b1a':'rgba(0,0,0,0.1)')+';background:'+col.fc+';cursor:pointer;box-sizing:border-box;transform:'+(isOn?'scale(1.2)':'scale(1)')+';transition:transform .15s;'+(col.lt?'box-shadow:inset 0 0 0 1px rgba(0,0,0,0.15);':'')+'">'+
        (isOn?'<span style="color:'+(col.lt?'#3d2b1a':'#fff')+';font-size:9px;font-weight:700;line-height:24px;display:block;text-align:center;">✓</span>':'​')+
        '</div>';
    });
    // delegation handler attached after innerHTML is set — see container onclick below

    var isCustom=!!curIcCol&&curIcCol!==textColour;
    var priceMsg=isCustom
      ? '<span style="color:#c47a45;font-weight:800;background:#fff3e6;border:1px solid #e8c09a;border-radius:6px;padding:1px 6px;">+₹500</span> for a different colour'
      : 'Same as text colour · <span style="font-weight:700;">no extra charge</span>';

    // POSITION row — mirror section rules: center only when 2+ words
    var wordCount=(lineText||'').trim().split(/\s+/).filter(Boolean).length;
    var sides=wordCount>=2?[['left','← Left'],['center','· Center'],['right','Right →']]:[['left','← Left'],['right','Right →']];
    var curSide=opt.iconSide||'left';
    if(curSide==='center'&&wordCount<2)curSide='left';
    var posBtns=sides.map(function(s){
      var on=curSide===s[0];
      return '<div onclick="ntPopupSetSide('+lineIdx+",'"+s[0]+"')\" style=\"flex:1;padding:9px 4px;border:1.5px solid "+(on?'#c47a45':'#e8d5c0')+";border-radius:9px;background:"+(on?'#c47a45':'#fff')+";text-align:center;font-size:11px;font-weight:700;color:"+(on?'#fff':'#3d2b1a')+";cursor:pointer;\">"+s[1]+"</div>";
    }).join('');

    body=''
      +'<div style="font-size:9px;font-weight:700;color:#8c7b6e;letter-spacing:.06em;text-transform:uppercase;margin:'+(showIcons?'4px':'2px')+' 0 8px;">Icon colour</div>'
      +'<div style="display:flex;gap:7px;flex-wrap:wrap;align-items:center;">'+sw+'</div>'
      +'<div style="font-size:10px;color:#8c7b6e;margin-top:8px;line-height:1.4;">'+priceMsg+'</div>'
      +'<div style="font-size:9px;font-weight:700;color:#8c7b6e;letter-spacing:.06em;text-transform:uppercase;margin:14px 0 8px;">Align icon</div>'
      +'<div style="display:flex;gap:7px;">'+posBtns+'</div>'
      +'<div style="font-size:9px;font-weight:700;color:#8c7b6e;letter-spacing:.06em;text-transform:uppercase;margin:14px 0 8px;">Rotate & Reflect</div>'
      +'<div style="display:flex;gap:7px;align-items:center;">'
        +'<div onclick="ntPopupRotate('+lineIdx+',-1)" style="flex:1;padding:9px 4px;border:1.5px solid #e8d5c0;border-radius:9px;background:#fff;text-align:center;font-size:16px;cursor:pointer;" title="Rotate left 5°">&#8634;</div>'
        +'<div style="text-align:center;min-width:36px;font-family:\'Poppins\',sans-serif;font-weight:700;font-size:13px;color:#3d2b1a;">'+((opt.iconRotation||0)+'°')+'</div>'
        +'<div onclick="ntPopupRotate('+lineIdx+',1)" style="flex:1;padding:9px 4px;border:1.5px solid #e8d5c0;border-radius:9px;background:#fff;text-align:center;font-size:16px;cursor:pointer;" title="Rotate right 5°">&#8635;</div>'
        +'<div onclick="ntPopupReflect('+lineIdx+')" style="flex:1;padding:9px 4px;border:1.5px solid '+(opt.iconFlip?'#c47a45':'#e8d5c0')+';border-radius:9px;background:'+(opt.iconFlip?'#fff8f3':'#fff')+';text-align:center;font-size:13px;font-weight:700;color:'+(opt.iconFlip?'#c47a45':'#8c7b6e')+';cursor:pointer;" title="Reflect horizontally">\u21d4 Flip</div>'
      +'</div>'
      +'<div style="display:flex;align-items:center;justify-content:space-between;margin-top:16px;">'
        +'<span onclick="ntPopupRemoveIcon('+lineIdx+')" style="font-size:11px;color:#c0392b;cursor:pointer;text-decoration:underline;">✕ Remove icon</span>'
        +'<button onclick="ntIconPopupClose()" style="background:var(--orange,#c47a45);color:#fff;border:none;border-radius:22px;padding:11px 26px;font-weight:700;font-size:13px;cursor:pointer;font-family:\'DM Sans\',sans-serif;">Done ✓</button>'
      +'</div>';
  } else {
    body='<div style="font-size:11px;color:#8c7b6e;text-align:center;padding:6px 0 4px;">Pick an icon for this line</div>';
  }

  var headerSub=hasIcon
    ? '<div onclick="ntIconPopupToggleIcons()" style="font-size:11px;font-weight:700;color:#c47a45;background:#fff3e6;border-radius:8px;padding:2px 8px;margin-top:4px;display:inline-block;cursor:pointer;">'+(window._ntIconPopupShowIcons?'▲ close icons':'↻ tap to change icon')+'</div>'
    : '<div style="font-size:11px;color:#8c7b6e;margin-top:2px;">choosing an icon…</div>';
  var headThumb=hasIcon
    ? '<img src="'+src+'" style="width:30px;height:30px;object-fit:contain;filter:'+ntIconFilter(activeColour||'#3d2b1a')+';" alt="">'
    : '<span style="font-size:20px;color:#bba98f;">★</span>';

  var pop=document.createElement('div');pop.id='ntIconPopup';
  var _bg=document.getElementById('s4Bg');
  var _slEl=document.getElementById('ntSl');
  var _bgR=_bg?_bg.getBoundingClientRect():{bottom:260};
  var _slR=_slEl?_slEl.getBoundingClientRect():{left:0,right:window.innerWidth,width:window.innerWidth,bottom:window.innerHeight};
  var _popTop=Math.max(40,Math.min(Math.round(_bgR.bottom)+2,window.innerHeight-200));
  var _popMaxH=Math.max(160,Math.round(Math.min(_slR.bottom,window.innerHeight))-_popTop);
  pop.style.cssText='position:fixed;left:'+Math.round(_slR.left)+'px;width:'+Math.round(_slR.width)+'px;top:'+_popTop+'px;max-height:'+_popMaxH+'px;overflow-y:auto;z-index:2147483600;background:#fff;border-top:2px solid #e8d5c0;box-shadow:0 8px 32px rgba(0,0,0,0.2);';
  var _mountEl=document.body;
  pop.onclick=function(e){if(e.target===pop)window.ntIconPopupClose();};
  pop.innerHTML='<div style="padding:14px 16px 18px;font-family:\'DM Sans\',sans-serif;">'
    +'<div style="display:flex;align-items:center;gap:11px;margin-bottom:14px;">'
      +'<div style="width:44px;height:44px;border-radius:11px;border:1.5px solid #e8d5c0;background:#fff;display:flex;align-items:center;justify-content:center;flex-shrink:0;">'+headThumb+'</div>'
      +'<div style="flex:1;"><div style="font-family:\'Poppins\',sans-serif;font-weight:700;font-size:14px;color:#3d2b1a;">Line '+(lineIdx+1)+(lineText?' · "'+(lineText.length>16?lineText.slice(0,16)+'…':lineText)+'"':'')+'</div>'+headerSub+'</div>'
      +'<div onclick="ntIconPopupClose()" style="width:30px;height:30px;border-radius:50%;background:#f3ece3;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:16px;color:#3d2b1a;flex-shrink:0;">✕</div>'
    +'</div>'
    +iconGrid
    +body
  +'</div>';
  // Backdrop covers only the area below the canvas
  var _bd=document.createElement('div');
  _bd.id='ntIconPopupBd';
  _bd.style.cssText='position:fixed;left:'+Math.round(_slR.left)+'px;width:'+Math.round(_slR.width)+'px;top:'+_popTop+'px;bottom:0;z-index:2147483599;background:rgba(36,22,8,0.55);';
  _bd.onclick=function(){window.ntIconPopupClose();};
  _mountEl.appendChild(_bd);
  _mountEl.appendChild(pop);
  pop._bd=_bd;
  // Show dim above popup (below canvas)
  var _dimEl2=document.getElementById('ntPopupDim');
  var _bgForDim2=document.getElementById('s4Bg');
  var _bgBot2=_bgForDim2?Math.round(_bgForDim2.getBoundingClientRect().bottom)+2:200;
  var _slForDim2=document.getElementById('ntSl');
  var _slR3=_slForDim2?_slForDim2.getBoundingClientRect():{left:0,width:window.innerWidth};
  if(!_dimEl2){_dimEl2=document.createElement('div');_dimEl2.id='ntPopupDim';document.body.appendChild(_dimEl2);}
  _dimEl2.style.cssText='position:fixed;left:'+Math.round(_slR3.left)+'px;width:'+Math.round(_slR3.width)+'px;top:'+_bgBot2+'px;bottom:0;background:rgba(0,0,0,0.35);z-index:2147483599;pointer-events:none;';
  _dimEl2.style.display='block';
}
window.ntRenderIconPopup=ntRenderIconPopup;
function ntIconColourSwatches(lineIdx){
  // Colour picker hidden — managed via per-line pills below global colour row
  return '';
}

window.ntStripPickIcon=function(el,prefix){
  var src=el.getAttribute('data-src');
  var lbl=el.getAttribute('data-label')||ntIconLabel&&ntIconLabel(src)||src.split('/').pop().split('?')[0].replace(/\.[^.]+$/,'');
  if(prefix==='line'){
    window._ntStripSelIcon=src;window._ntLineStripShowGrid=false;
    var li=(window._ntLineStripLine||1)-1;
    var _nloP=curLines.length;
    if(li<_nloP){
      if(!window.s4LineOpts[li])window.s4LineOpts[li]={};
      window.s4LineOpts[li].iconKey=src;window.s4LineOpts[li].iconLabel=lbl;
      window.s4LineOpts[li].iconSide=window._ntLineStripPos||'left';
      window.s4LineOpts[li].iconRotation=window._ntLineStripRot||0;
    } else {
      var niP=li-_nloP;
      if(!window.s4NameLineOpts)window.s4NameLineOpts=[];
      while(window.s4NameLineOpts.length<=niP)window.s4NameLineOpts.push({});
      window.s4NameLineOpts[niP].iconKey=src;window.s4NameLineOpts[niP].iconLabel=lbl;
      window.s4NameLineOpts[niP].iconSide=window._ntLineStripPos||'left';
      window.s4NameLineOpts[niP].iconRotation=window._ntLineStripRot||0;
    }
    renderS4();try{renderS4SizeBar();}catch(e){}
  } else {
    window._ntLetterStripIcon=src;window._ntLetterStripShowGrid=false;
    var _prevIL=window.ntLetterIcon||{};
    window.ntLetterIcon={active:true,letter:'',line:window._ntLetterStripLine||0,charIdx:0,iconSrc:src,iconLabel:'',
      px:_prevIL.px!=null?_prevIL.px:50,py:_prevIL.py!=null?_prevIL.py:15,
      rotation:window._ntLetterStripRot||0};
    if(typeof renderS4==='function')renderS4();
    if(typeof ntRefreshIconLetterRow==='function')ntRefreshIconLetterRow();
  }
  // Rebuild to show selected state + options (grid collapses automatically)
  ntRenderIconStrips();
};
window.ntStripSetPos=function(p){
  window._ntLineStripPos=p;
  var li=(window._ntLineStripLine||1)-1;
  var _nlo=curLines.length;
  if(li<_nlo){
    if(window.s4LineOpts&&window.s4LineOpts[li]){window.s4LineOpts[li].iconSide=p;renderS4();}
  } else {
    var ni=li-_nlo;
    if(!window.s4NameLineOpts)window.s4NameLineOpts=[];
    while(window.s4NameLineOpts.length<=ni)window.s4NameLineOpts.push({});
    window.s4NameLineOpts[ni].iconSide=p;renderS4();
  }
  ntRenderIconStrips();
};
window.ntStripRot=function(prefix,delta){
  if(prefix==='line'){
    window._ntLineStripRot=Math.max(-180,Math.min(180,(window._ntLineStripRot||0)+delta));
    var li=(window._ntLineStripLine||1)-1;
    var _nlo=curLines.length;
    if(li<_nlo){
      if(window.s4LineOpts&&window.s4LineOpts[li]){window.s4LineOpts[li].iconRotation=window._ntLineStripRot;renderS4();}
    } else {
      var ni=li-_nlo;
      if(!window.s4NameLineOpts)window.s4NameLineOpts=[];
      while(window.s4NameLineOpts.length<=ni)window.s4NameLineOpts.push({});
      window.s4NameLineOpts[ni].iconRotation=window._ntLineStripRot;renderS4();
    }
  } else {
    window._ntLetterStripRot=Math.max(-180,Math.min(180,(window._ntLetterStripRot||0)+delta));
    if(window.ntLetterIcon)window.ntLetterIcon.rotation=window._ntLetterStripRot;
    if(typeof renderS4==='function')renderS4();
  }
  ntRenderIconStrips();
};
window.ntLineStripRemove=function(){
  var li=(window._ntLineStripLine||1)-1;
  if(li>=0&&window.s4LineOpts&&window.s4LineOpts[li]){
    delete window.s4LineOpts[li].iconKey;delete window.s4LineOpts[li].iconSide;delete window.s4LineOpts[li].iconRotation;
    renderS4();try{renderS4SizeBar();}catch(e){}
  }
  window._ntStripSelIcon='';window._ntLineStripOpen=false;window._ntLineStripStep=0;
  window._ntLineStripLine=curLines.length===1?1:0;window._ntLineStripShowGrid=false;
  ntRenderIconStrips();
};
window.ntLetterStripRemove=function(){
  window.ntLetterIcon={active:false,letter:'',line:0,charIdx:0,iconSrc:'',iconLabel:''};
  window._ntLetterStripIcon='';window._ntLetterStripOpen=false;window._ntLetterStripShowGrid=false;
  if(typeof renderS4==='function')renderS4();
  if(typeof ntRefreshIconLetterRow==='function')ntRefreshIconLetterRow();
  ntRenderIconStrips();
};
window.ntRenderIconStrips=ntRenderIconStrips;

window.pc3 = pc3;
window.pc4 = pc4;
window.initS4 = initS4;
window.renderS4 = renderS4;
window.goPersonal = goPersonal;
window.goMantra = goMantra;
window.showSt = showSt;
window.calcSizePrice = calcSizePrice;
window.renderS4LineChips = renderS4LineChips;
window.renderS4SizeBar = renderS4SizeBar;
window.renderC4 = renderC4;
window.adjustSizeS4 = adjustSizeS4;
// Stub for removed function — called by initS4
function ntShowAddIconBtn(){ /* icon add button — handled via ntILRow999/S4 */ }

// NT_CUSTOM_ICONS — set by nukkad-customiser-section.liquid before this script loads
// Retry once in case of race condition on slow connections
window.NT_CUSTOM_ICONS = window.NT_CUSTOM_ICONS || [];
setTimeout(function(){
  if(!window.NT_CUSTOM_ICONS.length&&window._NT_ICONS_PENDING){
    window.NT_CUSTOM_ICONS=window._NT_ICONS_PENDING;
  }
},1000);
window.adjustSize = adjustSize;
window.toggleDesigner = toggleDesigner;
window.mantraResizeDelta = mantraResizeDelta;
window.mantraQtyDelta = mantraQtyDelta;
window.mantraAddLine = mantraAddLine;
window.setMantraFont = setMantraFont;
window.setFont = setFont;
window.setFont4 = setFont4;
window.adjustQty = adjustQty;
window.adjustQtyS4 = adjustQtyS4;
window.s4GoBackToQuote = s4GoBackToQuote;
window.s4FocusName = s4FocusName;
window.designerState = designerState;

// ── EXPOSE IIFE-SCOPED STATE VIA GETTERS ───────────────
// curLines, customSizeOverride, mantraLines etc. live inside the IIFE.
// The slider liquid functions (ntCommissionPersonal etc.) need them via window.
Object.defineProperty(window, 'curLines', {
  get: function(){ return curLines; },
  set: function(v){ curLines = v; },
  configurable: true
});
Object.defineProperty(window, 'customSizeOverride', {
  get: function(){ return customSizeOverride; },
  set: function(v){ customSizeOverride = v; },
  configurable: true
});
Object.defineProperty(window, 'isNamed', {
  get: function(){ return isNamed; },
  set: function(v){ isNamed = v; },
  configurable: true
});
Object.defineProperty(window, 'mantraLines', {
  get: function(){ return mantraLines; },
  configurable: true
});
Object.defineProperty(window, 'mantraCurInch', {
  get: function(){ return mantraCurInch; },
  configurable: true
});
Object.defineProperty(window, 'mantraQtyVal', {
  get: function(){ return mantraQtyVal; },
  configurable: true
});

})();

// ── APPLY DELIVERY + FAQ FROM CONFIG ─────────────────
function ntApplyBottomSection(){
  var cfg = window.NUKKAD_CONFIG || {};

  // Delivery
  var dd = document.getElementById('ntDeliveryDays');
  if(dd && cfg.deliveryDays) dd.textContent = cfg.deliveryDays;
  var ds = document.getElementById('ntDeliverySub');
  if(ds && cfg.deliverySub) ds.textContent = cfg.deliverySub;

  // FAQ
  var faqWrap = document.getElementById('ntFaqWrap');
  var faqItems = document.getElementById('ntFaqItems');
  var faqs = cfg.faq || [];
  if(faqWrap && faqItems && faqs.length){
    faqWrap.style.display = 'block';
    var openIdx = -1;
    faqItems.innerHTML = faqs.filter(function(f){ return f.q && f.a; }).map(function(f, i){
      return '<div style="background:#fff;border:1.5px solid #e8d5c0;border-radius:12px;margin-bottom:7px;overflow:hidden;">'
        +'<div onclick="ntToggleFaq('+i+')" style="display:flex;align-items:center;justify-content:space-between;padding:12px 14px;cursor:pointer;font-family:\'Poppins\',sans-serif;font-weight:700;font-size:11px;color:#3d2b1a;gap:8px;">'
        +f.q
        +'<span id="ntFaqIcon'+i+'" style="font-size:16px;color:#c47a45;transition:transform .25s;flex-shrink:0;font-weight:300;line-height:1;">+</span>'
        +'</div>'
        +'<div id="ntFaqAns'+i+'" style="max-height:0;overflow:hidden;transition:max-height .3s ease,padding .3s ease;font-size:10px;color:#8c7b6e;line-height:1.65;padding:0 14px;">'
        +f.a
        +'</div>'
        +'</div>';
    }).join('');
  }
}

window._ntFaqOpen = -1;
function ntToggleFaq(i){
  var prev = window._ntFaqOpen;
  if(prev >= 0 && prev !== i){
    var pa = document.getElementById('ntFaqAns'+prev);
    var pi = document.getElementById('ntFaqIcon'+prev);
    if(pa){ pa.style.maxHeight='0'; pa.style.padding='0 14px'; }
    if(pi){ pi.style.transform=''; pi.textContent='+'; }
  }
  var a = document.getElementById('ntFaqAns'+i);
  var ic = document.getElementById('ntFaqIcon'+i);
  var isOpen = (prev === i);
  if(isOpen){
    if(a){ a.style.maxHeight='0'; a.style.padding='0 14px'; }
    if(ic){ ic.style.transform=''; ic.textContent='+'; }
    window._ntFaqOpen = -1;
  } else {
    if(a){ a.style.maxHeight='200px'; a.style.padding='0 14px 13px'; }
    if(ic){ ic.style.transform='rotate(45deg)'; ic.textContent='+'; }
    window._ntFaqOpen = i;
  }
}

// Call after config is applied
setTimeout(ntApplyBottomSection, 600);